import React from "react";

export const englishTranslation = {
  'Mon profil': 'My profile',
  Déconnexion: 'Logout',
  'Tableau de bord': 'Dashboard',
  'Contenus de la commande': 'Order content',
  'Commandes non attribuées': 'Orders not attributed',
  'Commandes en cours': 'Orders in progress',
  'Commandes en retard': 'Overdue orders',
  'Commandes validées': 'Validated orders',
  'Non attribuées': 'Not attributed',
  'En cours': 'In progress',
  'En retard': 'Overdue',
  Validées: 'Validated',
  Rechercher: 'Search',
  'Mes Projets': 'My projects',
  'Titre de la commande': 'Order heading',
  'Textes livrés': 'Delivered',
  'Textes validés': 'Validated',
  'Nouveau texte': 'New text',
  'Nom du texte': 'Name of the text',
  'Mots clés': 'Mots clés',
  URL: 'URL',
  'Balise titre': 'Title tag',
  'Balise meta-description': 'Meta tag',
  'Détails du texte': 'Text details',
  Étape: 'Step',
  '(Titre, mot clé, url, balise, méta-description)':
    '(title, keyword, url, title and meta tag)',
  'ajouter un texte': 'ajouter un texte',
  'Séparer les mots clés par un "enter"':
    'Séparer les mots clés par un "enter"',
  'mot-clé': 'keyword',
  'Télécharger le document': 'Download the document',
  'Mots clés manquants': 'Missing keywords',
  'Ajout de mots-clé avec la fréquence restante':
    'Remaining keword frequencies',
  'Résultat sémantique': 'Semantic result',
  'Enrichissement sémantique': 'semantic enrichment',
  'Insérez votre gap sémantique avec l’occurrence':
    'Insert your semantic gap with the occurrence',
  'Coller le texte initial dans le champs ci-dessous':
    'Paste the initial content in the field below',
  optionel: 'Only for optimization',
  'Ajouter ou compléter ci-dessous votre contenu':
    'Add or complete the content below',
  'Analyses restantes': 'Remaining analysis',
  'Nombre total de mots (existants et ajoutés)':
    'Total number of words (existing and new)',
  'Nombre de mot à ajouter': 'Number of words to add',
  'Nombre total de mots ajoutés': 'Total number of added words',
  Sauvegarder: 'Save',
  'Enregistrer et informer client': 'Save and inform client',
  'Soumettre un nouveau texte': 'Submit a new text',
  'Bon pour livraison': 'Ready for delivery',
  Comparer: 'Compare',
  Analyser: 'Analyse',
  Brouillon: 'Draft',
  'Il semblerait que tu n’aies plus de crédit d’analyse':
    "Looks like you're out of scan credit",
  'Ce champ est obligatoire': 'This field is required',
  'Êtes vous sur de vouloir sauvegarder le texte':
    'Are you sure you want to save the text',
  'Veuillez changer les informations suivantes titre et/ou mot clé':
    'Please change the following information: title and/or keyword',
  "Une erreur s'est produite": 'An error has occurred',
  'Veuillez corriger le format de votre gap sémantique afin de pouvoir sauvegarder le texte en brouillon':
    'Please correct the format of your semantic gap in order to be able to save the text in draft',
  'Veuillez ajouter un texte initiale afin de pouvoir sauvegarder le texte en brouillon':
    'Please add an initial text in order to be able to save the text in draft',
  'Veuillez ajouter une url afin de pouvoir sauvegarder le texte en brouillon':
    'Please add a url so that you can save the draft text',
  'Le texte': 'The text',
  'a été mis en brouillon': 'has been drafted',
  'Le texte a été mis en brouillon': 'The text has been drafted',
  'Le texte a été livré avec succès': 'The text was delivered successfully',
  'Modification effectuée avec succès': 'Change made successfully',
  "La demande d'ajout de crédit est envoyée":
    'The request to add credit is sent',
  'La commande a été supprimé avec succès':
    'The order was successfully deleted',
  'Voulez-vous vraiment supprimer la commande de':
    'Are you sure you want to delete The order',
  'Voulez-vous vraiment supprimer la ligne de commande pour':
    'Are you sure you want to delete the order distribution for',
  'Voulez-vous vraiment supprimer  le texte?':
    'Are you sure you want to delete the text?',
  Postuler: 'Apply',
  Postulé: 'applied',
  Supprimer: 'Delete',
  'Typix - Mon profil': 'Typix - My profile',
  'Votre profil a été mis à jour avec succès.':
    'Your profile has been successfully updated.',
  "Une erreur s'est produite. Veuillez vérifier votre saisie ou essayer plus tard.":
    'An error has occurred. ',
  'Ce champs est obligatoire': 'This field is required',
  Prénom: 'First name',
  'E-mail': 'E-mail',
  'Ce champs est obligatoire et ne peut avoir que des nombres':
    'This field is mandatory and can only have numbers',
  'Mot de passe': 'Password',
  'doit comprendre au moins 8 charactères': 'must be at least 8 characters',
  'au moins une lettre minuscule et une lettre majuscule,un caractère spécial et un chiffre':
    'at least one lowercase letter and one uppercase letter, one special character and one number',
  'ne doit pas inclure votre nom/prénom':
    'must not include your first/last name',
  'Confirmer le mot de passe': 'Confirm password',
  'Les deux mots de passe ne sonts pas identiques':
    'The two passwords are not identical',
  'Avoir au moins 8 caractères avec une lettre majuscule, un chiffre, un symbole et ne pas être identique au nom.':
    'At least 8 characters including 1 upper case letter, one number, a symbol and different from the name',
  'Typix - Nouvelle commande': 'Typix - New order',
  'La commande pour le client': 'The order for the client',
  'a été ajouté avec succès': 'was successfully added',
  'Le titre de la commande existe déjà': 'Order title already exists',
  "Oups....! Une erreur s'est produite": 'Whoops....! ',
  'Nouvelle commande': 'New order',
  'Réf devis': 'Quote reference',
  'Tâche - id tâche': 'Task - task ID',
  'Intitulé de la commande': 'Order heading',
  'URL du site': 'Website URL',
  'Nombre de textes': 'Number of texts',
  'Tarif au mot': 'price/word',
  Consultant: 'Consultant',
  'Contact edito': 'Editorial project manager ',
  'Coût d’achat max/mot': 'cost/word max',
  'Rédacteur attribué': 'Assigned Writer',
  'Ce champs doit être sup à 0 et inférieur à 1':
    'This field must be greater than 0 and less than 1',
  'Ce champs doit être sup à 0': 'This field must be greater than 0',
  'Nb textes': 'Number of texts',
  ' Vous avez ': ' You have ',
  ' textes en plus': ' more texts',
  ' Min': ' Min',
  'Max doit être sup à Min': 'Max must be greater than Min',
  Max: 'Max',
  'Nombre de mots par texte': 'Number of words per text',
  "Ce champs doit être sup à 0 car facturation n'est pas au réel":
    'This field must be greater than 0 because invoicing is not real',
  'Facturation au réel': 'Billing at cost',
  'Brief détaillé': 'Detailed brief',
  'Gap sémantique': 'Semantic gap',
  Documentation: 'Documentation',
  'Champs obligatoires': 'Required fields',
  'à cocher si le nombre de mots est différent par texte':
    'to be checked if the number of words is different per text',
  'Lien drive...': 'Drive link...',
  'Le contrat pour le client': 'The contract for the client',
  'a été créé avec succès': 'was created successfully',
  'Contrat déjà existant, veuillez modifier les informations':
    'Existing contract, please modify the information',
  'Nouveau client': 'New client',
  'Prénom / Nom du client': 'Client full name',
  'Fiche du site web ': 'Website Details',
  'Compte client': 'Client account',
  'Url du site': 'Website URL',
  'Nb de textes par Silo': 'Number of texts per Silo',
  'Nombre de FAQ': 'Number of Q&A',
  'Nombre de GMB': 'Number of GMB',
  'Nombre de Silo': 'Number of silo',
  'Nb de textes à optimiser': 'Number of texts to optimize',
  'Thématiques d’expertise': 'Fields of expertise',
  'Typix - Créer rédacteur': 'Typix - Create Writer',
  'Le rédacteur ': 'The writer ',
  'Fiche du rédacteur': "Writer's sheet",
  'Ajouter un rédacteur': 'Add a writer',
  Mail: 'Email',
  Adresse: 'Address',
  Société: 'Company',
  'Analyse/Limite': 'Analysis/Limit',
  'Prénom/Nom': 'Full name',
  Téléphone: 'Phone',
  Thématiques: 'Topics',
  'Note rédacteur': "Writer's level",
  Global: 'Global',
  Deadline: 'Deadline',
  Rédacteurs: 'Writers',
  'Afficher les résultats': 'Display results',
  Afficher: 'Display',
  '0 rédacteurs': '0 writers',
  'Typix - Mon tableau de bord': 'Typix - My Dashboard',
  'Le contrat de': 'The contract of',
  'a été supprimé avec succès': 'has been successfully deleted',
  "il y'a des commandes liés au site web ":
    'there are orders linked to the website ',
  'Liste des clients': 'Clients listing',
  Nom: 'Last name',
  'Nom client': 'Name',
  Commandes: 'Orders',
  Éditer: 'Edit',
  'non attribuées': 'unassigned',
  'en cours': 'in progress',
  'en retard': 'late',
  validées: 'validated',
  'Voulez-vous vraiment supprimer le contrat de':
    'Are you sure you want to delete the contract from',
  'Temps restant': 'Remaining time',
  'Nb de textes': 'Number of texts',
  'Nb total de textes': 'Total number of texts',
  'Nb de mots': 'Number of words',
  'Au réel': 'At cost',
  'Nb mots/texte': 'Nb words/text',
  Prix: 'Price',
  Textes: 'Texts',
  Validation: 'Validation',
  'Votre décision a été prise en compte avec succès':
    'Your decision has been successfully taken into account',
  'Détail de la commande': 'Order details',
  'Détail ligne de commande': 'Order distribution ',
  Historique: 'History',
  'Typix - Détails de la commande': 'Typix - Order Details',
  'Contenu de la commande': 'Command content',
  'Contenu disponible': 'Available contents',
  Noir: 'Black',
  Orange: 'Orange',
  Violet: 'Violet',
  Vert: 'Green',
  'contenu en attente de vérification client':
    'content awaiting client verification',
  'contenu en attente de repasse rédacteur': 'content awaiting editor review',
  'contenu repassé, en attente validation client':
    'content re-made, awaiting client validation',
  'contenu validé par le client': 'content validated by the client',
  'Tout télécharger': 'Download all',
  'Ajouter un texte': 'Add a text',
  Traduction: 'Translation',
  'Tous les textes': 'All texts',
  'Textes revisés': 'Reviewed texts',
  'Révision en attente': 'Pending review',
  Brouillons: 'Drafts',
  'Titre du texte': 'Text heading',
  "Date d'ajout": 'Publication date',
  'Édité par le client': 'Client edited',
  'Révision demandée': 'Client asked for a review',
  Validé: 'Validated',
  'résultats sur': 'results over',
  Précédent: 'Previous',
  Suivant: 'Next',
  Oui: 'Yes',
  Non: 'No',
  'Intitulé commande': 'Order title',
  'Nombre de mots gérés': 'Number of words managed',
  'Min/Max': 'Min/Max',
  'Nombre de mots rédigés': 'Number of words written',
  'Status texte': 'status text',
  'Date de livraison': 'Delivery date',
  Score: 'Score',
  'Mots clés & URL': 'Keywords & URL',
  Ajout: 'Added',
  'Mise à jour': 'Updated',
  Status: 'Status',
  Actions: 'Actions',
  'Date deadline validation client': 'Client validation deadline',
  'Date de validation': 'Validation date',
  'Liste des commandes': 'Orders Listing',
  "Vous avez la possibilité d'exporter le rapport d'une, ou de plusieurs commandes. Pour exporter toutes les commandes d'un client, il vous suffit juste de cliquer sur l'icône de téléchargement en jaune":
    'You have the option of exporting the report of one or more orders. ',
  'Typix - Détails du texte': 'Typix - Text Details',
  'Le texte initial de': 'The original text of',
  'a été activé': 'has been activated',
  'a été livré avec succès': 'has been delivered successfully',
  'Mot clé': 'Keyword',
  'Format souhaité': 'Desired format',
  'mot-clé (fréquence)': 'keyword (frequency)',
  'Séparez les mots-clés par un Enter .':
    'Separate the keywords with an "Enter".',
  'keyword1 (2)\nkeyword2 (1)\nkeyword3 (1)\nkeyword4 (2)\n…': 'keyword1 (2)\n',
  'Ajout de mots-clés avec la fréquence restante':
    'Addition of keywords with the remaining frequency',
  'Mots clés restants': 'Remaining keywords',
  Langue: 'Language',
  Langues: 'Languages',
  Disponibilité: 'Availability',
  'ID rédacteur': 'Writer ID',
  Réactiver: 'Reactivate',
  'Ajouter ou compléter ci-dessous votre contenu :':
    'Add or complete your content below:',
  'Nombre total de mots (existants et ajoutés) :':
    'Total number of words (existing and new):',
  'Nombre de mot à ajouter (Min/Max) : ': 'Number of words to add (Min/Max): ',
  'Nombre total de mots ajoutés :': 'Total number of words added:',
  Rôle: 'Role',
  Modifier: 'Edit',
  Désactiver: 'Deactivate',
  'Ajouter un admin': 'Add an admin',
  'Ajouter un consultant': 'Add a consultant',
  'Ajouter un client': 'Add client',
  'Tous les rôles': 'All roles',
  Admins: 'admins',
  Clients: 'Clients',
  Consultants: 'Consultants',
  'Typix - Gestion des utilisateurs': 'Typix - User Management',
  'Gestion des utilisateurs': 'User Management',
  'Rechercher par mail, prénom, nom, site...':
    'Search by email, first name, last name, website...',
  'Typix - Fiche site web': 'Typix - Website details',
  "il y'a des commandes liés à au site web":
    'there are orders linked to the website',
  'Fiche du site web': 'Website details',
  'Prénom/Nom du client': "Client's first name/last name",
  'Mail client': 'Client email',
  'Détail de la prestation du contenu': 'Details of content delivery',
  'Voir les commandes': 'See orders',
  'Typix - Fiche rédacteur': "Typix - Editor's sheet",
  'Vous ne pouvez pas supprimer le rédacteur': 'You cannot delete the editor',
  'car celui-ci a déjà rédigé des textes':
    'because he has already written texts',
  'Voulez-vous vraiment supprimer le rédacteur':
    'Are you sure you want to delete the editor',
  disponible: 'available',
  indisponible: 'unavailable',
  'Exporter .csv': 'Export .csv',
  'listeRedacteur-': 'WritersList-',
  Notifications: 'Notifications',
  'nouvelles notifications': 'new notifications',
  'Vous avez': 'You have',
  'textes livrés en attente de validation':
    'texts delivered awaiting validation',
  'révisions effectuées en attentes de validation':
    'completed revisions awaiting validation',
  'commandes prête': 'orders ready',
  'Toutes les notifications': 'All notices',
  'Révisions effectués': 'Revisions made',
  'Typix - Mon Profile': 'Typix - My Profile',
  'Le texte a été enregistré avec succès':
    'The text has been saved successfully',
  'La traduction a été enregistrée avec succès':
    'The translation has been successfully saved',
  'Texte + Traduction enregistré avec succès':
    'Text + Translation has been successfully saved',
  'Le texte a été validé avec succès':
    'The text has been validated successfully',
  'Gap sémantique :': 'Semantic gap:',
  'Séparez les mots-clés par un " Enter ".':
    'Separate the keywords with an "Enter".',
  'Valider le texte': 'Validate the text',
  'Demander une révision': 'Request a review',
  'Demander une repasse globale': 'Request a global review',
  'Mes Commandes': 'My orders',
  rédacteurs: 'writers',
  Site: 'Website',
  'Export en cours de téléchargement…': 'Export in progress...',
  "Pas d'options": 'No options',
  "Un utilisateur existe déjà avec l'email":
    'A user already exists with the email',
  "L'admin": 'The admin',
  'Le consultant': 'The consultant',
  'Le client': 'The client',
  'Le rédacteur': 'The writer',
  "l'admin": 'the admin',
  'le consultant': 'the consultant',
  'le client': 'the client',
  'le rédacteur': 'the writer',
  'La fiche du website': 'The website details',
  'a été mis à jour avec succès': 'has been updated successfully',
  'Votre candidature a bien été envoyée':
    'Your application has been sent successfully',
  'Postuler à la commande': 'Apply for order',
  'Livraison estimé au': 'Estimated delivery at',
  Annuler: 'Cancel',
  Confirmer: 'Confirm',
  'Vous êtes sûr': 'Are you sure',
  'Demander des crédits': 'Apply for credits',
  'Félicitations !': 'Congratulations !',
  'un email contenant un lien de réinitialisation du mot de passe a été envoyé à votre email':
    'an email containing a password reset link has been sent to your email',
  'vérifiez votre email et cliquez sur le lien pour continuer !':
    'check your email and click the link to continue!',
  "cet email n'existe pas": 'this email does not exist',
  'Réinitialiser votre mot de passe': 'Reset your password',
  Réinitialiser: 'Reset',
  Envoyer: 'Send',
  Ou: 'Or',
  'Veuillez donner un descriptif au document téléchargé':
    'Please give a description of the uploaded file',
  'Votre demande de révision a bien été envoyée.':
    'Your review request has been sent.',
  'Veuillez saisir un texte ou importer un fichier.':
    'Please enter text or import a file.',
  'Demande de révision': 'Request for review',
  "Merci d'indiquer ci-dessous vos demandes de modifications en prenant bien en compte nos conditions de repasses":
    'Please indicate below your requests for modifications, taking into account our reviewing conditions',
  'Dans le cadre d’une repasse sur des contenus, seuls les éléments suivants seront pris en charge':
    'As part of a review of content, only the following elements will be supported',
  'Si des phrases ne sont pas dans un français correct':
    'If sentences are not grammatically correct',
  'importer un document': 'import a document',
  'le contenu présente des inexactitudes': 'If the content has inaccuracies',
  'Si le contenu ne respecte pas les règles du brief':
    'If the content does not respect the rules of the brief',
  'Votre text ne de doit pas dépasser 500 mots':
    'Your text should not exceed 500 words',
  'Les demandes suivantes ne seront pas prises en compte':
    'The following requests will not be considered',
  'Coquilles (double espace, « s »…)': 'Shells (double space, “s”…)',
  'Expressions ou phrases françaises mais ne vous convenant pas':
    'English expressions or sentenses that do not suit you',
  'Toute demande n’ayant pas été précisée lors du brief':
    'Any request that was not specified during the brief',
  'Pour ajouter un nouveau texte': 'To add new text',
  "Pour ajouter un texte (optimisation d'un contenu existant)":
    'To add text (optimizing existing content)',
  'Nombre de Jours': 'Number of days',
  'délai dépassé': 'missed deadline',
  'Livraison estimée': 'Estimated delivery',
  'Modifier l’admin': 'Edit admin',
  'Modifier le client': 'Edit client',
  'Modifier le rédacteur': 'Edit Writer',
  'Modifier le consultant': 'Edit Consultant',
  'Oups...!il y a une/plusieurs erreur(s) dans la fenêtre du gap sémantique. Veuillez vérifier son contenu pour la/les corriger et soumettre à nouveau votre texte.':
    'Oops...! there is/are error(s) in the semantic gap window. Please check its contents to correct it/them and resubmit your text.',
  'Voulez-vous vraiment supprimer': 'Are you sure you want to delete',
  "est le seul client pour un site, il faut ajouter d'autres pour pouvoir le supprimer":
    'is the only client for a site, you must add others to be able to delete it',
  'ne peut pas être supprimé car il est lié à des sites web':
    'cannot be deleted because it is linked to websites',
  'ne peut pas être supprimé pour le moment': 'cannot be deleted at this time',
  "L'utilisateur": 'The user',
  'Voulez-vous vraiment désactiver': 'Are you sure you want to deactivate',
  'Voulez-vous vraiment activer': 'Do you really want to activate',
  'a été désactivé avec succès': 'has been deactivated successfully',
  'a été activé avec succès': 'has been successfully activated',
  Utilisateurs: 'Users',
  "Le nombre de texte de la commande ne peut pas être inférieur aux nombre de textes attribuées au(x) rédacteur(s). Veuillez d'abord modifier les informations de la ligne de commande":
    'The number of texts in the order cannot be less than the number of texts attributed to the editor(s). ',
  'La commande a été mis à jour avec succès !':
    'The order was successfully updated!',
  "Cette commande n'existe pas": 'This order does not exist',
  'Mail rédacteurs': 'Writer Email',
  'Chef edito': 'chief editor',
  'Min.': 'Min.',
  'Max.': 'Max.',
  Consignes: 'Instructions',
  Rédaction: 'Writing',
  'La ligne de commande pour': 'The order distribution for',
  'Cette ligne de commande ne peut pas être supprimée car une partie de ses textes a été livré':
    'This command line cannot be deleted because part of its texts has been delivered',
  'Les lignes de commandes ont été mises à jour avec succès !':
    'The order distributionS have been successfully updated!',
  'Mise à jour non autorisée car des textes ont été livrés':
    'Update not allowed because texts have been delivered',
  'Ce champs doit être sup ou égale nombre de texte':
    'This field must be greater than or equal to number of text',
  'livré et inférieur au nombre de texte non affecté':
    'delivered and less than the number of unassigned text',
  'Nombre de textes restants': 'Number of remaining texts',
  'Nombre de textes ajoutés': 'Number of texts added',
  "Nombre d'agents": 'Number of agents',
  voir: 'see',
  'Le texte a été supprimé avec succès': 'The text was successfully deleted',
  'Recherche par rédacteur ou texte': 'Search by author or text',
  'Mail envoyé': 'E-mail sent',
  Date: 'Date',
  'Liste des rédacteurs': 'Writers list',
  'Chercher un rédacteur': 'Find a writer',
  'rédacteurs trouvés': 'Writers found',
  'Ce champ est obligatoire et doit être inférieur ou égal au Nombre total des textes  de la commande':
    'This field is mandatory and must be less than or equal to the Total number of order texts',
  'Ce champ est obligatoire doit être supérieur à 0':
    'This field is required must be greater than 0',
  'Doit être inférieur au nombre maximum':
    'Must be less than the maximum number',
  "La date doit être ultérieure à aujourd'hui.":
    'The date must be later than today.',
  'Veuillez fournir une date valide': 'Please provide a valid date',
  'Veuillez préciser la date': 'Please specify the date',
  'email invalide': 'invalid email',
  'Numéro invalide': 'Invalid number',
  'Avoir au moins 8 caractères avec une lettre majuscule, un chiffre, un charactère spécial':
    'Have at least 8 characters with a capital letter, a number, a special character',
  'Ne doit pas contenir votre nom': 'Must not contain your name',
  'Le mot de passe de confirmation ne correspond pas':
    'Confirmation password does not match',
  Compte: 'Account',
  'Nb de silo par texte': 'Number of silo per text',
  'Nb de FAQ': 'Number of Q&A',
  'Nb de GMB': 'Number of GMB',
  'Nb de Silo': 'Number of Silo',
  'Détail de la prestation': 'Content invoice detail',
  'Avoir au moins 8 caractères avec une lettre majuscule, un chiffre, un charactère spécial et ne pas être identique au nom':
    'Have at least 8 characters with a capital letter, a number, a special character and not be identical to the name',
  'Contenu rédigé': 'Written content',
  'Ne plus afficher ce message': 'Do not show this message again',
  'Mail clients': 'Client Email',
  'Notes rédacteurs': "Writer's grade",
  'Tarif/Mot': 'Price/Word',
  'Min/Max mots': 'Min/Max words',
  Livrés: 'Delivered',
  Validés: 'Validated ',
  'Coût d’achat': 'Purchase cost',
  'Total facturé': 'Total billed',
  'Rechercher un rédacteur': 'Find a writer',
  'Rechercher par nom ou email': 'Search by name or email',
  'Nom/prénom': 'Full Name',
  Contacter: 'Contact',
  Notes: 'Rating',
  email: 'email',
  'mot de passe oublié': 'forgotten password',
  'Veuillez saisir des champs valides': 'Please enter valid fields',
  'Mot de passe incorrect': 'Wrong password',
  "Une erreur s'est produite, veuillez réessayer":
    'An error has occurred, please try again',
  "L'émail": 'The e-mail',
  "n'existe pas": 'does not exist',
  'Réinitialiser  votre mot de passe': 'reset password',
  'Mot de passe mis à jour avec succès': 'Password updated successfully',
  'Ce mot de passe est le mot de passe que vous avez oublié':
    'This password is the one you have already forgotten',
  'Les données fournies sont invalides': 'The data provided is invalid',
  'Votre demande a expirée .. veuillez refaire une autre':
    'Your request has expired...please make another one',
  'Confirmer le nouveau mot de passe': 'Confirm new password',
  'Mettez des mots-clés avec fréquence': 'Set keywords with frequency',
  'Mettez votre texte': 'Put your text',
  Autres: 'Other',
  rédacteur: 'writer',
  Différence: 'Difference',
  'Comparaison hors ligne': 'Offline comparison',
  Heures: 'Hours',
  Titre: 'Title',
  'Nombre de mots': 'Number of words',
  Texte: 'Text',
  Résultats: 'Results',
  Beauté: 'Beauty',
  'Tourisme/Loisirs': 'Tourism/Leisure',
  Voyage: 'Travel',
  'Immo/Defisc': 'Real Estate/Tax',
  Automobile: 'Auto',
  'Maison/Déco': 'Home/Decor',
  Technologie: 'Technology',
  Actualités: 'News',
  Art: 'Art',
  Associations: 'Associations',
  'Banque/Assurance': 'Banking/Insurance',
  'Business/Management': 'Business/Management',
  Commerce: 'Business',
  Droit: 'Law',
  Emploi: 'Employment',
  'Energie/Environnement': 'Energy/Environment',
  'Enfant/Puéri': 'Children/Parents',
  Enseignement: 'Education',
  Entreprise: 'Company',
  Finance: 'Finance',
  'Grande distribution': 'Large-scale distribution',
  Humanitaire: 'Humanitarian',
  Institutions: 'Institutions',
  Internet: 'Internet',
  Jeux: 'Games',
  Literie: 'Bedding',
  Mode: 'Fashion',
  Musique: 'Music',
  Outillage: 'Tools',
  Perso: 'Personal',
  Polyvalent: 'Polyvalent',
  Regional: 'Regional',
  'Santé/Bien-être': 'Health/Wellness',
  Sciences: 'Science',
  Services: 'Services',
  Societe: 'Company',
  Sortir: 'Go out',
  Sport: 'Sports',
  Téléphonie: 'Telephony',
  Transport: 'Transport',
  'Travaux/BTP': 'Works/BTP',
  Webmaster: 'Webmaster',
  Cuisine: 'Cooking',
  'Vos demandes': 'Your requests',
  'Importer un autre document': 'Import another document',
  Exemple: 'Example',
  Français: 'French',
  Anglais: 'English',
  Espagnol: 'Spanish',
  Italien: 'Italian',
  Allemand: 'German',
  Afar: 'Afar',
  Abkhazien: 'Abkhazian',
  Avestan: 'Avestan',
  Afrikaans: 'Afrikaans',
  Akan: 'Akan',
  Amharique: 'Amharic',
  Aragonais: 'Aragonese',
  Arabe: 'Arabic',
  Assamais: 'Assamese',
  Avaric: 'Avaric',
  Aymara: 'Aymara',
  Azerbaïdjanais: 'Azerbaijani',
  Bashkir: 'Bashkir',
  Biélorusse: 'Belarusian',
  Bulgare: 'Bulgarian',
  'Langues bihari': 'Bihari languages',
  Bislama: 'Bislama',
  Bambara: 'Bambara',
  Bengali: 'Bengali',
  Tibétain: 'Tibetan',
  Breton: 'Breton',
  Bosniaque: 'Bosnian',
  'Catalan ; Valencien': 'Catalan; Valencian',
  Tchétchène: 'Chechen',
  Chamorro: 'Chamorro',
  Corse: 'Corsican',
  Cree: 'Cree',
  Czech: 'Czech',
  'Slave ecclésiastique ; vieux slavon ; slavon ecclésiastique ; vieux bulgare ; vieux slavon ecclésiastique':
    'Church Slavic; Old Slavonic; Church Slavonic; Old Bulgarian; Old Church Slavonic',
  Tchouvache: 'Chuvash',
  Welsh: 'Welsh',
  Danois: 'Danish',
  'Divehi ; Dhivehi ; Maldivien': 'Divehi; Dhivehi; Maldivian',
  Dzongkha: 'Dzongkha',
  Ewe: 'Ewe',
  'Grec moderne (1453-)': 'Greek, Modern (1453-)',
  Grec: 'Greek',
  Estonien: 'Estonian',
  Basque: 'Basque',
  Persan: 'Persian',
  Fulah: 'Fulah',
  Finnois: 'Finnish',
  Fidjien: 'Fijian',
  Féroïen: 'Faroese',
  'Frison occidental': 'Western Frisian',
  Irlandais: 'Irish',
  Gaélique: 'Scottish Gaelic',
  Galicien: 'Galician',
  Guarani: 'Guarani',
  Gujarati: 'Gujarati',
  Manx: 'Manx',
  Hausa: 'Hausa',
  Hébreu: 'Hebrew',
  Hindi: 'Hindi',
  'Hiri Motu': 'Hiri Motu',
  Croate: 'Croatian',
  'Haïtien ; créole haïtien': 'Haitian Creole',
  Hongrois: 'Hungarian',
  Arménien: 'Armenian',
  Herero: 'Herero',
  'Interlingua (Association internationale des langues auxiliaires)':
    'Interlingua (International Auxiliary Language Association)',
  Indonésien: 'Indonesian',
  'Interlingue ; Occidental': 'Interlingue (Occidental)',
  Igbo: 'Igbo',
  'Sichuan Yi ; Nuosu': 'Sichuan Yi (Nuosu)',
  Inupiaq: 'Inupiaq',
  Ido: 'Ido',
  Islandais: 'Icelandic',
  Inuktitut: 'Inuktitut',
  Japonais: 'Japanese',
  Javanais: 'Javanese',
  Géorgien: 'Georgian',
  Kongo: 'Kongo',
  'Kikuyu ; Gikuyu': 'Kikuyu (Gikuyu)',
  'Kuanyama ; Kwanyama': 'Kwanyama (Kuanyama)',
  Kazakh: 'Kazakh',
  'Kalaallisut ; Groenlandais': 'Greenlandic (Kalaallisut)',
  'Khmer central': 'Khmer (Central)',
  Kannada: 'Kannada',
  Coréen: 'Korean',
  Kanuri: 'Kanuri',
  Kashmiri: 'Kashmiri',
  Kurde: 'Kurdish',
  Komi: 'Komi',
  Cornouailles: 'Cornish',
  'Kirghiz ; Kirghiz': 'Kyrgyz (Kyrgyzstan)',
  Latin: 'Latin',
  'Luxembourgeois ; Letzeburgesch': 'Luxembourgish (Letzeburgesch)',
  Ganda: 'Ganda',
  'Limburgan ; Limburger ; Limburgish': 'Limburgish',
  Lingala: 'Lingala',
  Lao: 'Lao',
  Lituanien: 'Lithuanian',
  'Luba-Katanga': 'Luba-Katanga',
  Letton: 'Latvian',
  Malgache: 'Malagasy',
  Marshallais: 'Marshallese',
  Maori: 'Māori',
  Macédonien: 'Macedonian',
  Malayalam: 'Malayalam',
  Mongolien: 'Mongolian',
  Marathi: 'Marathi',
  Malay: 'Malay',
  Maltais: 'Maltese',
  Birmane: 'Burmese',
  Nauru: 'Nauruan',
  'Bokmål, norvégien ; Bokmål norvégien': 'Norwegian Bokmål',
  'Ndebele, Nord ; Ndebele Nord': 'Northern Ndebele',
  Népalais: 'Nepali',
  Ndonga: 'Ndonga',
  'Hollandais ; Flamand': 'Dutch (Flemish)',
  Néerlandais: 'Dutch',
  'Nynorsk norvégien': 'Norwegian Nynorsk',
  Norvégien: 'Norwegian',
  'Ndebele, South ; South Ndebele': 'South Ndebele',
  'Navajo ; Navaho': 'Navajo',
  'Chichewa ; Chewa ; Nyanja': 'Chichewa',
  'Occitan (post 1500)': 'Occitan',
  Ojibwa: 'Ojibwe',
  Oromo: 'Oromo',
  Oriya: 'Oriya',
  'Ossétien ; Ossétique': 'Ossetian',
  'Panjabi ; Punjabi': 'Punjabi',
  Pali: 'Pali',
  Polish: 'Polish',
  'Pushto ; Pashto': 'Pashto',
  Portugais: 'Portuguese',
  Quechua: 'Quechua',
  Romanche: 'Romansh',
  Rundi: 'Rundi',
  'Roumain ; Moldave ; Moldovan': 'Romanian',
  Roumain: 'Romanian',
  Russe: 'Russian',
  Kinyarwanda: 'Kinyarwanda',
  Sanskrit: 'Sanskrit',
  Sarde: 'Sardinian',
  Sindhi: 'Sindhi',
  'Sami du Nord': 'Northern Sami',
  Sango: 'Sango',
  'Sinhala ; Cingalais': 'Sinhala',
  Slovaque: 'Slovak',
  Slovène: 'Slovenian',
  Samoan: 'Samoan',
  Shona: 'Shona',
  Somali: 'Somali',
  Albanais: 'Albanian',
  Serbe: 'Serbian',
  Swati: 'Swati',
  'Sotho, Southern': 'Southern Sotho',
  Sundanese: 'Sundanese',
  Suédois: 'Swedish',
  Swahili: 'Swahili',
  Tamil: 'Tamil',
  Telugu: 'Telugu',
  Tadjik: 'Tajik',
  Thai: 'Thai',
  Tigrinya: 'Tigrinya',
  Turkmène: 'Turkmen',
  Tagalog: 'Tagalog',
  Tswana: 'Tswana',
  'Tonga (Îles Tonga)': 'Tongan',
  Turc: 'Turkish',
  Tsonga: 'Tsonga',
  Tatar: 'Tatar',
  Twi: 'Twi',
  Tahitien: 'Tahitian',
  'Uighur ; Uyghur': 'Uighur',
  Ukrainien: 'Ukrainian',
  Urdu: 'Urdu',
  Uzbek: 'Uzbek',
  Venda: 'Venda',
  Vietnamien: 'Vietnamese',
  Volapük: 'Volapük',
  Wallon: 'Walloon',
  Wolof: 'Wolof',
  Xhosa: 'Xhosa',
  Yiddish: 'Yiddish',
  Yoruba: 'Yoruba',
  'Zhuang ; Chuang': 'Zhuang ; Chuang',
  Chinois: 'Chinese',
  Zoulou: 'Zulu',
  'Commandes intelligentes': 'Smart orders',
  'Commandes avec révision': 'Review + smart orders',
  'Type de contenu': 'Content type',
  'Fiche produit': 'Product page',
  GMB: 'GMB',
  'STORE LOCATOR': 'STORE LOCATOR',
  'Rédaction premium': 'Premium writing',
  'Rédaction avec révision': 'Smart + review writing',
  'Rédaction intelligente': 'Smart writing',
  PREMIUM: 'PREMIUM',
  Type: 'Type',
  Editer: 'Edit',
  'Tous les types': 'All types',
  Smart: 'Smart',
  'Smart + review': 'Smart + review',
  'Factures traitées': 'Processed invoices',
  'Factures à valider': 'Invoices to validate',
  'Impossible de générer la facture ! Veuillez réessayer':
    'Unable to generate the invoice! Please try again',
  'Récapitulatif de facturation': 'Billing summary',
  'Demander une modification': 'Request a modification',
  'Valider et envoyer la facture': 'Validate and send the invoice',
  'Demande de modification': 'Modification request',
  'La facture a été validé avec succès!':
    'The invoice has been successfully validated!',
  "Oups un erreur c'est produit!": 'Oops, an error occurred!',
  'Nombre de texte': 'Number of texts',
  'Nombre de mot par texte :': 'Number of words per text:',
  Paiement: 'Payment',
  Virement: 'Bank transfer',
  Délai: 'Deadline',
  'Référence de votre facture': 'Your invoice reference',
  'Coût au mot': 'Cost per word',
  'Montant global de la commande': 'Total amount of the order',
  'Votre facture': 'Your invoice',
  'Importer votre facture': 'Import your invoice',
  'Pas de fichier disponible': 'No file available',
  Télécharger: 'Download',
  Relancer: 'Resend',
  'Générer la facture': 'Generate the invoice',

  Payée: 'Paid',
  'En cours de paiement': 'Payment in progress',
  'En cours de validation': 'Validation in progress',
  'A envoyer': 'To be sent',
  'Modification demandée': 'Modification requested',
  'Référence de facture est obligatoire': 'Invoice reference is required',
  'Le coût au mot doit être un nombre': 'The cost per word must be a number',
  'Le coût au mot doit être un nombre positif':
    'The cost per word must be a positive number',
  'Le coût au mot est obligatoire': 'The cost per word is required',
  'Le montant global de la commande doit être un nombre':
    'The total amount of the order must be a number',
  'Le montant global de la commande doit être un nombre positif':
    'The total amount of the order must be a positive number',
  'Le montant global de la commande est obligatoire':
    'The total amount of the order is required',
  'Bill reference existe déja , veuillez réessayer':
    'Bill reference already exists, please try again',
  'La facture a été envoyée avec succès!':
    'The invoice has been successfully sent!',

  'Montant estimé': 'Estimated amount',
  Action: 'Action',
  Facture: 'Invoice',
  Statut: 'Status',
  Factures: 'Invoices',
  'Valider la facture': 'Validate the invoice',
  'La relance a été envoyée avec succès !':
    'The reminder has been successfully sent!',
  'La demande de modification a été envoyée avec succès !':
    'The modification request has been successfully sent!',
  'Le cout est trop élevé': 'The cost is too high',
  'Le montant global de la commande est trop élevé ':
    'The total amount of the order is too high',
  jours: 'days',
  'Factures à envoyer': 'Invoices to send',
  'Valider le paiement': 'Validate payment',

  'Générer une facture': 'Generate an invoice',
  'Montant rédacteur': "Writer's amount",
  'Montant estimé par Typix': 'Estimated amount by Typix',
  'Voir la modification': 'View modification',

  'Tag de Titre': 'Title Tag',
  'Meta description': 'Meta Description',
  'Nom du produit': 'Product Name',
  Avantages: 'Benefits',
  'Description détaillée': 'Detailed Description',
  'En cours de modification': 'Under modification',
  'Mes Factures': 'My invoices',
  'En attente de validation': 'Awaiting validation',
  'les valeurs négatives ne sont pas autorisées':
    'The negative values are not allowed.',
  'Texte Seulement': 'Text Only',
  'Traduction Seulement': 'Translation Only',
  'La relance peut être faite 20 jours après la soumissions de la facture':
    'The reminder can be sent 20 days after invoice submission',
  Instructions: 'Instructions',
  'Votre avis pour la commande': 'Your feedback for the order',
  'Votre évaluation est précieuse pour nous ! Merci !':
    'Your evaluation is valuable to us! Thank you!',
  "Une erreur s'est produite lors de la soumission de votre évaluation. Veuillez réessayer ultérieurement!":
    'An error occurred while submitting your evaluation. Please try again later!',
  Evaluer: 'Evaluate',
  Commentaire: 'Comment',
  'Votre commantaire': 'Your comment',
  Note: 'Rating',
  'Votre retour est précieux pour nous et nous aide à améliorer nos services.':
    'Your feedback is valuable to us and helps us improve our services.',
  'Verifier la facture': 'Verify the invoice',

  ' Votre retour est précieux pour nous et nous aide à améliorer nos services. Merci de partager votre évaluation avec nous!':
    'Your feedback is valuable to us and helps us improve our services. Thank you for sharing your evaluation with us!',
  'Notes rédacteur': "Writer's notes",
  'Avis client': 'Customer review',
  'Pas de commantaire': 'No comments',
  "Qu'avez vous pensé de votre commande?": 'What did you think of your order?',
  'Evaluation de la commande': 'Order evaluation',
  'Rédiger un commentaire': 'Write a comment',
  'Contribuez à nous permettre de vous proposer les services de rédaction de la plus haute qualité en partageant vos commentaires.':
    'Contribute to enabling us to offer you the highest quality writing services by sharing your feedback.',
  'Que pouvons-nous améliorer?': 'What can we improve?',
  Continuer: 'Continue',
  'Le dernier texte a été validé avec succès':
    'The last text has been successfully validated',
  'Rechercher par rédacteur, commandes, et montant':
    'Search by writer, orders, and amount',
  obligatoire: 'required',
  'Note admin': 'Admin note',
  'Note client': 'Customer note',
  Partie: 'Part',
  'Vous venez de valider tous les contenus rédigés par ':
    'You have just validated all the content written by ',
  "Qu'en avez vous pensé": 'What did you think about it',
  'La facture a été générée avec succès !':
    'The invoice has been generated successfully!',
  'La taille du titre et/ou la méta-description est trop courte':
    'The title and/or meta-description length is too short',
  'Demande de révision globale': 'Request a global review',
  Valider: 'Validate',
  'Obligatoire en cas d’optimisation ou traduction':
    'Required in case of optimization or translation',
  'Mots clés Bourrées': 'Keyword stuffing',
  'Votre commentaire...': 'Your comment...',
  'Ex : "Contenus de très bonne qualité': 'E.g: "Very good quality content"',
  "pouvez-vous s'il vous plaît reprendre ce/tte rédacteur/rice pour les prochaines commandes?":
    'Can you please assign this writer for future orders?',
  'Ce bouton est pour informer le client que le texte initial, contenait déjà du keyword stuffing':
    'This button is to inform the client that the original text already contained keyword stuffing',
  'Maillage Interne': 'Internal link',
  'Modifier le texte': 'Edit the text',
  Ajouter: 'Add',
  'Demande examen': 'Request examination',
  'Recherche de mots clés à haute densité': 'Keyword stuffing research',
  'Oups, il semblerait qu’il y ait du keyword stuffing dans votre texte : ':
    'Oops, it appears that there is keyword stuffing in your text: ',
  'Oups, il semblerait qu’il y ait du keyword stuffing (trop d’occurrences d’un ou plusieurs mots clés) dans le texte initial.':
    'Oops, it appears that there is keyword stuffing (too many occurrences of one or more keywords) in the original text.',
  'Merci de vous assurer que la densité des mots clés soit optimisée pour le SEO (une occurrence maximum tous les 50 mots).':
    'Please ensure that keyword density is optimized for SEO (a maximum of one occurrence every 50 words).',
  'Pour cela merci de ne pas retoucher le texte existant et de bien vouloir envoyer une demande d’examen au support.':
    'For this, please do not edit the existing text and kindly send an examination request to support.',
  'Votre demande a été bien envoyée !':
    'Your request has been successfully sent!',
  "Il y a eu un problème lors de l'envoi de votre demande":
    'There was a problem sending your request.',
  'Veuillez attendez pour le  keyword Stuffing analyse':
    'Please wait for the keyword stuffing analysis.',
  'Inserez le maillage interne': 'Insert the internal linking',
  'Merci de vous assurer que la densité des mots clés soit optimisée pour le SEO (une occurrence maximum tous les 50 mots).\nSi vous constatez un terme pouvant avoir plusieurs significations (Exemple : Former / Formation/ Forme ou Matelas/Matelassé) , vous pouvez faire une demande d’examen auprès du support.':
    'Please ensure that keyword density is optimized for SEO (maximum one occurrence every 50 words).\nIf you come across a term that can have multiple meanings (Example: Former / Formation / Form or Matelas / Quilted), you can request a review from support.',
  'Mots clés à haute densité dans le texte actuel':
    'High-density keywords in the current text',
  'Mots clés à haute densité dans le texte initial':
    'High-density keywords in the initial text',
  'Texte en cours de rédaction !': 'Text in progress !',
  'Êtes-vous sûr(e) de vouloir valider le texte ? Assurez-vous d’abord d’avoir enregistré les modifications.':
    'Are you sure you want to validate the text? First, make sure you have saved the changes.',
  "Information dernière minute ! Ton stock de crédits sera bientôt épuisé :( Pour anticiper, n'hésite pas à demander dès maintenant plus de crédits pour terminer ta commande.":
    'Last-minute information! Your credit balance will soon be depleted :( To anticipate, feel free to request more credits now to complete your order.',
  'Voulez-vous confirmer l’URL actuelle ou la modifier ?':
    'Do you want to confirm the current URL or change it?',
  'Veuillez fournir une URL valide': 'Please provide a valid URL.',
  'Merci de bien vouloir indiquer ci-dessous l’url de la page où a été intégré le contenu:':
    'Please kindly provide the URL of the page where the content has been integrated below:',
  'Contenu en ligne': 'Online content',
  'Télécharger le document de révision': 'Download the revision document',
  'Date d’envoi': 'Date of sending',
  Information: 'Information',
  Enregistrer: 'Save',
  'Textes en ligne': 'Online',
  'Livrer les textes': 'Deliver the texts',
  Indisponible: 'Unavailable',
  Disponible: 'Available',
  'Les textes ont été livrés avec succès.':
    'The texts have been delivered successfully.',
  'Le texte a été livré avec succès.':
    'The text has been delivered successfully.',
  ' Les textes ont été validés avec succès.':
    'The texts have been successfully validated.',
  'Le texte a été validé avec succès.':
    'The text has been successfully validated.',
  'Voulez-vous vraiment valider les Textes de la commande':
    'Do you really want to validate the order texts?',
  'Voulez-vous vraiment livrer les Textes de la commande':
    'Do you really want to deliver the order texts?',
  'Fiche produit longue': 'Long product page',
  'Fiche produit courte': 'Short product page',
  'Un texte est trop long et ne peut pas être exporté sur Excel':
    'A text is too long and cannot be exported to Excel.',
  'Mettre un texte en brouillon en livré':
    'Change a text from draft to delivered',
  'Remettre un texte validé à livré': 'Change a validated text to delivered',
  'Invalider le texte': 'Invalidate the text',
  'Je souhaiterai modifier mon mot de passe : comment faire ?':
    'I would like to change my password: how do I do it?',
  'Comment mettre un contenu en bon pour livraison ?':
    'How to set content ready for delivery?',
  'Je ne peux pas mettre mon contenu en « brouillon »':
    'I cannot save my content as "draft"',
  'Typix n’a pas enregistré mes dernières modifications':
    'Typix did not save my latest changes',
  'Comment rédiger une création de contenu ?': 'How to write content creation?',
  'Comment rédiger une optimisation de contenu ?':
    'How to write content optimization?',
  'Je ne vois plus ma commande – que faire ?':
    'I no longer see my order – what to do?',
  'Comment générer une facture ?': 'How to generate an invoice?',
  'Je ne peux pas generer ma facture : que faire ?':
    'I cannot generate my invoice: what to do?',
  'Tuto process Typix global': 'Global Typix process - tutorial',
  'Tuto mise en ligne des contenus': 'How to upload content - tutorial',
  'Modification mot de passe': 'Password change',
  'Comment valider un contenu dans Typix ?':
    'How to validate content in Typix?',
  'Tuto Facturation': 'Billing tutorial',
  'Le test ne me convient pas': 'The test does not suit me',
  'Le statut du contenu a bien été modifié':
    'The status of the content has been successfully modified',
  'Le gap sémantique de ce mot clé n’a pas encore été validé, veuillez contacter le support Typix : support-typix@pixalione.com':
    'The semantic gap of this keyword has not yet been validated. Please contact Typix support: support-typix@pixalione.com',
  'Ce mot clé n’existe pas sur MONETORING, veuillez vérifier avec le support Typix : support-typix@pixalione.com':
    'This keyword does not exist on MONETORING, please check with Typix support: support-typix@pixalione.com',
  "Ce mot clé n'existe pas sur AQISIS, veuillez vérifier avec le support Typix : support-typix@pixalione.com":
    'This keyword does not exist on AQISIS. Please check with Typix support: support-typix@pixalione.com',
  "Ce siteweb n'existe pas sur AQISIS, veuillez vérifier avec le support Typix : support-typix@pixalione.com":
    'This website does not exist on AQISIS. Please check with Typix support: support-typix@pixalione.com',
  'Question (headkey) introuvable pour ce mot-clé/URL sur AQISIS. Veuillez vérifier avec le support Typix : support-typix@pixalione.com':
    'Question (headkey) not found for this keyword/URL on AQISIS. Please check with Typix support: support-typix@pixalione.com',
  "Plusieurs pages d'atterrissage ont été trouvées pour ce mot-clé. Veuillez préciser l'URL de la page.":
    'Several landing pages were found for this keyword. Please specify the page URL.',
  'Impossible de se connecter à la base de données AQISIS. Veuillez réessayer.':
    'Unable to connect to the AQISIS database. Please try again.',
  'Récupérer le Gap': 'Retrieve the Gap',
  'Le test ne me convient pas': 'The test does not suit me',
  'Le statut du contenu a bien été modifié':
    'The status of the content has been successfully modified',
  'Le gap sémantique de ce mot clé n’a pas encore été validé, veuillez contacter le support Typix : support-typix@pixalione.com':
    'The semantic gap of this keyword has not yet been validated. Please contact Typix support: support-typix@pixalione.com',
  'Ce mot clé n’existe pas sur MONETORING, veuillez vérifier avec le support Typix : support-typix@pixalione.com':
    'This keyword does not exist on MONETORING, please check with Typix support: support-typix@pixalione.com',
  "Ce mot clé n'existe pas sur AQISIS, veuillez vérifier avec le support Typix : support-typix@pixalione.com":
    'This keyword does not exist on AQISIS. Please check with Typix support: support-typix@pixalione.com',
  "Ce siteweb n'existe pas sur AQISIS, veuillez vérifier avec le support Typix : support-typix@pixalione.com":
    'This website does not exist on AQISIS. Please check with Typix support: support-typix@pixalione.com',
  'Question (headkey) introuvable pour ce mot-clé/URL sur AQISIS. Veuillez vérifier avec le support Typix : support-typix@pixalione.com':
    'Question (headkey) not found for this keyword/URL on AQISIS. Please check with Typix support: support-typix@pixalione.com',
  "Plusieurs pages d'atterrissage ont été trouvées pour ce mot-clé. Veuillez préciser l'URL de la page.":
    'Several landing pages were found for this keyword. Please specify the page URL.',
  'Impossible de se connecter à la base de données AQISIS. Veuillez réessayer.':
    'Unable to connect to the AQISIS database. Please try again.',
  'Récupérer le Gap': 'Retrieve the Gap',
  'Traduction premium': 'Premium translation',
  'Rédaction et/ou Traduction premium': 'Premium writing and/or translation',
  'Rédaction et/ou Traduction premium': 'Premium writing and/or translation',
  'Rédaction et/ou Traduction avec révision':
    'Writing and/or Translation with revision',
  'Rédaction et/ou Traduction intelligente': 'Smart writing and/or translation',
  'Traduction avec révision': ' Smart + review translation ',
  'Traduction intelligente': 'Smart translation',
  'Le nombre de mots commandé est supérieur à celui vendu':
    'The number of texts ordered is greater than those sold',
  'Rédaction et/ou Traduction premium': 'Premium writing and/or translation',
  'Rédaction et/ou Traduction smart + review':
    'Smart writing and/or translation + review',
  'Rédaction et/ou Traduction smart': 'Smart writing and/or translation',
  'Nom Silo': 'Silo Name',
  'textes en plus': 'additional text(s)',
  'Remettre en brouillon': 'Revert to draft',
  'Bon pour Livraison Vérifié': 'Ready for delivery (verified)',
  'Voulez-vous vraiment remettre en brouillon les Textes de la commande':
    'Are you sure you want to revert the texts to draft of the order',
  'La vérification du texte a été annulée.':
    'The text verification has been canceled.',
  'Content enrichment': 'Content enrichment',
  Category: 'Category',
  'Voulez-vous vraiment annuler la vérification du texte?':
    'Are you sure you want to cancel the text verification?',
  'Vérifié par Admin': 'Verified by Admin',
  'Etes-vous sûr(e) de vouloir regénérer tous les contenus ?':
    'Are you sure you want to regenerate all content?',
  'Je suis sûr(e)': 'I am sure',
  'Non, revenir en arrière': 'No, go back',
  'à cocher si la commande a l’intention d’avoir un rédacteur exclusif pour le client':
    'tick if the order intends to have an exclusive writer for the client',
  Gouvernance: 'Governance',
  'Modification à valider': 'Modification to be validated',
  Rédacteur: 'Writer',
  Vérifié: 'Verified',
  'a été vérifié avec succès': 'has been successfully verified',
  'Nouveau site web': 'New website',
  'Mail Chef Project': 'Project manager email',
  'Site web': 'Website',
  'Liste des siteweb': 'Website list',
  'Projets non attribuées': 'Unassigned projects',
  'Projets en cours': 'Ongoing projects',
  'Projets en retard': 'Overdue projects',
  'Projets validées': 'Validated projects',
  'Projets smart + reviews': 'Smart + review projects',
  'Projets smart': 'Smart projects',
  'Le site web': 'The website',
  'Bienvenue !': 'Welcome!',
  'Accédez à votre compte pour gérer vos contenus.':
    'Access your account to manage your content.',
  'Veuillez saisir votre adresse mail': 'Please enter your email address',
  'Entrez votre mot de passe': 'Enter your password',
  'Se connecter': 'Sign in',
  "Vous n'avez pas de compte ?": "You don't have an account ?",
  "Passez à l'action !": 'Get started!',
  'Inscrivez-vous gratuitement pour commencer.':
    'Register for free to get started.',
  'Accélérez votre stratégie': 'Accelerate your content',
  ' de contenu.': ' strategy.',
  'IA générative, optimisation SEO avancée et validation  ':
    'Generative AI, advanced SEO optimization and ',
  'humaine intégrées dans un seul workflow.':
    'human validation integrated into a single workflow.',
  'Créez un compte gratuitement pour commencer à gérer vos contenus.':
    'Create an account for free to start managing your content.',
  'a été modifié avec succès': 'has been successfully modified!',
  'Vous avez déjà un compte ?': 'You already have an account ?',
  'Connectez vous': 'Sign in',
  'Nom*': 'Last name*',
  'Prénom*': 'First name*',
  'Mot de passe*': 'Password*',
  Retour: 'Back',
  Suivant: 'Next',
  'Numéro de téléphone': 'Phone number',
  Société: 'Company',
  'Chargement...': 'Loading...',
  "S'inscrire": 'Register',
  "En poursuivant, vous acceptez les Conditions d'utilisation et la  Politique de confidentialité.":
    'By continuing, you accept the Terms of Use and the Privacy Policy.',
  'Confirmer le mot de passe*': 'Confirm password*',
  'Confirmez votre mot de passe': 'Confirm your password',
  'Mot de passe faible : au moins 8 caractères, une majuscule, une minuscule, un chiffre.':
    'Weak password: at least 8 characters, one uppercase, one lowercase, one number.',
  'Un compte avec cette adresse email existe déjà.':
    'An account with this email address already exists.',
  "Oups, il semble qu'un problème soit survenu lors de l'inscription. Veuillez réessayer.":
    'Oops, it seems a problem occurred during registration. Please try again.',
  'Inscription réussie ! 🎉': 'Registration successful! 🎉',
  'Un email de confirmation a été envoyé à votre adresse mail.':
    'An email confirmation has been sent to your email address.',
  'Veuillez cliquer sur le lien contenu dans le mail pour activer votre compte.':
    'Please click on the link contained in the email to activate your account.',
  'Ajouter un siteweb': 'Add a website',
  'Nouveau projet': 'New project',
  éditer: 'Edit',
  'Ajouter un chef de projet': 'Add a project manager',
  'Langues de rédaction': 'Writing languages',
  'Modifier le chef de project': 'Edit project manager',
  "Modifier l'admin": 'Edit admin',
  'Nom du projet': 'Project name',
  'Chef de projet': 'Project manager',
  'Rédaction et traduction': 'Writing + Translation',
  'Séléctionner le type de contenu': 'Select the content type',
  'Sélectionner un agent IA personnalisé': 'Select a personnalised IA agent',
  'Créer un agent IA personnalisé': 'Create a personnalised IA agent',
  'Liens utiles': 'Useful links',
  'Comparaison du score global': 'Comparison of global score',
  'avec le top 3 concurrents': 'with top 3 competitors',
  'Position du mot clé avec le top 3 concurrents': 'Keyword ranking',
  'Ouvrir la page': 'Open page',
  'Méta description': 'Meta description',
  Balises: 'Tags',
  Lisibilité: 'Readibility',
  'Longueur des paragraphes': 'Paragraph length',
  Phrases: 'Sentences',
  'de +100 mots sur': 'with + 100 words /',
  Phrase: 'Sentence',
  'de +20 mots sur': 'with + 20 words / ',
  'Notre recommandation': 'Our recommandation',
  'Longueur du texte': 'Text length',
  'Formats de contenus variés': 'Various Content Formats',
  'par rapport au top 3 de vos concurrents':
    'in comparison with your top 3 competitors',
  'Vous êtes': 'Your ranking is',
  'Vous avez un score global de': 'Your global score is',
  'pour une moyenne du secteur à': 'for an average of',
  'GAP comblé - Mission accomplie': 'All gaps filled – Mission accomplished',
  'Mots clé restants': 'Missed keywords',
  'Phrases de +20 mots': 'Sentenses with + 20 words',
  'Titre H1': 'H1 title',
  'Titres H2': 'H2 titles',
  'Dans le texte actuel': 'In actual text',
  'Dans le texte initial': 'In initial text',
  mots: 'words',
  objectif: 'target',
  'Temps de lecture': 'Target time',
  'requis ( Bullet point, Bon à savoir,Sommaire)':
    'Required (Bullet point, Did you know?, Summary)',
  'de contenu sur': 'under',
  'Félicitations ! Le nombre de mots correspond à la quantité d’informations importantes permettant de répondre au sujet':
    'Congratulations! The word count matches the amount of important information needed to answer the topic.',
  'Félicitations ! Votre contenu ne contient aucune phrase de plus de 20 mots !':
    'Congratulations! Your content does not contain any sentences longer than 20 words!',
  'Félicitations ! Votre contenu est aéré et facilite la lecture':
    'Congratulations! Your content is well-spaced and makes reading easier.',
  'Félicitations ! Votre contenu dispose de formats variés qui dynamisent la lecture et permettent d’isoler les informations importantes.':
    'Congratulations! Your content uses varied formats that make reading dynamic and helps highlight important information.',
  'Félicitations ! Le contenu présente une balise h1 unique et contient le mot clé à l’origine du texte':
    'Congratulations! The content has a unique h1 tag and contains the keyword that inspired the text.',
  'Félicitations ! Le contenu est structuré de façon cohérente et présente au moins 2 balises <h2>':
    'Congratulations! The content is structured coherently and has at least 2 <h2> tags.',
  'Félicitations ! Votre contenu contient du maillage interne pondéré et qui ne pollue pas la lecture.':
    'Congratulations! Your content contains balanced internal linking that does not disrupt the reading flow.',
  'Félicitations ! Le scoring d’enrichissement est supérieur à 85%!':
    'Congratulations! The enrichment score is higher than 85%!',
  'Félicitations ! Votre texte n’est pas suroptimisé sur le mot clé ciblé.':
    'Congratulations! Your text is not over-optimized for the targeted keyword.',
  'Le nombre de mots doit correspondre à la quantité d’informations importantes permettant de répondre au sujet':
    'The word count must match the amount of important information needed to answer the topic.',
  'Il est important d’adapter le niveau de vocabulaire en fonction de votre cible. Un vocabulaire simple pourrait l’infantiliser et, à l’inverse, un vocabulaire trop complexe pourrait rendre le contenu inaccessible.':
    'It is important to adapt the vocabulary level to your target audience. Too simple a vocabulary might infantilize them, while too complex a vocabulary could make the content inaccessible.',
  'Plus de 70% des internautes ne lisent pas les phrases > 20 mots => Utiliser des phrases concises pour augmenter le temps de rétention sur la page':
    'More than 70% of internet users do not read sentences longer than 20 words => Use concise sentences to increase page retention time.',
  "Un contenu constitué de blocs de paragraphes trop compact va altérer l'UX et augmenter le taux de rebond.":
    'Content made up of overly compact paragraph blocks will harm UX and increase bounce rate.',
  "Multipliez les différents formats d'affichage pour une lecture plus lisible et confortable.":
    'Use multiple display formats to make reading clearer and more comfortable.',
  'Un contenu optimisé doit obligatoirement contenir une seule balise h1 et mentionner le mot clé. ':
    'Optimized content must contain a single h1 tag and include the keyword.',
  'Pour une structure de contenu optimale, il faut au moins 2 balises h2.':
    'For optimal content structure, at least 2 h2 tags are required.',
  'Le maillage interne est un très bon moyen de connecter une page avec d’autres pages traitant du même sujet, ou complémentaires.':
    'Internal linking is a great way to connect a page with other pages on the same or related topics.',
  'Un contenu optimisé doit obtenir un scoring d’enrichissement de min 85%. Supprimer du gap sémantique altèrera le scoring d’optimisation':
    'Optimized content must achieve an enrichment score of at least 85%. Removing semantic depth will lower the optimization score.',
  'Répéter le mot trop de fois dans le contenu est pénalisant pour le moteur de recherche. Idéalement, ne pas dépasser un taux de 2.35% (soit environs 2 répétitions pour 100 mots). ':
    'Repeating the keyword too many times is penalized by search engines. Ideally, do not exceed a rate of 2.35% (about 2 repetitions per 100 words).',
  'Aucune balise H1 trouvée.': 'No H1 tag found.',
  'Balise H1 contient le mot-clé.': 'H1 tag contains the keyword.',
  'Balise H1 présente mais sans le mot-clé.':
    'H1 tag is present but does not contain the keyword.',
  '{{count_total}} balises H2 trouvées, {{count_with_kw}} avec mot-clé.':
    '{{count_total}} H2 tags found, {{count_with_kw}} containing the keyword.',
  ' balises H2 trouvées,': ' H2 tags found,',
  ' avec mot-clé.': ' containing the keyword.',
  'Très facile à lire : Accessible aux enfants ou à des personnes avec un niveau de lecture basique.':
    'Very easy to read: Accessible to children or people with a basic reading level.',

  'Facile à lire : Compréhensible par la majorité des adultes et adolescents.':
    'Easy to read: Understandable by most adults and teenagers.',

  'Difficile à lire : Nécessite un bon niveau de lecture, parfois un bagage académique':
    'Difficult to read: Requires a good reading level, sometimes an academic background.',

  'Très difficile à lire : Réservé à un public expert ou très averti':
    'Very difficult to read: Reserved for an expert or highly knowledgeable audience.',
  'Aucune balise H1 trouvée.': 'No H1 tag found.',
  'Balise H1 contient le mot-clé.': 'H1 tag contains the keyword.',
  'Balise H1 présente mais sans le mot-clé.':
    'H1 tag is present but does not contain the keyword.',
  '{{count_total}} balises H2 trouvées, {{count_with_kw}} avec mot-clé.':
    '{{count_total}} H2 tags found, {{count_with_kw}} containing the keyword.',
  ' balises H2 trouvées,': ' H2 tags found,',
  ' avec mot-clé.': ' containing the keyword.',
  'Wording adapté': 'Appropriate wording',
  'Une seule balise H1 avec le mot-clé est recommandée.':
    'Only one H1 tag with the keyword is recommended.',

  'Ajoutez le mot-clé dans la balise H1.': 'Add the keyword in the H1 tag.',

  'Adaptez votre vocabulaire à votre audience. Trop simple infantilise, trop complexe exclut.':
    'Adapt your vocabulary to your audience. Too simple infantilizes, too complex excludes.',

  'Les contenus web se lisent rapidement. Un temps trop long peut décourager.':
    'Web content is read quickly. Too much time can discourage readers.',

  'Information sur la structure': 'Information on the structure',

  'Information sur le résultat sémantique':
    'Information on the semantic result',

  'Information sur les balises HTML': 'Information on HTML tags',

  'Information sur le keyword stuffing': 'Information on keyword stuffing',

  Vous: 'Your website',
  'Fiches produit SEO': 'SEO Product page',
  'En ligne': 'Online',
  'En ligne...': 'Online...',
  Livré: 'Delivered',
  'Sélectionner un LLM': 'Select an LLM',
  'Enregistrement...': 'Saving...',
  'Enregistré': 'Saved',
  'Livrer': 'Deliver',
  'Livraison...': 'Delivering...',
  'Validation...': 'Validating...',
  'Lancer': 'Start',
  'Relancer': 'Restart',
  'Génération en cours...': 'Generation in progress...',
  'Génération en cours': 'Generation in progress',
  'La génération a échoué.': 'Generation failed.',
  'Veuillez vérifier vos données d’entrée et réessayer. Si le problème persiste, contactez le support.':
    'Please check your input data and try again. If the problem persists, contact support.',
  'Rédaction en cours...': 'Writing in progress...',
  'Une erreur est survenue lors de la rédaction.': 'An error occurred during writing.',
  'Vous avez atteint la limite de génération de texte par IA !': 'You have reached the limit for AI text generation!',
  'Une erreur est survenue lors de la vérification du crédit.': 'An error occurred while checking credit.',
  Actions: 'Actions',
  /////////
  'Derniers contenus rédigés': 'Latest written contents',
  'voir plus': 'See more',
  'texte': 'Text',
  'date d\'ajout': 'Added date',
  'titre du projet': 'Project title',
  'Date de création': 'Creation Date',
  'Derniers projets créés': 'Recently Added Projects ',
  '% projets par statut de validation :': 'Projects by Status (%)',
  'non attribués': 'Unassigned',
  'en cours': 'In progress',
  'en retard': 'Overdue',
  'validées': 'Validated',
  'smart + reviews': 'Smart + Reviews',
  'smart': 'Smart',
  'premium': 'Premium',
  'smart + review': 'Smart + Review',
  'Statut d\'avancement des contenus:': 'Content by Status (%)',
  'Nombre de textes publiés :': 'Published Texts',
  'Nb de textes publiés': 'No. of texts published',
  'Top ranked': 'Top Ranked',
  'Mot clé': 'Keyword',
  'Clicks': 'Clicks',
  'Clicks (Y-1)': 'Clicks (Y-1)',
  'Position': 'Position',
  'Sessions': 'Sessions',
  'Sessions (Y-1)': 'Sessions (Y-1)',
  'Evolution performance': 'Performance Evolution',
  'Pourcentage': 'Percentage',
  'Livré': 'Delivered',
  'Brouillon': 'Draft',
  'Publié': 'Published',
  'Suivez vos contenus et projets en temps réel': 'Get real-time insights into your content and projects.',
  'Tableau de bord': 'Dashboard',
  'Titre du projet': 'Project Title',
  'Conversions': 'Conversions',
  "La balise H1 est essentielle pour l'optimisation SEO.":
    'The H1 tag is essential for SEO optimization.',
  'Impressions': 'Impressions',
  'Jan': 'Jan',
  'Fév': 'Feb',
  'Mars': 'Mar',
  'Avr': 'Apr',
  'Mai': 'May',
  'Juin': 'Jun',
  'Juil.': 'Jul',
  'Août': 'Aug',
  'Sept': 'Sep',
  'Oct': 'Oct',
  'Nov': 'Nov',
  'Déc': 'Dec',
  'Pour activer cette fonctionnalité, ajoutez notre adresse ': 'To activate this feature, add our address ',
  'à votre ': ' to your ',
  'Search Console': 'Search Console',
  ', ': ', ',
  'puis cliquez ici pour lancer l’analyse.': 'then click here to start the analysis.',
  'all devices': 'All devices',
  'Desktop': 'Desktop',
  'Mobile': 'Mobile',
  '30 days': '30 days',
  '7 days': '7 days',
  '90 days': '90 days',
  'Aucun projet créé pour le moment.': 'No projects created yet.',
  'Lancer votre premier projet': 'Launch your first project',
  'Aucun contenu disponible pour ce site web.': 'No content available for this website.',
  'Mes contenus': 'My contents',
  'Type de contenu': 'Content type',
  'Date d\'ajout': 'Creation date',
  'URL': 'URL',
  'Status': 'Status',
  'Date de livraison': 'Delivery date',
  'Date de validation': 'Validation date',
  'Date de déploiement': 'Deployment date',
  'Action': 'Action',
  'Aucun contenu pour ce filtre.': 'No content for this filter.',
  'Chargement...': 'Loading...',
  'Aucun contenu.': 'No content.',
  'Précédent': 'Previous',
  'Suivant': 'Next',

  'fiche produit': 'Product page',
  'Page catégorie': 'Category page',
  'Fiche GMB': 'GMB page',
  'store locator': 'Store locator',
  'redaction': 'Writing',
  'traduction': 'Translation',
  'Fiches produit SEO': 'SEO product page',
  'Derniers projets crées': 'Latest Added Projects',
  'Agent IA': 'AI agent',
  'Dérniére mise à jour': 'Last update',
  'Créer un nouveau contenu': 'Create new content',
  'Rédigez un texte optimisé grâce à l’IA — rapide, pertinent et performant.': 'Write an AI-optimized text — fast, relevant, and effective.',
  'Validé': 'Validated',
  'En ligne': 'Online',
  'Fiches GMB': 'GMB pages',
  'Fiches store locator': 'Store locator pages',
  'Pages catégories': 'Category pages',
  'Traduction IA': 'AI Translation',
  '🌍 Traduction IA': '🌍 AI Translation',
  'Actions': 'Actions',
  'Traduire un nouveau contenu': 'Translate new content',
  'Traduisez vos contenus automatiquement avec une précision multilingue.': 'Automatically translate your contents with multilingual accuracy.',
  'Nom du projet': 'Project name',
  'Chef de projet': 'Project manager',
  'Deadline du projet': 'Project deadline',
  'Informations globales': 'General information',
  'Contenu du projet': 'Project content',
  'Séléctionner le type de contenu': 'Select content type',
  'Sélectionner un agent IA personnalisé': 'Select a custom AI agent',
  'Créer un agent IA personnalisé': 'Create a custom AI agent',
  'Liens utiles': 'Useful links',
  'Rédacteur(s)': 'Writer(s)',
  'Deadline': 'Deadline',
  'Nb textes': 'No. of texts',
  'IA + Revue humaine': 'AI + Writer review',
  'Ajouter un projet': 'Add project',
  'Projets': 'Projects',
  'Non attribués': 'Unassigned',
  'Rédaction IA': 'AI Writing',
  'Résultats sur': 'Results on',
  'Êtes-vous sûr de vouloir supprimer cet agent IA ?': 'Are you sure you want to delete this AI agent?',
  'Mes agents IA': 'My AI agents',
  'Tous': 'All',
  'Rédaction': 'Writing',
  'Traduction': 'Translation',
  'Rechercher': 'Search',
  'Sélectionner un site': 'Select a website',
  'Créer un agent IA personnalisé': 'Create a custom AI agent',
  'Définissez la mission, le rôle, la langue, le type de contenu et plus encore.': 'Define mission, role, language, content type, and more.',
  'Nouvel agent': 'New agent',
  'Rôle :': 'Role:',
  'Type de contenu :': 'Content type:',
  'Langue :': 'Language:',
  'Siteweb :': 'Website:',
  'GBP': 'GBP',
  'Sélectionner un LLM': 'Select an LLM',
  'Fiche produit smart': 'Smart product page',
  'Détails du texte': 'Text details',
  '(Mot clé*, URL, Balise titre, Balise méta-description)': '(Keyword*, URL, Title tag, Meta description)',
  'URL siteweb*': 'Website URL*',
  'Balise titre': 'Title tag',
  'Balise méta-description': 'Meta description',
  'Sélectionner un site web': 'Select a website',
  'Sélectionner un agent IA': 'Select an AI agent',
  'Lancer': 'Launch',
  'Relancer': 'Relaunch',
  'Génération en cours...': 'Generating...',
  'Générer': 'Generate',
  'Enregistrement...': 'Saving...',
  'Enregistrer ': 'Save',
  'Livrer': 'Deliver',
  'Livraison...': 'Delivering...',
  'En ligne...': 'Online...',
  "Derniers contenus ajoutés": "Recently Added Contents",
  'Nom de l\'agent': 'Agent name',
  'Site web': 'Website',
  'Mission': 'Mission',
  'Langue de traduction': 'Translation language',
  'Langue': 'Language',
  'Tonalité': 'Tone',
  'Cible / Audience': 'Target audience',
  'Base de connaissance locale': 'Local knowledge base',
  'Base de connaissance en ligne': 'Online knowledge base',
  'Sélect. fichiers': 'Select files',
  'Ex: URL1, URL2': 'Ex: URL1, URL2',
  'Annuler': 'Cancel',
  'Mettre à jour': 'Update',
  'Valider': 'Validate',
  'Ex: un paragraphe sur les types d\'intervention, un paragraphe sur les avantages': 'Ex: a paragraph on types of intervention, a paragraph on benefits',
  'ex : les parapluies pliant sont à ouverture automatique, les autres sont manuels': 'Ex: folding umbrellas open automatically, others are manual',
  '📚 Base de connaissances': '📚 Knowledge base',
  'Type de produits / services proposés par le site*': 'Types of products / services of the website*',
  'Règles rédactionnelles': 'Editorial rules',
  'Lexique recommandé': 'Recommended glossary',
  'Expressions interdites': 'Prohibited expressions',
  'Instructions de personnalisation': 'Personalization instructions',
  "🧩 Informations générales": "🧩 General information",
  "🗣️ Ton & Audience": "🗣️ Tone & Audience",
  "📝 Structure & Rédaction": "📝 Structure & Writing",
  "📚 Base de connaissances": "📚 Knowledge base",
  "Structure de texte attendu": "Expected text structure",
  "Enrichissement SEO": "SEO enhancement",
  "traduction IA": "AI translation",
  "Traduction en cours...": "Translation in progress...",
  "Traduire": "Translate",
  "Traduire le texte": "Translate text",
  "Source": "Source",
  "Cible": "Target",
  "1 · LANGUE CIBLE": "1 · TARGET LANGUAGE",
  "2 · AGENT DE TRADUCTION": "2 · TRANSLATION AGENT",
  "Langue cible": "Target language",
  "Agent de traduction": "Translation agent",
  "Sélectionnez une langue": "Select a language",
  "Sélectionnez d’abord une langue": "Select a language first",
  "Sélectionnez un agent": "Select an agent",
  "Aucun agent disponible pour cette langue": "No agent available for this language",
  "Traduction enregistrée": "Translation saved",
  "Texte traduit modifié avec succès": "Translated text updated successfully",
  "a bien été modifiée.": "has been successfully updated.",
  "La Traduction en": "The translation into",
  "la langue cible": "the target language",
  "votre texte": "your text",
  "de": "of",
  "a bien été enregistrée. Elle est désormais disponible dans la section": "has been successfully saved. It is now available in the",
  ", où vous pouvez la relire, l'ajuster et la publier.": ", where you can review, adjust and publish it.",
  "Rester ici": "Stay here",
  "Aller à Traduction IA": "Go to AI Translation",
  "Lier au projet": "Link to project",
  "Lier à un projet": "Link to a project",
  "Le texte": "The text",
  "sera sauvegardé sous ce projet.": "will be saved under this project.",
  "sera sauvegardé sous le projet sélectionné.": "will be saved under the selected project.",
  "Aucun projet pour ce site": "No project for this site",
  "Créez un premier projet pour commencer à y regrouper vos textes sauvegardés.": "Create a first project to start grouping your saved texts there.",
  "Créer un projet": "Create a project",
  "VOS PROJETS": "YOUR PROJECTS",
  "Sélectionnez le projet auquel lier ce texte.": "Select the project to link this text to.",
  "Rechercher un projet…": "Search for a project…",
  "Aucun projet ne correspond.": "No matching projects.",
  "Sélectionnez un projet": "Select a project",
  "Texte ajouté au projet": "Text added to project",
  "Le texte a bien été ajouté au projet": "The text has been successfully added to project",
  "Il n'apparaîtra plus dans la section Rédaction IA : vous le retrouverez désormais directement dans la section Projets.": "It will no longer appear in the AI Writing section: you will now find it directly in the Projects section.",
  "Il n'apparaîtra plus dans la section": "It will no longer appear in the",
  "Rédaction": "Writing",
  "vous le retrouverez désormais directement dans la section": "you will now find it directly in the",
  "Projets": "Projects",
  "Voir dans Projets": "View in Projects",
  "Aller aux Projets": "Go to Projects",
  "Impossible de charger la liste des projets. Veuillez réessayer.": "Unable to load the project list. Please try again.",
  "Une erreur est survenue lors de l'ajout au projet. Veuillez réessayer.": "An error occurred while adding to the project. Please try again.",
  "Aucun projet disponible pour ce site web.": "No projects available for this website.",
  "ORIGINAL": "ORIGINAL",
  "TRADUCTION": "TRANSLATION",
  "Une erreur est survenue lors de la traduction.": "An error occurred during translation.",
  "Le texte source est requis pour la traduction.": "Source text is required for translation.",
  "Veuillez d'abord traduire un texte avant de sauvegarder.": "Please translate a text before saving.",
  "Le texte source est requis pour la sauvegarde.": "Source text is required for saving.",
  "Sélectionnez une langue cible.": "Select a target language.",
  "Néerlandais": "Dutch",
  "Créer votre assistant éditorial sur mesure": "Create your custom editorial assistant",
  "Votre texte traduit": "Your translated text",
  "Détail du projet": "Project details",
  "Détail d'attribution": "Assignment details",
  "Détail des contenus": "Content details",
  'En ligne...': 'Online...',
  'Ajouter un nouveau site web': 'Add a new website',
  'Créer': 'Add',
  'Séléctionner ou ajoutez les thématiques qui reflètent votre expertise.': 'Select or add the topics that reflect your expertise.',
  'Ajoutez ou sélectionnez une thématique': 'Add or select a topic.',
  'Le site web a été créé avec succès': 'The website has been created successfully',
  'Nous configurons actuellement vos agents IA. Ils seront bientôt prêts à vous assister dans la génération de vos contenus.': 'We are currently setting up your AI agents. They will soon be ready to assist you with generating your content.',
  'Tous les sites': 'All websites',
  'Sélectionner le site web': 'Select a website',
  'Aucun fichier sélectionné': 'No file selected',
  'ex : utilise le vouvoiement, utilise un vocabulaire compréhensible par la cible': 'E.g: use formal address (‘you’) and vocabulary that is easy for the target audience to understand.',
  '🧠 Créer un agent IA': '🧠 Create an IA agent',
  '🧠 Modifier un agent IA': '🧠 Update an IA agent',
  'Ex : AMF (Autorité des Marchés Financiers).': 'E.g: AMF (French Financial Markets Authority).',
  'Ex: bio, écologique, nom des concurrents': 'E.g: organic, eco-friendly, competitors’ names.',
  'Détailler le plus possible la structure attendue à l\'aide d\'axes de rédaction pour guider l\'IA sur les sujets à traiter et dans quel ordre': 'Provide as much detail as possible on the expected structure using writing guidelines to guide the AI on the topics to cover and the order in which to address them.',
  'Ajouter des éléments que l\'IA doit ou ne pas faire ou mentionner': 'Add elements that the AI must or must not do or mention.',
  'Ex: prêt-à-porter féminin': 'E.g: digital marketing',
  'Ex: Rédacteur SEO': 'E.g : SEO writer',
  'Indiquer la liste des urls sur lesquels l\'IA peut s\'appuyer': 'Specify the list of URLs that the AI can reference.',
  'Créez, optimisez, performez : votre contenu prend une nouvelle dimension.': 'Create, optimize, perform: take your content to a whole new level.',
  'La création de contenu n\'a jamais été aussi smart.': 'Content creation has never been this smart',
  'Boostez votre productivité grâce à la puissance multi-IA. Comparez et combinez les meilleures propositions issues de plusieurs LLM, puis optimisez-les grâce à un score de contenu en temps réel (SEO, lisibilité, pertinence)': 'Boost your productivity with the power of multi-AI. Compare and combine the best suggestions from multiple LLMs, then optimize them with a real-time content score (SEO, readability, relevance).',
  'Je crée mon premier contenu SEO friendly': 'Create my first SEO-friendly content.',
  'Veuillez coller le texte source....': 'Please enter the source text you want to translate…',
  'Enrichir': 'Launch',
  'Veuillez d\'abord sélectionner un site web': 'Please select a website first',
  "🎯 Commencez ici": "🎯 Start here",
  "Ajoutez ou sélectionnez le site web que vous souhaitez suivre.": "Add or select the website you want to track.",
  "📝 Derniers contenus créés": "📝 Latest content created",
  "Retrouvez ici les derniers contenus créés pour le site sélectionné.": "Find here the latest content created for the selected website.",
  "Cliquez sur un texte pour consulter sa fiche détaillée.": "Click on a text to view its detailed page.",
  "📁 Derniers projets créés": "📁 Latest projects created",
  "Accédez rapidement aux derniers projets lancés pour ce site.": "Quickly access the latest projects launched for this website.",
  "Cliquez sur un projet pour voir son avancement et les contenus associés.": "Click on a project to see its progress and associated content.",
  "📊 Suivi de vos projets": "📊 Track your projects",
  "Visualisez la répartition de vos projets : en cours, en retard ou validés.": "View the distribution of your projects: ongoing, delayed, or completed.",
  "Une vue d’ensemble claire pour suivre l’état global de votre production.": "A clear overview to monitor the overall status of your production.",
  "📑 Statut d’avancement des contenus": "📑 Content progress status",
  "Suivez ici la répartition de vos contenus : brouillons, livrés et publiés.": "Track the distribution of your content here: drafts, delivered, and published.",
  "Idéal pour identifier rapidement où concentrer vos efforts.": "Ideal for quickly identifying where to focus your efforts.",
  "📅 Textes publiés par mois": "📅 Texts published per month",
  "Visualisez le nombre de textes publiés chaque mois pour le site sélectionné.": "See the number of texts published each month for the selected website.",
  "Suivez ainsi votre rythme de déploiement dans le temps.": "This way, track your deployment pace over time.",
  "⭐ Top mots-clés": "⭐ Top keywords",
  "Découvrez vos 5 mots-clés les plus performants issus de la Search Console.": "Discover your 5 best-performing keywords from the Search Console.",
  "Comparez leur position, les clics actuels et les clics de l’année précédente.": "Compare their position, current clicks, and clicks from the previous year.",
  "📈 Activer le suivi du trafic": "📈 Enable traffic tracking",
  "Ajoutez notre adresse e-mail à votre Search Console pour activer cette analyse.": "Add our email address to your Search Console to enable this analysis.",
  "Vous pourrez ensuite suivre l’évolution de votre trafic directement dans Typix.": "You can then track your traffic evolution directly in Typix.",
  "🏠 Tableau de bord": "🏠 Dashboard",
  "Revenez à la vue globale : indicateurs clés, contenus récents, projets et performances de votre site.": "Return to the global view: key metrics, recent content, projects, and website performance.",
  "🤖 Agents IA": "🤖 AI Agents",
  "Configurez et pilotez vos agents IA pour automatiser la rédaction ainsi que la traduction et gagner du temps sur vos contenus.": "Set up and manage your AI agents to automate writing and translation, saving time on your content.",
  "✍️ Rédaction IA": "✍️ AI Writing",
  "Accédez aux générateurs IA : fiches produit, fiches GMB, pages catégories et autres contenus optimisés.": "Access AI generators: product pages, GMB pages, category pages, and other optimized content.",
  "🌍 Traduction IA": "🌍 AI Translation",
  "Traduisez vos contenus en plusieurs langues en quelques clics tout en conservant la cohérence SEO.": "Translate your content into multiple languages in a few clicks while maintaining SEO consistency.",
  "➕ Créer un projet": "➕ Create a project",
  "Lancez un nouveau projet de contenus en quelques secondes et suivez ensuite son avancement.": "Launch a new content project in seconds and then track its progress.",
  "📂 Gestion des projets": "📂 Project management",
  "Accédez à vos projets non attribués, en cours, en retard ou validés pour suivre leur progression.": "Access your unassigned, ongoing, delayed, or completed projects to track their progress.",
  "👤 Mon profil": "👤 My profile",
  "Modifiez vos informations personnelles.": "Edit your personal information.",
  "🧑‍🤝‍🧑 Gestion des utilisateurs": "🧑‍🤝‍🧑 User management",
  "Invitez de nouveaux membres, gérez leurs droits et organisez vos équipes simplement.": "Invite new members, manage their permissions, and organize your teams easily.",
  "❓ Mon guide": "❓ My guide",
  "Relancez ce guide interactif à tout moment pour retrouver les principales fonctionnalités de Typix.": "Restart this interactive guide at any time to access the main features of Typix.",
  'Mon guide': 'My guide',
  'Se déconnecter': 'Logout',
  "L'adresse email est obligatoire.": "The email address is required.",
  "Le nom est obligatoire.": "The last name is required.",
  "Le prénom est obligatoire.": "The first name is required.",
  "Le mot de passe est obligatoire.": "The password is required.",
  "La confirmation est obligatoire.": "The confirmation is required.",
  "Les mots de passe ne correspondent pas.": "The passwords do not match.",
  "Nom agent'": "Agent name",
  "Rédaction": "Writing",
  "Traduction": "Translation",
  "Mots clé": "Keyword",
  "Url de la page": "Page URL",
  "Entrez le mot clé principal": "Enter the main keyword",
  "Entrez l url": "Enter the URL",
  "Date d'ajout": "Creation Date",
  "Dernière mise à jour": "Last update",
  "URL": "URL",
  "Status": "Status",
  "Actions": "Actions",
  "Détails du texte": "Text details",
  "Contenus disponibles": "Available content",
  "Textes générés": "Generated texts",
  "Url page": "Page URL",
  "Entrez l'URL cible de votre contenu (facultatif).": "Enter the target URL of your content (optional).",
  "GAP sémantique": "Semantic gap",
  "keyword1 (2),\nkeyword2 (1),\nkeyword3 (1),\nkeyword4 (2),\n.....": "keyword1 (2),\nkeyword2 (1),\nkeyword3 (1),\nkeyword4 (2),\n.....",
  "Maillage interne": "Internal linking",
  "Introduisez le maillage": "Enter the internal linking",
  "Introduisez le maillage interne": "Enter the internal linking",
  "Texte à traduire": "Text to translate",
  "Saisissez le texte à traduire": "Enter the text to translate",
  "Traduire un contenu": "Translate content",
  "Traduire un lot de contenus": "Translate a batch of content",
  "Importer un fichier contenant la liste des textes à traduire et l'IA fera le reste 😊": "Import a file containing the list of texts to translate and AI will do the rest 😊",
  "Commencer la traduction": "Start translation",
  "Lancer la traduction": "Launch translation",
  "Commencer la rédaction": "Start writing",
  "Lancer la rédaction": "Launch writing",
  'Analyse Content Score en cours': 'Calculation of content score is in progress',
  'Terminer': 'Done',
  'Suivant': 'Next',
  'Précédent': 'Back',
  'Passer': 'Skip',
  'Fermer': 'Close',
  'Rôle*': 'Role*',
  'Agent IA mis à jour avec succès': 'AI agent updated successfully',
  'Agent IA créé avec succès': 'AI agent created successfully',
  'Annuler la création de l\'agent ?': 'Cancel agent creation?',
  'Annuler les modifications ?': 'Cancel changes?',
  'Chargement': 'Loading',
  'Êtes-vous sûr de vouloir supprimer ce contenu ?': 'Are you sure you want to delete this content ?',
  'Score Global': 'Global score',
  'Score SEO': 'SEO score',
  'Score UX': 'UX score',
  '(Mot clé*, URL, Balise titre, Balise méta-description, Agent IA*)': '(Keyword, URL, Title tag, Meta description tag, AI Agent*)',
  'Rédacteurs / Agent': 'Writers / Agent',
  'Ajouter un administrateur': 'Add an admin',
  'Rechercher par mail, prénom, nom,...': 'Search by mail, fisrt name, last name',
  'Récapitulatif': 'Summary',
  'Quitter la création': 'Quit creation',
  'Objectif du projet': 'Project objective',
  'Mode de production': 'Production mode',
  'Répartition du travail': 'Work distribution',
  'Contexte éditorial': 'Editorial context',
  'Rédaction': 'Writing',
  'Traduction': 'Translation',
  'Créer du contenu original': 'Create original content',
  'Traduire un contenu existant': 'Translate existing content',
  'Identification du projet': 'Project identification',
  'Nom du projet': 'Project name',
  'Vous pourrez modifier le nom plus tard': 'You can change the name later',
  'URL du site': 'Website URL',
  'Langue': 'Language',
  'Sélectionner une langue': 'Select a language',
  'Nombre de textes': 'Number of texts',
  '12 textes disponibles': '12 texts available',
  'Chef de projet': 'Project manager',
  'Aucun chef de projet assigné au siteweb': 'No project manager assigned to the website',
  'Sélectionner un chef de projet': 'Select a project manager',
  'Date limite du projet': 'Project deadline',
  'Sélectionner une date limite': 'Select a deadline',
  'Retour': 'Back',
  'Définissez l\'objectif et le cadre général de votre projet.': 'Define the objective and general framework of your project.',
  'IA': 'AI',
  'Production généré par IA': 'AI-generated production',
  'Rédacteur': 'Writer',
  'Production par un rédacteur': 'Production by a writer',
  'IA + revue humaine': 'AI + human review',
  'IA avec validation humaine.': 'AI with human validation.',
  'Répartissez les textes de votre projet entre vous et d\'éventuels rédacteurs.': 'Distribute the texts of your project between yourself and potential writers.',
  'L\'attribution à un rédacteur est optionnelle.': 'Assignment to a writer is optional.',
  'Agent IA': 'AI agent',
  'Vous pourrez changer d\'agent plus tard': 'You can change the agent later',
  'Sélectionnez le mode IA': 'Select AI mode',
  'Aucun agent disponible': 'No agent available',
  'Sélectionner un agent IA': 'Select an AI agent',
  'Format du contenu': 'Content format',
  'Sélectionner un format': 'Select a format',
  'Nombre de mots par texte': 'Number of words per text',
  'Format personnalisé': 'Custom format',
  'définir le nombre de mots': 'define the number of words',
  'mots': 'words',
  'Options avancées': 'Advanced options',
  'Enrichissement du contenu': 'Content enrichment',
  'Génération Image': 'Image Generation',
  "Nombre d’images": "Number of Images",
  "Définir le nombre d’images": "Set the number of images",
  'Consomment des crédits supplémentaires': 'Consume additional credits',
  'IA augmentée par vos données': 'AI enhanced by your data',
  'Sélectionnez les personnes en charge de la relecture des contenus générés par l\'IA et répartissez': 'Select the people in charge of reviewing AI-generated content and distribute',
  'les textes à valider.': 'the texts to validate.',
  'Le relecteur peut apporter des corrections et ajustements ciblés dans la limite de mots définie,': 'The reviewer can make corrections and targeted adjustments within the defined word limit,',
  'sans réécrire entièrement le contenu.': 'without completely rewriting the content.',
  'Contexte éditorial & brief détaillé du projet': 'Editorial context & detailed project brief',
  'Ajouter des informations contextuelles pour guider et enrichir la production des contenus.': 'Add contextual information to guide and enrich content production.',
  'Gap sémantique': 'Semantic gap',
  'optionnel': 'optional',
  'Brief détaillé': 'Detailed brief',
  'Lien drive...': 'Drive link...',
  'Lancer le projet': 'Launch project',
  'Nom du projet existant': 'Project name already exists',
  'Un projet avec ce nom existe déjà dans votre espace.': 'A project with this name already exists in your space.',
  'Merci de choisir un nom différent pour continuer.': 'Please choose a different name to continue.',
  'Erreur lors de la création du projet. Veuillez réessayer.': 'Error creating project. Please try again.',
  'Félicitations !': 'Congratulations!',
  'Votre projet a été créé avec succès !': 'Your project has been created successfully!',
  'Voir le projet': 'View project',
  'Paramètres du compte': 'Account settings',
  'Site web': 'Website',
  'Langue du site': 'Site language',
  'textes': 'texts',
  'Deadline': 'Deadline',
  'Type': 'Type',
  'Rédacteur': 'Writer',
  'Moi (par défaut)': 'Me (by default)',
  'Livraison le': 'Delivery on',
  'À venir': 'Coming soon',
  'Production généré par IA': 'AI-generated production',
  'Agent': 'Agent',
  'Format': 'Format',
  'Enrichissement du contenu activé': 'Content enrichment enabled',
  'Relecteur': 'Reviewer',
  'texte': 'text',
  'Limite de modification': 'Modification limit',
  'Aucune attribution': 'No assignment',
  'Aucun élément ajouté': 'No items added',
  'janvier': 'January',
  'février': 'February',
  'mars': 'March',
  'avril': 'April',
  'mai': 'May',
  'juin': 'June',
  'juillet': 'July',
  'août': 'August',
  'septembre': 'September',
  'octobre': 'October',
  'novembre': 'November',
  'décembre': 'December',
  'à': 'to',
  'mots minimum': 'words minimum',
  'mots maximum': 'words maximum',
  'Sans titre': 'Untitled',
  'Status de validation des projets': 'Project validation status',
  "Statut d'avancement des contenus": 'Content progress status:',
  'Total des contenus': 'Total content:',
  'Non attribué': 'Unassigned',
  'Évolution des performances': 'Performance evolution',
  'Position': 'Position',
  'Nombre de textes publiés': 'Number of published texts',
  'Espace de travail AI': 'AI workspace',
  'Découverte de mots-clés': 'Keyword Discovery',
  'Générer un mot-clé': 'Generate a keyword',
  'Aucun mot-clé pour le moment.': 'No keywords yet.',
  'Mise à jour 1.2': 'Update 1.2',
  'Découvrez les dernières fonctionnalités, optimisations et correctifs.':
    'Discover the latest features, optimizations and fixes.',
  'Découvrez Typix Néo en 2 min': 'Discover Typix Néo in 2 min',
  'Regarder la vidéo': 'Watch the video',
  'Score de contenu': 'Content score',
  'Création de projet': 'Project creation',
  'Vidéo terminée': 'Video finished',
  'Souhaitez-vous regarder la vidéo suivante ?': 'Would you like to watch the next video?',
  'Vidéo suivante': 'Next video',
  Nouveau: 'New',
  'Nouvelle fonctionnalité': 'New feature',
  'Les tutoriels vidéo arrivent sur Typix Néo': 'Video tutorials are coming to Typix Néo',
  'Des vidéos courtes pour maîtriser chaque étape, à regarder quand vous voulez.':
    'Short videos to master every step, to watch whenever you want.',
  'Bibliothèque des vidéos': 'Video library',
  vues: 'viewed',
  'Ne plus afficher au démarrage': 'Don’t show again at startup',
  'Voir tous les tutoriels': 'See all tutorials',
  'Plus tard': 'Later',
  'Un tour d’horizon rapide de la plateforme et de ses principales fonctionnalités.':
    'A quick overview of the platform and its main features.',
  'Découvrez comment utiliser l’Agent IA de Typix Néo.':
    'Discover how to use the Typix Néo AI Agent.',
  'Apprenez à générer un brief de rédaction en quelques clics.':
    'Learn how to generate a writing brief in a few clicks.',
  'Trouvez les mots-clés à cibler pour vos contenus.':
    'Find the keywords to target for your content.',
  'Générez des contenus optimisés grâce à la rédaction IA de Typix Néo.':
    'Generate optimized content with Typix Néo AI writing.',
  'Évaluez la qualité SEO et éditoriale de vos contenus avec le scoring.':
    'Evaluate the SEO and editorial quality of your content with scoring.',
  'Créez et organisez vos projets de contenu étape par étape.':
    'Create and organize your content projects step by step.',
  'Produisez plusieurs contenus en une seule fois avec la rédaction en lot.':
    'Produce multiple pieces of content at once with batch writing.',
  'Rédaction en lot': 'Batch writing',
  'Projet créé': 'Project created',
  'Votre projet a bien été créé.': 'Your project has been created.',
  'Vous pouvez commencer à travailler dessus dès maintenant.':
    'You can start working on it right away.',
  'Sélectionnez le mode IA': 'Select AI mode',
  'Aucun agent disponible': 'No agent available',
  'Sélectionner un agent IA': 'Select an AI agent',
  'Sélectionner un format': 'Select a format',
  'Veuillez d\'abord sélectionner un site web': 'Please select a website first',
  ////////////
  'Nouveau contenu': 'New content',
  'Génération en cours...': 'Generation in progress...',
  'Optimisation en cours...': 'Optimization in progress...',
  'Traduction en cours...': 'Translation in progress...',
  'En lignes': 'Online',
  'filtres': 'filters',
  'trier par': 'sort by',
  'Score décroissant': 'Decreasing score',
  'Score croissant': 'Increasing score',
  'Date de création': 'Creation date',
  'Date de mise à jour': 'Last update',
  'Date récente': 'Recent date',
  'Date ancienne': 'Old date',
  'Mots clés': 'Keywords',
  'Éditeur': 'Editor',
  'Créateur': 'Creator',
  'Rédacteurs': 'Writers',
  'Réinitialisé par défaut': 'Reset to default',
  'Mode de rédaction': 'Writing mode',
  'Agent AI utilisé': 'AI agent used',
  'Textes en brouillons': 'Draft',
  'Modèle': 'Model',
  'Paramètres du projet': 'Project settings',
  'Avancement': 'Progress',
  'Progression': 'Progression',
  'Aucun texte disponible': 'No text available',
  'Détails du projet': 'Project details',
  'Page {{current}} sur {{total}}': 'Page {{current}} of {{total}}',
  'Moteur LLM': 'LLM engine',
  'Rédiger un contenu': 'Write content',
  'Traduire un contenu': 'Translate content',
  'Optimiser un contenu': 'Optimize content',
  'Générer un contenu': 'Generate content',
  'Créez un texte pour un mot-clé spécifique avec un formulaire guidé': 'Create a text for a specific keyword with a guided form',
  'Traduire un texte spécifique avec un formulaire guidé': 'Translate a specific text with a guided form',
  'Générez plusieurs textes en important un fichier Excel': 'Generate several texts by importing an Excel file',
  'Rédiger un lot de contenus': 'Write a batch of content',
  'Traduire un lot de contenus': 'Translate a batch of content',
  'Enrichir un contenu': 'Enrich content',
  'Optimisez un texte spécifique avec un formulaire guidé': 'Optimize a specific text with a guided form',
  'Nombre total de textes alloués au projet': 'Total number of texts allocated to the project',
  'Vous pourrez changer le format du contenu plus tard': 'You can change the content format later',
  'Saisissez chaque mot-clé suivi de sa fréquence entre parenthèses, puis appuyez sur Entrée. Exemple : chaussures(3)': 'Enter each keyword followed by its frequency in parentheses, then press Enter. Example: shoes(3)',
  'Ex: voiture(5), électrique(3), autonomie(8)': 'Ex: car(5), electric(3), autonomy(8)',
  'URLs des pages à lier (séparées par des virgules)': 'URLs of pages to link (separated by commas)',
  'Besoin d\'aide pour préparer votre fichier ?': 'Need help preparing your file?',
  'Télécharger le modèle (Excel)': 'Download the model (Excel)',
  'Déposez votre fichier ici': 'Drop your file here',
  'Glissez-déposez votre fichier Excel': 'Drag and drop your Excel file',
  'ou cliquez pour parcourir': 'or click to browse',
  'Formats acceptés : .xlsx, .xls (max 10 Mo)': 'Accepted formats: .xlsx, .xls (max 10 Mo)',
  'Parcourir les fichiers': 'Browse files',
  'Ex: télépéage automatique': 'Ex: automatic toll payment',
  'Générer le contenu': 'Generate content',
  'Lancer la génération': 'Launch generation',
  'Commencer la traduction': 'Start translation',
  'Lancer la traduction': 'Launch translation',
  'Partager': 'share',
  'Telecharger le texte': 'Download text',
  'Modifier le projet': 'Edit project',
  'Modifiez les détails de votre projet ici.': 'Edit the details of your project here.',
  'Général': 'General',
  'Allocation des textes': 'Text allocation',
  'Sélectionner un format du contenu': 'Select a content format',
  'Allocation aux rédacteurs': 'Allocation to writers',
  '{{count}} textes disponibles': '{{count}} texts available',
  'Sélectionner un rédacteur': 'Select a writer',
  'Nom du rédacteur': 'Writer name',
  'Date limite': 'Deadline',
  'texte restant': 'remaining text',
  'textes alloués': 'allocated texts',
  'Article court - 300 mots': 'short -300 words',
  'Article moyen - 600 mots': 'medium  - 600 words',
  'Article long - 1000 mots': 'long  - 1000 words',
  'Youtube - 350 mots': 'youtube - 350 words',
  'Linkedin - 200 mots': 'linkedin - 200 words',
  'X - 150 mots': 'x - 150 words',
  'Personnalisé': 'custom',

  'Voir plus': 'View more',
  ' à votre ': ' to your ',
  '{{count}} textes à livrer': '{{count}} texts to deliver',
  ///support
  'Nous contacter': 'Contact us',
  'Vous avez une question ou un problème ? Contactez-nous et nous vous répondrons dans les plus brefs délais.': 'Do you have a question or a problem? Contact us and we will get back to you as soon as possible.',
  'Sujet': 'Subject',
  'Message': 'Message',
  'Soumettre ma demande': 'Submit my request',
  'Veuillez sélectionner un sujet': 'Please select a subject',
  'Décrivez votre demande en détail...': 'Describe your request in detail...',
  'Sélectionnez un sujet': 'Select a subject',
  'Autre': 'Other',
  'Feedback': 'Feedback',
  'Question': 'Question',
  'Bug': 'Bug',
  'Le message doit contenir au moins 10 caractères': 'The message must contain at least 10 characters',
  'Votre message a été envoyé avec succès. Nous vous répondrons dans les plus brefs délais.': 'Your message has been sent successfully. We will get back to you as soon as possible.',
  'Votre demande a bien été transmise à notre équipe support, qui vous répondra dans les plus brefs délais.': 'Your request has been successfully forwarded to our support team, who will respond to you as soon as possible.',
  'Envoi en cours...': 'Sending...',
  'Fermer': 'Close',
  //
  'Créer un nouvel agent AI': 'Create a new AI agent',
  'Mission de l\'agent': 'Agent mission',
  'L\'agent générera du contenu original à partir de vos consignes.': 'The agent will generate original content based on your instructions.',
  'Informations générales': 'General information',
  'Informations principales': 'Main information',
  'Ton & audience': 'Tone & audience',
  'Structure & rédaction': 'Structure & writing',
  'Base de connaissances': 'Knowledge base',
  'Construction du contenu': 'Content construction',
  'Structure attendu': 'Expected structure',
  'Cadre lexical': 'Lexical framework',
  'Personnalisation avancée': 'Advanced customization',
  'Base de connaissance locale en ligne': 'Online local knowledge base',
  'Glissez-déposez votre fichier': 'Drag and drop your file',
  '3 fichiers maximum.': '3 files maximum.',
  '1 fichier maximum.': '1 file maximum.',
  'Vous pouvez importer 3 fichiers maximum.': 'You can import up to 3 files.',
  'Vous avez atteint le nombre maximum de fichiers autorisés pour cet agent.':
    'You have reached the maximum number of files allowed for this agent.',
  'Vous pouvez importer 1 fichier maximum.': 'You can import 1 file only.',
  "Informations & tone of voice de l'entreprise":
    'Company information & tone of voice',
  "Ajoutez un document décrivant l'entreprise, sa ligne éditoriale et son tone of voice pour rendre la rédaction de contenu plus pertinente.\nFormats acceptés : PDF ou Word (max 10 Mo).":
    'Add a document describing the company, its editorial line and tone of voice to make content writing more relevant.\nAccepted formats: PDF or Word (max 10 MB).',
  'Format de fichier non supporté': 'Unsupported file format',
  'Format de fichier non supporté. Formats acceptés : PDF ou Word.':
    'Unsupported file format. Accepted formats: PDF or Word.',
  'Le format du fichier Informations entreprise n’est pas supporté. Formats acceptés : PDF ou Word.':
    'The company information file format is not supported. Accepted formats: PDF or Word.',
  'Fichier trop volumineux (max 10 Mo)': 'File too large (max 10 MB)',
  'Fichier trop volumineux': 'File too large',
  'Le fichier Informations entreprise est trop volumineux. Veuillez choisir un fichier de 10 Mo maximum.':
    'The company information file is too large. Please choose a file of 10 MB or less.',
  'Supprimer le fichier': 'Remove file',
  'Base de connaissance': 'Knowledge base',
  'Indiquez la liste des urls sur lesquels l’IA peut s’appuyer': 'Provide the list of URLs the AI can rely on',
  'Définissez le positionnement éditorial de votre agent afin qu’il adapte son ton,': 'Define the editorial positioning of your agent so that it adapts its tone,',
  'sa cible et son vocabulaire à votre activité.': 'its target and its vocabulary to your activity.',
  'caractères': 'characters',
  'Rechercher un agent...': 'Search for an agent...',
  'Aucun enrichissement lexical renseigné. Merci de préciser les termes à ajouter.': ' No semantic enrichment provided. Please add the relevant terms.',
  ////
  'Section 1 — Informations requises': 'Section 1 — Required information',
  'Nombre de textes maximum atteint.': 'Maximum number of texts reached.',
  'Vous avez réparti tous les textes disponibles pour ce projet.': 'You have distributed all the available texts for this project.',
  'Section 2 — Génération IA': 'Section 2 — AI generation',
  'Section 3 — Paramètres SEO avancés (optionnel)': 'Section 3 — Advanced SEO settings (optional)',

  'Supprimer le projet ?': 'Delete project',
  'Êtes-vous sûr de vouloir supprimer le projet ? Cette action est irréversible.': 'Are you sure you want to delete the project. This action is irreversible.',
  'Rédacteur (optionnel)': 'Writer (Optionnal)',
  'Aucun rédacteur disponible': 'No writer available',
  "Nombre de textes maximum atteint.": 'Maximum number of texts reached.',
  'Vous avez réparti tous les textes disponibles pour ce projet.': 'You have assigned all available texts for this project.',
  "Supprimer la ligne": "Delete this line",
  "Sélectionner d'abord un rédacteur": "Select a writer first",
  'Format personnalisé - définir le nombre de mots': 'Custom format – define the word count',
  'Ajouter une tâche': 'Add a new task',
  'textes répartis': 'Assigned texts',
  'Sélectionner un moteur LLM': 'Select an LLM engine',
  'colonnes': 'Columns',
  'Limite de modification par texte': 'Edit limit per text',
  'Nombre maximum de mots que le relecteur peut modifier ou ajouter.': 'Maximum number of words the reviewer can edit or add',
  'Projet': 'Project',
  'Colonnes visibles': 'Visible columns',
  'Rapide - via Aqisis': 'Fast - via Aqisis',
  'Génération de gap sémantique': 'Génération de gap sémantique',
  'Identifiez les concepts manquants autour de votre mot-clé pour améliorer la pertinence SEO du texte.': 'Identify missing concepts around your keyword to improve the text\'s SEO relevance.',
  'Analyse basée sur la base de données Aqisis. Requiert un accès actif à Aqisis.': 'Analysis based on the Aqisis database. Requires an active Aqisis access.',
  'Génération basée sur votre contenu et votre mot-clé. Peut prendre quelques secondes.': 'Generation based on your content and keyword. This may take a few seconds.',
  'Mot clé principal dans Aqisis': 'Principal keyword in Aqisis',
  'Analyse intelligente (Light Gap)': 'Smart analysis',
  'GEO - Via Search Ai': 'GEO - Via Search Ai',
  'Search Ai': 'Search Ai',
  'Récupération du gap recommandé par Search Ai pour le GEO. Requiert un accès Search Ai actif.': 'Retrieve the gap recommended by Search Ai for GEO. Requires an active Search Ai access.',
  'Veuillez renseigner un mot-clé et un site web avant de lancer le GAP GEO.': 'Please provide a keyword and a website before running the GEO GAP.',
  "Oups....! Une erreur s'est produite lors du calcul du GAP GEO.": 'Oops....! An error occurred while computing the GEO GAP.',
  'Le site web ou les utilisateurs ne sont pas présents dans Search Ai. Vérifiez que votre compte Search Ai est correctement configuré.': 'The website or users are not present in Search Ai. Please verify that your Search Ai account is correctly configured.',
  'Search Ai est momentanément indisponible. Veuillez réessayer ultérieurement ou contacter le support si le problème persiste.': 'Search Ai is temporarily unavailable. Please try again later or contact support if the problem persists.',
  "Le prompt n'existe pas dans Search Ai. Veuillez vérifier que le mot-clé correspond bien au prompt recherché.": 'The prompt does not exist in Search Ai. Please verify that the keyword matches the prompt you are looking for.',
  "Aucune correspondance entre l'URL et la question n'a été trouvée dans Search Ai.": 'No match was found between the URL and the question in Search Ai.',
  "Ce prompt est associé à plusieurs analyses Search Ai. Sélectionnez l'adresse e-mail correspondant à l'analyse depuis laquelle vous souhaitez récupérer le gap sémantique.": 'This prompt is associated with multiple Search Ai analyses. Select the email address corresponding to the analysis from which you want to retrieve the semantic gap.',
  'Sélectionner une adresse e-mail': 'Select an email address',
  'Ex : référencement naturel': 'Eg : Software developpement',
  'Titre projet': 'Project title',
  'Projets validés': 'Validated projects',
  'Gap comblé : aucun mot-clé restant.': 'Gap filled: no keywords remaining.',
  'Saisissez chaque mot-clé suivi de sa fréquence entre parenthèses, séparés par une virgule ou un retour à la ligne. \n Exemple :\n chaussures(3), robe(2), pantalon(1)': 'Enter each keyword followed by its frequency in parentheses, separated by a comma or a line break. \n Example:\n shoes(3), dress(2), pants(1)',
  'Générer une couverture sémantique': 'Generate semantic gap',
  'Lancer la création': 'Start writing',
  'Télécharger en Word': 'Download as Word',
  'Télécharger en HTML': 'Download as HTML',
  'Veuillez enregistrer le texte avant de pouvoir le télécharger.':
    'Please save the text before you can download it.',
  'Balise Title :': 'Title tag :',
  'Balise Meta Description :': 'Meta description tag :',
  'URL cible :': 'URL',
  'URL cible': 'URL',
  "Entrez l'URL cible": 'Enter URL',
  'caractères': 'Characters',
  'Entrez la meta description': 'Enter meta description',
  'Balise Title & Meta': 'Title & Meta tag',
  'Texte original': 'Original text',
  'Texte initial': 'Initial text',
  "Texte sauvegardé avec succès": "Text saved successfully",
  "Erreur lors de la sauvegarde": "Error while saving",
  "Texte sauvegardé en brouillon": "Text saved as draft",
  "Texte livré avec succès": "Text delivered successfully",
  'Téléchargez tous les textes.': 'Download all texts.',
  'Rechercher un texte...': 'Search for a text...',
  'Preset de mots': 'Word preset',
  '⚠️ Ajoutez un mot-clé principal pour activer la génération IA': '⚠️ Add a main keyword to activate AI generation',
  'Sélectionnez un agent IA': 'Select an AI agent',
  'Sélectionnez un modèle': 'Select a model',
  'Sélectionnez un format': 'Select a format',
  'Mot-clé principal': 'Main keyword',
  'Paramètres de génération': 'Generated content settings',
  'Relancer l’IA': 'Relaunch AI',
  'Modèle IA': 'AI model',
  'Régénérer avec l’IA': 'Regenerate with AI',
  'Généré par IA': 'Generated by AI',
  /////help panel 

  "Structure attendue": "Expected structure",
  "🎯 Ce champ permet de définir l'organisation du contenu généré. Il indique les sections et sous-sections que l'IA doit respecter lors de la rédaction.": "🎯 This field defines the organization of the generated content. It specifies the sections and subsections that the AI must follow when writing.",
  "Ce champ ne doit pas modifier": "This field must not modify",
  "Le style rédactionnel": "The writing style",
  "Les règles éditoriales": "The editorial rules",
  "Les contraintes SEO": "The SEO constraints",
  "Le nombre de mots": "The word count",
  "Le champ lexical": "The vocabulary field",
  "Ce champ permet de définir": "This field is used to define",
  "L'organisation du contenu": "The content organization",
  "Les sections principales": "The main sections",
  "Les sous-sections": "The subsections",
  "La hiérarchie des titres (H1, H2, H3)": "The heading hierarchy (H1, H2, H3)",
  "Les éléments structurés comme les listes": "Structured elements such as lists",
  "Page produit": "Product page",
  "Format recommandé": "Recommended format",
  "→ Utilisez une structure hiérarchique claire": "→ Use a clear hierarchical structure",
  "Nom du produit + bénéfice principal": "Product name + main benefit",
  "Présentation du produit": "Product presentation",
  "Caractéristiques et détails techniques": "Features and technical details",
  "Liste": "List",
  "Points clés ou caractéristiques": "Key points or features",
  "Avantages pour l'utilisateur": "Benefits for the user",
  "Pourquoi choisir ce produit ?": "Why choose this product?",
  "À qui s'adresse ce produit ?": "Who is this product for?",
  "Conseils d'utilisation": "Usage tips",
  "Questions fréquentes": "Frequently asked questions",
  "Vous pouvez vous inspirer de cet exemple pour structurer votre champ.": "You can use this example as inspiration to structure your field.",
  "Base de connaissance en ligne": "Online knowledge base",
  "🎯 Ce champ permet d'indiquer les pages web sur lesquelles l'IA peut s'appuyer pour enrichir ses réponses.": "🎯 This field allows you to specify web pages that the AI can use to enrich its responses.",
  "Bonnes pratiques": "Best practices",
  "Indiquer uniquement des pages fiables et à jour": "Only include reliable and up-to-date pages",
  "Sélectionner des pages cohérentes avec votre activité": "Select pages relevant to your business",
  "Privilégier des pages de contenu (articles, FAQ, fiches) plutôt que la home": "Prefer content pages (articles, FAQs, product sheets) over the homepage",
  "→ Liste d'URL séparées par une virgule ou un retour à la ligne.": "→ List of URLs separated by a comma or a line break.",
  "Bonnes pratiques pour le lexique recommandé": "Best practices for the recommended lexicon",
  "🎯 Le champ lexical permet d'indiquer des termes à privilégier afin d'enrichir le vocabulaire et renforcer la cohérence thématique du contenu. ": "🎯 The vocabulary field lets you specify preferred terms to enrich the language and strengthen the thematic consistency of the content.",
  "Ce champ ne doit pas servir à": "This field must not be used to",
  "Imposer une répétition excessive": "Force excessive repetition",
  "Forcer des mots-clés": "Force keywords",
  "Donner des instructions SEO techniques": "Give technical SEO instructions",
  "Indiquer une fréquence d'utilisation": "Specify a usage frequency",
  "Modifier la structure du texte": "Modify the text structure",
  "À privilégier": "Recommended",
  "Des mots ou expressions liés au sujet": "Words or expressions related to the topic",
  "Des termes utilisés par votre audience": "Terms used by your audience",
  "Des mots clés qui enrichissent le champ lexical": "Keywords that enrich the vocabulary",
  "→ Ajouter une liste de mots ou d'expressions liés au sujet.": "→ Add a list of words or expressions related to the topic.",
  "Expérience Immersive": "Immersive Experience",
  "Émotion": "Emotion",
  "Mise en scène": "Staging",
  "Artiste": "Artist",
  "Performance": "Performance",
  "Billetterie": "Ticketing",
  "Programmation": "Programming",
  "Ambiance": "Atmosphere",
  "Comment utiliser les consignes complémentaires": "How to use additional instructions",
  "🎯 Les consignes complémentaires permettent d'ajouter des précisions spécifiques au contenu généré. Elles servent à orienter la génération sur un point particulier sans modifier la structure ou les règles principales définies par l'agent.": "🎯 Additional instructions allow you to add specific details to the generated content. They help guide generation on a particular point without modifying the main structure or rules defined by the agent.",
  "Ce champ peut servir à": "This field can be used to",
  "Demander un angle particulier": "Request a specific angle",
  "Préciser un point à approfondir": "Specify a point to elaborate on",
  "Orienter l'analyse": "Guide the analysis",
  "Indiquer un élément spécifique à inclure": "Indicate a specific element to include",
  "Modifier la structure du texte": "Modify the text structure",
  "Changer le nombre de mots": "Change the word count",
  "Supprimer des sections": "Remove sections",
  "Modifier le format": "Modify the format",
  "Donner des consignes techniques SEO": "Give technical SEO instructions",
  "Exemple de consignes complémentaires": "Example of additional instructions",
  "Angle à privilégier": "Preferred angle",
  "Mettre l'accent sur l'aspect écologique": "Focus on the ecological aspect",
  "Point à approfondir": "Point to elaborate on",
  "Inclure un exemple concret d'utilisation": "Include a concrete usage example",
  "Élément à inclure": "Element to include",
  "Valoriser l'impact pour les familles": "Highlight the impact for families",
  "Ces consignes s'appliquent à chaque texte généré par cet agent.": "These instructions apply to every text generated by this agent.",
  "Règles rédactionnelles": "Writing rules",
  "🎯 Ce champ définit uniquement le style d'écriture. Il ne modifie pas la structure ni les règles SEO.": "🎯 This field defines the writing style only. It does not modify the structure or SEO rules.",
  "La structure du texte": "The text structure",
  "Les contraintes SEO": "The SEO constraints",
  "Le nombre de mots": "The word count",
  "Le format HTML": "The HTML format",
  "Les liens ou le maillage interne": "Links or internal linking",
  "Ce champ concerne uniquement": "This field concerns only",
  "Le niveau de langue": "The language level",
  "La relation au lecteur": "The relationship with the reader",
  "Le rythme et le type de phrases": "The rhythm and type of sentences",
  "La posture rédactionnelle": "The writing stance",
  "L'objectif émotionnel": "The emotional goal",
  "→ Utilisez une liste structurée": "→ Use a structured list",
  "Niveau de langue": "Language level",
  "Simple et accessible": "Simple and accessible",
  "Relation au lecteur": "Relationship with the reader",
  "Complice et directe": "Friendly and direct",
  "Tutoiement": "Informal address (tu)",
  "Obligatoire": "Mandatory",
  "Rythme": "Rhythm",
  "Dynamique et engageant": "Dynamic and engaging",
  "Voix": "Voice",
  "Active": "Active",
  "Posture": "Stance",
  "Centrée sur le spectateur et l'expérience vécue": "Focused on the viewer and the lived experience",
  "Objectif": "Goal",
  "Donner envie de découvrir et de sortir": "Inspire curiosity and encourage going out",
  "Style": "Style",
  "Privilégier les verbes d'action et les bénéfices concrets": "Favor action verbs and concrete benefits",
  "Clarté": "Clarity",
  "Éviter toute phrase générique, élitiste ou trop promotionnelle": "Avoid any generic, elitist, or overly promotional phrasing",
  "Expressions interdites": "Forbidden expressions",
  "🎯 Ce champ permet d'indiquer des mots ou expressions à éviter dans le texte final.": "🎯 This field allows you to specify words or expressions to avoid in the final text.",
  "Renseignez uniquement des mots ou expressions courtes": "Enter only short words or phrases",
  "EXEMPLES ILLUSTRATIFS :": "ILLUSTRATIVE EXAMPLES:",
  "En conclusion": "In conclusion",
  "Dans cet article": "In this article",
  "Cliquez ici": "Click here",
  "Meilleur du marché": "Best on the market",
  "Révolutionnaire": "Revolutionary",
  "Incroyable opportunité": "Incredible opportunity",
  "Saisissez vos propres expressions": "Enter your own expressions",
  "Ces exemples ne sont pas des règles imposées.": "These examples are not imposed rules.",
  "Aide à création": "Creation help",
  "Aide à la création": "Creation help",





  ////////////// reste autres langues ///////////////////////

  "Indiquez la liste des urls sur lesquels l'IA peut s'appuyer": "Provide the list of URLs the AI can rely on",
  "Définissez le positionnement éditorial de votre agent afin qu'il adapte son ton,sa cible et son vocabulaire à votre activité.": "Define the editorial positioning of your agent so that it adapts its tone, its target and its vocabulary to your activity.",
  'Consignes complémetaires ': 'Additional instructions',


  'H1: Nom de la catégorie – Notre sélection de mot-clé principal': 'H1: Category name – Our selection of main keywords',
  'H2: Présentation de la catégorie': 'H2: Category presentation',
  'H2: Découvrez nos différents types de produits ou services': 'H2: Discover our different types of products or services',
  'H3: Sous-catégorie 1': 'H3: Subcategory 1',
  'H3: Sous-catégorie 2': 'H3: Subcategory 2',
  'H2: Guide d’achat – Comment bien choisir ?': 'H2: Buying guide – How to choose the right one?',
  'H2: Pourquoi faire confiance à la marque ?': 'H2: Why trust the brand?',

  'H1: Trouver un magasin Nom de l’enseigne': 'H1: Find a store Name of the brand',
  'H2: Notre réseau de magasins': 'H2: Our store network',
  'H2: Comment trouver le magasin le plus proche ?': 'H2: How to find the nearest store?',
  'H2: Nos implantations par région': 'H2: Our locations by region',
  'H3: Région 1': 'H3: Region 1',
  'H3: Région 2': 'H3: Region 2',
  'H2: Services disponibles en magasin': 'H2: Services available in store',
  'H2: Préparer votre visite': 'H2: Prepare your visit',
  'H2: Questions fréquentes sur nos magasins': 'H2: Frequently asked questions about our stores',


  "- Phrase d’accroche incluant activité principale et ville.": "- Hook sentence including main activity and city.",
  "- Présentation concise de l’entreprise et de son expertise.": "- Concise presentation of the company and its expertise.",
  "- Mention de 3 services principaux.": "- Mention of 3 main services.",
  "- Élément différenciant ou valeur ajoutée.": "- Differentiating element or added value.",
  "- Indication de la zone d’intervention.": "- Indication of the service area.",
  "- Invitation naturelle à contacter ou visiter.": "- Natural invitation to contact or visit.",


  'H1: Nom du produit + bénéfice principal': 'H1: Product name + main benefit',
  'H2: Présentation du produit': 'H2: Product presentation',
  'H2: Caractéristiques et détails techniques': 'H2: Features and technical details',
  'Liste à puces': 'List of bullet points',
  "H2: Avantages pour l’utilisateur": "H2: Benefits for the user",
  'H2: Pourquoi choisir ce produit ?': 'H2: Why choose this product?',
  "H2: À qui s’adresse ce produit ?": "H2: Who is this product for?",
  "H2: Conseils d’utilisation": "H2: Usage tips",
  'H2: Questions fréquentes': 'H2: Frequently asked questions',

  'Niveau de langue :': 'Language level :',
  'Relation au lecteur :': 'Relationship with the reader :',
  'Tutoiement :': 'Informal address :',
  'Rythme :': 'Rhythm :',
  'Voix :': 'Voice :',
  'Posture :': 'Stance :',
  'Objectif :': 'Goal :',
  'Style :': 'Style :',
  'Clarté :': 'Clarity :',
  'Expérience immersive': 'Immersive experience',
  'Emotion': 'Emotion',
  'Mise en scène': 'Staging',
  'Artiste': 'Artist',
  'Performance': 'Performance',
  'Billetterie': 'Ticketing',
  'Programmation': 'Programming',
  'Ambiance': 'Atmosphere',

  'Angle à privilégier :': 'Preferred angle :',
  'Point à approfondir :': 'Point to elaborate on :',
  'Élément à inclure :': 'Element to include :',
  'Paramètres de traduction': 'Translation settings',
  'Consignes complémetaires': 'Additional guidelines.',
  'Contenu web': 'Content web',
  'H1: Titre principal de l’article': 'H1: Main title of the article',
  'H2: Introduction': 'H2: Introduction',
  'H3: Présentation du sujet': 'H3: Subject presentation',
  'H3: Objectif ou intérêt pour le lecteur': 'H3: Objective or interest for the reader',
  'H2: Développement principal': 'H2: Main development',
  'H3: Concept': 'H3: Concept',
  'H3: Fonctionnement': 'H3: Functioning',
  'H3: Exemples généraux': 'H3: General examples',
  'H2: Applications': 'H2: Applications',
  'H3: Cas pratiques': 'H3: Practical cases',
  'H3: Conseils ou recommandations': 'H3: Tips or recommendations',
  'H3: Points à retenir': 'H3: Points to remember',
  'H2: Informations complémentaires': 'H2: Additional information',
  'H3: Données ou faits généraux (sans inventer)': 'H3: General data (without inventing)',
  'H3: Questions fréquentes / FAQ (optionnel)': 'H3: Frequently asked questions / FAQ (optional)',
  'H3: Résumé des points clés': 'H3: Summary of key points',
  'H3: Ouverture / pistes de réflexion ou appel à l’action': 'H3: Opening / reflection tracks or call to action',
  'Configurez vos agents IA pour automatiser la création et la traduction de vos contenus, selon vos propres règles éditoriales.': 'Set up your AI agents to automate the creation and translation of your content, according to your own editorial guidelines.',
  'Dans cette section, vous pouvez paramétrer le ton, le style et ajouter des consignes afin d’obtenir des résultats adaptés à votre marque et à chaque type de contenu.': 'In this section, you can set the tone and style, and add specific instructions to generate results tailored to your brand and each type of content.',
  'Résultat': 'Result',
  'Vous gagnez du temps sur la création/traduction de contenu, tout en gardant le contrôle sur la qualité et la pertinence des productions.': 'You save time on content creation and translation, while maintaining full control over the quality and relevance of the output.',
  'Accédez aux générateurs IA pour créer différents types de contenus : fiches produit, fiches GMB, pages catégories et bien plus.': '',
  "Cette section vous permet de tester vos agents IA et de comparer les LLM disponibles selon chaque type de contenu.": "This section allows you to test your AI agents and compare the available LLMs for each type of content.",
  "Vous pouvez ainsi évaluer la qualité des résultats, ajuster vos paramètres et affiner vos choix avant de lancer une production à grande échelle.": "You can evaluate the quality of the results, adjust your settings, and refine your choices before launching large-scale production.",
  "C’est également l’endroit idéal pour générer des contenus à l’unité, de manière rapide et contrôlée.": "It is also the ideal place to generate individual pieces of content quickly and in a controlled way.",
  "Traduisez vos contenus en plusieurs langues en quelques clics, tout en préservant leur cohérence SEO et leur qualité éditoriale.": "Translate your content into multiple languages in just a few clicks, while maintaining SEO consistency and editorial quality.",
  "Lancez un nouveau projet en quelques secondes en définissant vos objectifs, le mode de production et les types de contenus à produire.": "Start a new project in seconds by defining your objectives, production mode, and the types of content to create.",
  "Cette section vous permet de centraliser la production, de garder une vision claire de vos contenus en cours et d’optimiser votre organisation pour produire plus efficacement.": "This section allows you to centralize production, keep a clear overview of your ongoing content, and optimize your workflow for more efficient output.",
  "Piloter l’ensemble de votre activité en un coup d’œil.": "Manage your entire activity at a glance.",
  "Accédez à vos indicateurs clés, consultez vos contenus récents et suivez l’avancement de vos projets": "Access your key metrics, review your recent content, and track the progress of your projects.",
  "Besoin d’aide ? Envoyez-nous un message et nous reviendrons vers vous rapidement pour vous assister": "Need help? Send us a message and we will get back to you quickly to assist you.",
  "Ces thématiques aident l’agent à produire du contenu ciblé et pertinent pour votre audiance": "These topics help the agent generate targeted and relevant content for your audience.",
  "Selectionnez une langue": "Select a language",
  "Cliquez sur Entrée pour confirmer — ex : SEO, E-commerce, Finance": "Press Enter to confirm — e.g., SEO, E-commerce, Finance",
  "Entrez une URL complète avec le format https://mondomaine.com": "Enter a full URL in the format https://mydomain.com",
  "Configurez votre workspace en ajoutant votre siteweb.": "Set up your workspace by adding your website.",
  "Vous pourrez ensuite créer et suivre vos contenus, configurer vos agents, gérer vos traductions et piloter vos projets.": "You can then create and track your content, configure your agents, manage translations, and oversee your projects.",
  "site web déjà existant, veuillez modifier les informations": "Website already exists, please update the information.",
  "Une erreur s'est produite lors de l'enregistrement. Notre équipe a été notifiée. Veuillez vérifier les informations de votre siteweb.": "An error occurred while saving. Our team has been notified. Please check your website information.",
  "Une erreur s'est produite lors de l'enregistrement. Notre équipe a été notifiée.": "An error occurred while saving. Our team has been notified.",
  'Votre compte n’a pas encore été activé. Veuillez le valider en cliquant sur le lien reçu par e-mail.': 'Your account has not been activated yet. Please validate it by clicking the link sent to your email.',
  'requis': 'required',
  'Votre compte a bien été créé. Veuillez cliquer sur le lien envoyé par e-mail afin de l’activer.': 'Your account has been successfully created. Please click the link sent to your email to activate it',

  'Clé API IA': 'AI API Key',
  'Connectez vos propres clés pour utiliser les modèles de votre choix.': 'Connect your own keys to use the models of your choice.',
  'Vos clés sont chiffrées et stockées en sécurité': 'Your keys are encrypted and securely stored',
  'Obtenir une clé API': 'Get an API key',
  'Saisir votre clé API…': 'Enter your API key…',
  'Modèle actif': 'Active model',
  'Connecté': 'Connected',
  'Non configuré': 'Not configured',
  'Clé supprimée avec succès.': 'Key successfully deleted.',
  'Erreur lors de la suppression.': 'Error while deleting.',
  'Erreur lors du test de connexion.': 'Error while testing connection.',
  'Clé invalide ou connexion échouée.': 'Invalid key or connection failed.',
  'Connexion validée ✓': 'Connection successful ✓',
  'Veuillez saisir une clé API avant de tester.': 'Please enter an API key before testing.',
  'Masquer': 'Hide',
  'Afficher': 'Show',
  'Supprimer': 'Delete',
  'Clé API': 'API Key',
  'Définir votre mot de passe': 'Set password',
  'Modèle par défaut': 'Default model',
  'Sélectionner une option': 'Select an option',
  'Tester': 'Test',
  'Mon équipe': 'My team',
  'Enrichissement': 'Optimization',
  'champs obligatoires': 'Required field',
  'Créer le siteweb': 'Create website',
  'URL déjà existante': 'URL already exists',
  'Ce site est déjà enregistré dans votre workspace. Vous pouvez y accéder directement depuis votre dashboard.': 'This site is already registered in your workspace. You can access it directly from your dashboard.',
  'Erreur inattendue': 'Unexpected error',
  'Mot de passe mis à jour avec succès ! Vous allez être redirigé vers la page de connexion.': 'Password updated successfully! You will be redirected to the login page.',
  'Sélectionnez et personnalisez...': 'Select and customize...',
  'Sélectionnez ou ajoutez un type de contenu personnalisé...': 'Select or enter a new type...',

  'Titre avec Nom établissement  + catégorie': 'Title with establishment name + category',

  'Adresse & contact : Une phrase simple avec adresse et numéro de téléphone': 'Address & contact: A simple sentence with address and phone number',
  'Description courte (accroche impactante, bénéfices immédiats)': 'Short description (impactful hook, immediate benefits)',
  'Description moyenne (structurée, orientée bénéfices, solutions pour le client)': 'Medium description (structured, focused on benefits, solutions for the client)',
  'Produits phares (liste)': 'Featured products (list of)',
  'Horaires': 'Opening hours',
  "Optionnel : ajoutez des URLs (site, blog, concurrents…) pour guider l’agent : il pourra s’en inspirer, analyser leur structure et produire des contenus plus pertinents et alignés avec votre univers.": "Optional: add URLs (website, blog, competitors…) to guide the agent; it can draw inspiration, analyze their structure, and produce content that is more relevant and aligned with your brand.",
  "Optionnel : vos ressources internes aident l’agent à produire des contenus plus précis et personnalisés.": "Optional: your internal resources help the agent produce more precise and personalized content.",
  "Base de connaissance web": "Web knowledge base",
  "Nommez votre agent comme un membre de votre équipe": "Name your agent like a member of your team",
  'Mission de l\'agent': 'Agent mission',
  'Choisissez la mission de votre agent.': 'Choose the mission of your agent.',

  '👉 Rédaction : pour créer du contenu original': '👉 Writing: to create original content',
  '👉 Traduction : pour adapter un contenu existant dans une autre langue': '👉 Translation: to adapt existing content into another language',
  'Ce choix détermine le fonctionnement de l’agent et les options disponibles par la suite.': 'This choice determines how the agent operates and the options available afterward.',
  'Nom de l’agent': 'Agent name',
  'Donnez un nom à votre agent comme s’il faisait partie de votre équipe.': 'Give your agent a name as if it were part of your team.',
  'Précisez le rôle de votre agent (rédacteur SEO, copywriter, expert métier…).': 'Specify your agent’s role (SEO writer, copywriter, subject-matter expert…).',
  'Ce rôle détermine sa posture, sa manière de rédiger (expert, pédagogue, commercial…).': 'This role determines its tone and writing style (expert, educational, commercial…).',
  'Et influence directement la manière dont il rédige, structure et priorise l’information.': 'And directly influences how it writes, structures, and prioritizes information.',
  'Sélectionnez parmi la liste le type de contenu que l’agent doit produire (Page catégorie, fiche produit, GMB, Store locator ou ajouter d’autre types comme article de blog, etc …).': 'Select from the list the type of content the agent should produce (category page, product sheet, GMB, store locator, or add other types like blog articles, etc.).',
  'Cela permet d’adapter automatiquement la structure, le style et les attentes SEO.': 'This automatically adapts the structure, style, and SEO expectations.',
  'Choisissez ou personnalisez la tonalité de vos contenus : professionnelle, pédagogique, engageante, premium, etc.': 'Choose or customize the tone of your content: professional, educational, engaging, premium, etc.',
  'La tonalité garantit une cohérence avec votre image de marque et votre positionnement.': 'The tone ensures consistency with your brand image and positioning.',
  'Définissez précisément à qui s’adresse votre contenu. Plus votre audience est claire (ex : débutants, experts, e-commerçants, parents…), plus le contenu sera pertinent, adapté et efficace.': 'Clearly define who your content is for. The more precise your audience (e.g., beginners, experts, e-commerce merchants, parents…), the more relevant, tailored, and effective the content will be.',
  'Définissez la structure type que l’agent doit suivre pour générer votre contenu.': 'Define the standard structure the agent should follow to generate your content.',
  'Indiquez les titres (H1, H2, H3…) et les éléments clés à inclure. Exemple : nom du produit, bénéfices, description, arguments, FAQ…': 'Specify headings (H1, H2, H3…) and key elements to include. Example: product name, benefits, description, arguments, FAQ…',
  'Une structure claire permet d’obtenir un contenu mieux organisé, plus lisible et optimisé pour le SEO.': 'A clear structure results in better-organized, more readable, and SEO-optimized content.',
  'Ajoutez des règles spécifiques de rédaction : style, vocabulaire, la manière de s’adresser au lecteur et le rythme du contenu.': 'Add specific writing rules: style, vocabulary, how to address the reader, and content pacing.',
  'Ces consignes permettent d’obtenir des contenus homogènes et conformes à vos standards éditoriaux.': 'These guidelines help produce consistent content aligned with your editorial standards.',
  'Indiquez les mots et expressions que l’agent doit privilégier dans le contenu. Cela permet d’enrichir le texte, d’améliorer le SEO et de renforcer votre univers sémantique.': 'Indicate the words and expressions the agent should prioritize in the content. This enriches the text, improves SEO, and strengthens your semantic universe.',
  'Exemple : innovation, performance, naturel, expertise…': 'Example: innovation, performance, natural, expertise…',
  'Listez les mots ou formulations à éviter. Utile pour protéger votre image de marque et éviter les contenus inadaptés.': 'List words or phrases to avoid. Useful to protect your brand image and prevent inappropriate content.',
  'Exemple : termes trop promotionnels, jargon technique, expressions négativ': 'Example: overly promotional terms, technical jargon, negative expressions',
  'Consignes complémentaires': 'Additional guidelines',
  'Ajoutez des instructions spécifiques pour affiner le contenu généré. Idéal pour préciser un angle, des éléments à mettre en avant ou des contraintes particulières.': 'Add specific instructions to refine the generated content. Ideal for defining an angle, highlighting key elements, or setting specific constraints.',
  'Base de connaissance locale': 'Local knowledge base',
  'Ajoutez vos ressources internes (documents, briefs, guidelines, contenus existants…).': 'Add your internal resources (documents, briefs, guidelines, existing content…).',
  'L’agent s’appuie sur ces éléments pour produire des contenus plus précis, cohérents et alignés avec votre expertise.': 'The agent relies on these elements to produce more accurate, consistent content aligned with your expertise.',
  'Base de connaissance web': 'Web knowledge base',
  'Ajoutez des URLs (site, blog, concurrents…) pour guider l’agent. Il peut analyser leur structure, leur contenu et s’en inspirer pour produire des textes plus performants et compétitifs.': 'Add URLs (website, blog, competitors…) to guide the agent. It can analyze their structure and content and use them as inspiration to produce more effective and competitive texts.',

  'Vous pouvez ajouter un nouvel agent IA en cliquant sur Créer un nouvel agent IA selon la mission et le type de contenu souhaité': 'You can add a new AI agent by clicking on Create a new AI agent based on the desired mission and content type',
  'Filtrer les agents': 'Filter agents',
  'Utilisez ce filtre pour afficher les agents selon le type de contenu qu’ils produisent.': 'Use this filter to display agents based on the type of content they produce.',
  'Onglets mission': 'Mission tabs',
  'Filtrez vos agents pour retrouver rapidement ceux que vous voulez voir. Par exemple, vous pouvez afficher seulement les agents de Rédaction ou de Traduction.': 'Filter your agents to quickly find the ones you want to see. For example, you can display only Writing or Translation agents.',
  'Première carte d’agent': 'First agent card',
  'Voici un exemple d’agent IA. Vous pouvez éditer ses paramètres ou le supprimer à tout moment. Chaque nouvel agent que vous créez apparaîtra ici.': 'Here is an example of an AI agent. You can edit its settings or delete it at any time. Each new agent you create will appear here.',
  'Créer un nouvel agent IA': 'Create a new AI agent',

  'Définissez précisément à qui s’adresse votre contenu.': 'Clearly define who your content is for.',
  'Plus votre audience est claire (ex : débutants, experts, e-commerçants, parents…), plus le contenu sera pertinent, adapté et efficace.': 'The more precise your audience (e.g., beginners, experts, e-commerce merchants, parents…), the more relevant, tailored, and effective the content will be.',
  'Définissez la nature de produit ou le service visé par la rédaction': 'Define the nature of the product or service targeted by the writing',
  'Coller plusieurs URLs d\'un coup — séparées par des virgules, espaces ou sauts de ligne': 'Paste multiple URLs at once — separated by commas, spaces, or line breaks',
  'Aucune URL ajoutée pour le moment': 'No URLs added yet',
  'Enrichissez l\'agent avec vos ressources : URLs, documents, mots-clés, briefs — pour des contenus ultra-personnalisés.': 'Enrich your agent with your resources: URLs, documents, keywords, briefs — for ultra-personalized content.',
  'Configurez la structure type de vos contenus : longueur, niveaux de titres, sections incontournables, balises SEO.': 'Configure the standard structure of your content: length, heading levels, essential sections, SEO tags.',
  'Définissez le ton éditorial (formel, conversationnel, expert) et la cible. L\'audience détermine le registre et la profondeur du contenu.': 'Define the editorial tone (formal, conversational, expert) and target. The audience determines the register and depth of the content.',
  'Donnez un nom à votre agent et définissez sa mission. Ces informations permettent à l\'IA d\'adapter précisément le contenu généré à vos besoins.': 'Give your agent a name and define its mission. These information allows the AI to precisely adapt the generated content to your needs.',
  'Limite d’agents IA atteinte': 'AI agent limit reached',
  'Vous avez atteint le nombre maximum d’agents IA autorisés sur votre forfait.': 'You have reached the maximum number of AI agents allowed on your plan.',
  'Passez à une offre supérieure': 'Upgrade to a higher plan',
  'pour créer davantage d’agents et': 'to create more agents and',
  'automatiser votre production': 'automate your production',
  'Passer au forfait superieur': 'Upgrade to a higher plan',
  'Fermer': 'Close',
  "Vous avez besoin d'aide pour utiliser cette interface ? Consultez notre guide complet pour créer et configurer vos agents IA.": 'Do you need help using this interface? Consult our complete guide to create and configure your AI agents.',
  'Voir le guide': 'View the guide',
  'Ajouter des crédits supplémentaires': 'Add additional credits',
  'Ajoutez des crédits pour continuer à générer du contenu avec vos agents IA. Les crédits sont consommés à chaque utilisation, selon le type de génération.': 'Add credits to continue generating content with your AI agents. Credits are consumed each time they are used, according to the type of generation.',
  'crédits': 'credits',
  'Utilisables immédiatement • Valables pour le mois en cours': 'Usable immediately • Valid for the current month',
  'Annuler': 'Cancel',
  'Redirection...': 'Redirection...',
  'Continuer vers le paiement': 'Continue to payment',
  'Vous serez redirigé vers notre page de paiement sécurisée (Stripe).': 'You will be redirected to our secure payment page (Stripe).',
  'Gérer votre abonnement': 'Manage your subscription',
  'Modifiez le nombre de sites associés à votre formule.': 'Modify the number of sites associated with your plan.',
  'Abonnement ': 'Subscription ',
  'Forfait actuel': 'Current plan',
  'sites actifs': 'active sites',
  'sites': 'sites',
  'Total mensuel': 'Total monthly',
  'Abonnement mensuel, annulable à tout moment. Paiement sécurisé via Stripe.': 'Monthly subscription, cancellable at any time. Secure payment via Stripe.',
  'Mise à jour...': 'Update...',
  'Contacter l\'équipe': 'Contact the team',
  'Résilier mon abonnement': 'Cancel my subscription',
  'Votre abonnement sera arrêté à la fin de la période en cours.': 'Your subscription will be canceled at the end of the current period.',
  'Pouvez-vous nous indiquer la raison principale de votre résiliation ?': 'Could you tell us the main reason for your cancellation?',
  'Trop cher par rapport à la valeur': 'Too expensive for the value provided',
  'Je n’utilise pas assez l’outil': 'I do not use the tool enough',
  'Fonctionnalités insuffisantes': 'Insufficient features',
  'Difficulté d’utilisation / UX': 'Usability / UX issues',
  'Problèmes techniques / bugs': 'Technical issues / bugs',
  'J’ai trouvé une alternative': 'I found an alternative',
  'Autre': 'Other',
  'Veuillez sélectionner un motif de résiliation.': 'Please select a cancellation reason.',
  'Impossible de traiter la résiliation pour le moment.': 'Unable to process the cancellation right now.',
  'Commentaire': 'Comment',
  'Ajoutez un commentaire': 'Add a comment',
  'Annuler': 'Cancel',
  'Confirmation...': 'Confirming...',
  'Confirmer la résiliation': 'Confirm cancellation',
  'Nombre de site web': 'Number of websites',
  'sites actifs': 'active sites',
  'mois': 'month',
  'Récapitulatif': 'Summary',
  'Sous total': 'Subtotal',
  'Abonnement mensuel renouvelé automatiquement, annulable à tout moment • Paiement sécurisé via Stripe.': 'Monthly subscription renewed automatically, cancellable at any time. Secure payment via Stripe.',
  'Redirection...': 'Redirection...',
  'Continuer vers le paiement': 'Continue to payment',
  'Contacter l\'équipe': 'Contact the team',
  'Augmenter': 'Increase',
  'Passer au forfait ': 'Upgrade to the ',
  'Améliorez votre plan pour débloquer plus de contenus, plus de crédits et de capacités IA.': 'Improve your plan to unlock more content, more credits, and AI capabilities.',
  'Nombre de site web': 'Number of websites',
  'site': 'site',
  'Augmenter': 'Increase',
  'Récapitulatif': 'Summary',
  'Sous total': 'Subtotal',
  'Abonnement mensuel renouvelé automatiquement, annulable à tout moment • Paiement sécurisé via Stripe': 'Monthly subscription renewed automatically, cancellable at any time. Secure payment via Stripe.',
  'Redirection...': 'Redirection...',
  'Continuer vers le paiement': 'Continue to payment',
  'Contacter l\'équipe': 'Contact the team',
  'Aucune facture': 'No invoice',
  'Crédit AI': 'AI credit',
  'Acheter des crédits': 'Buy credits',
  'réinitialisés le 3 avril': 'reset on 3 April',
  'Factures': 'Invoices',
  'Gérer mon abonnement': 'Manage my subscription',
  'admin': 'admin',
  'agent IA': 'AI agent',
  'Besoins spécifiques ou volumétrie importante ? Nos équipes vous accompagnent avec une offre adaptée.': 'Special needs or high volume? Our teams accompany you with an adapted offer.',
  'Abonnement': 'Subscription',
  'Besoin d’un plan personnalisé ?': 'Need a personalized plan?',
  'Contactez-nous': 'Contact us',
  'Voir toutes les formules': 'View all plans',
  'Gérer mon abonnement': 'Manage my subscription',
  'Forfait actuel': 'Current plan',
  'Améliorer maintenant': 'Improve now',
  'Passez au forfait light pour 9,90€': 'Upgrade to the Light plan for €9.90',
  'Passez au forfait premium pour 49,90€': 'Upgrade to the Premium plan for €49.90',
  'Passez au forfait pro pour 99,90€': 'Upgrade to the Pro plan for €99.90',
  '1 website': '1 website',
  '1 admin': '1 admin',
  '2 Agents IA': '2 AI agents',
  '200 crédit IA': '200 AI credits',
  '20 textes': '20 texts',
  'GPT ou IA utilisateur': 'GPT or custom AI model',
  '1 admin + 1 redacteur': '1 admin + 1 writer',
  '3 Agents IA': '3 AI agents',
  '1000 crédit IA': '1000 AI credits',
  '100 textes': '100 texts',
  'GPT +Claude': 'GPT + Claude',
  '1 admin + 1 redacteur + 1 chef de projet': '1 admin + 1 writer + 1 project manager',
  '5 Agents IA': '5 AI agents',
  '2000 crédit IA': '2000 AI credits',
  '200 textes': '200 texts',
  'GPT +Claude + perplexity+ hybrid': 'GPT + Claude + Perplexity + Hybrid',
  'Crédits épuisés': 'Credits exhausted',
  'Crédits disponibles': 'Credits available',
  'Demander un devis': 'Request a quote',

  'Besoins spécifiques ou volumétrie importante ?': 'Special needs or high volume?',
  'Nos équipes vous accompagnent avec une offre adaptée.': 'Our teams accompany you with an adapted offer.',
  'Demander un devis': 'Request a quote',
  'Configuration': 'Configuration',
  'Utilisateurs inclus': 'Users included',
  'Agent IA': 'AI agent',
  'Quota de contenus': 'Content quota',
  'Crédits IA mensuels': 'AI credits per month',
  'Modèles IA disponibles': 'Available AI models',
  'Assistant IA dans l’éditeur': 'AI assistant in the editor',
  'Type de contenu': 'Content type',
  'Générique': 'Generic',
  'SEO': 'SEO',
  'Social': 'Social',
  'Assistant IA dans l’éditeur': 'AI assistant in the editor',
  'Selon crédits': 'According to credits',
  'Génération augmentée (RAG)': 'Enhanced generation (RAG)',
  'SEO & contenu': 'SEO & content',
  'Score de contenu SEO & UX': 'SEO & UX content score',
  'Par site (multi-sites possibles)': 'Per site (multi-site possible)',
  'Choisissez la formule adaptée à vos besoins et faites évoluer votre usage à tout moment.': 'Choose the plan that fits your needs and scale your usage at any time.',
  'Contactez nous': 'Contact us',
  'Gratuit': 'Free',
  'Commencer': 'Get started',
  'S\'abonner': 'Subscribe',
  'Custom': 'Custom',
  '1 agent IA': '1 AI agent',
  '2 agents IA': '2 AI agents',
  '3 agents IA': '3 AI agents',
  '5 agents IA': '5 AI agents',
  '10 contenus/mois': '10 contents/month',
  '20 contenus/mois': '20 contents/month',
  '100 contenus/mois': '100 contents/month',
  '200 contenus/mois': '200 contents/month',
  '10 crédits IA': '10 AI credits',
  '200 crédits IA': '200 AI credits',
  '1000 crédits IA': '1000 AI credits',
  '2000 crédits IA': '2000 AI credits',
  'Modèle GPT': 'GPT model',
  'Tous les modèles': 'All models',
  'Besoins spécifiques': 'Specific needs',
  'Sur mesure': 'Custom',
  'Tarification adaptée': 'Tailored pricing',
  'Volumétrie importante': 'High volume',
  'Accompagnement': 'Dedicated support',
  'Comparaison des fonctionnalités': 'Feature comparison',
  'Fonctionnalité': 'Feature',
  'Agents IA': 'AI agents',
  'Crédits IA/mois': 'AI credits/month',
  'Score SEO & UX': 'SEO & UX score',
  'Support': 'Support',
  '/ site / mois': '/ site / month',
  'Chaque formule correspond à un site.': 'Each plan corresponds to one website.',
  'Ajoutez autant de sites que nécessaire.': 'Add as many websites as needed.',
  'Chaque site dispose de ses propres utilisateurs et crédits.': 'Each website has its own users and credits.',
  'Light': 'Light',
  'Premium': 'Premium',
  'Pro': 'Pro',
  'Améliorer': 'Upgrade',
  '1 rédacteur': '1 writer',
  '1 chef de projet': '1 project manager',
  'Modèles IA': 'AI models',
  '+ IA via API externe': '+ AI via external API',
  'Optimisation sémantique': 'Semantic optimization',
  'Traduction IA multilingue': 'Multilingual AI translation',
  'Collaboration': 'Collaboration',
  'Pilotage des contenus': 'Content management',
  'Export multi-formats': 'Multi-format export',
  'Collaboration & workflows': 'Collaboration & workflows',
  'Support & extras': 'Support & extras',
  'Support prioritaire': 'Priority support',
  'Création d’images IA': 'AI image generation',
  '25 images': '25 images',
  '50 images': '50 images',
  'Le plus populaire': 'The most popular',
  'Fermer la fenetre': 'Close window',
  'Paiement confirme': 'Payment confirmed',
  'Paiement echoue': 'Payment failed',
  'Votre paiement a ete valide avec succes': 'Your payment has been successfully validated',
  'Offre activee :': 'Activated plan:',
  'Credits ajoutes :': 'Credits added:',
  'Date :': 'Date:',
  'Vos credits sont disponibles des maintenant dans votre espace.': 'Your credits are now available in your space.',
  'Vous pouvez des maintenant profiter de toutes les fonctionnalites de Typix Neo.': 'You can now enjoy all Typix Neo features.',
  'Acceder a mon espace': 'Access my dashboard',
  'Le paiement n\'a pas pu etre finalise.': 'The payment could not be completed.',
  'Pas d\'inquietude, aucun montant n\'a ete preleve.': 'No worries, no amount has been charged.',
  'Vous pouvez reessayer en quelques secondes.': 'You can retry in a few seconds.',
  'Reessayer le paiement': 'Retry payment',
  'Changer de moyen de paiement': 'Change payment method',
  'Success': 'Success',
  'Cancel': 'Cancel',
  'Acheter des crédits': 'Buy credits',
  'Passer à une offre supérieure': 'Upgrade to a higher plan',
  'Fermer': 'Close',
  'Passer au forfait supérieur': 'Upgrade to a higher plan',
  'Fermer': 'Close',
  'Limite atteinte': 'Limit reached',
  'Vous avez atteint la limite autorisée par votre forfait.\n\nRechargez votre compte dès maintenant pour continuer à générer du contenu, enrichir vos textes et utiliser vos agents sans interruption.': 'You have reached the authorized limit of your plan.\n\nRecharge your account now to continue generating content, enrich your texts, and use your agents without interruption.',
  'Aucun agent disponible — veuillez d’abord ajouter un siteweb.': 'No agent available — please add a website first.',
  'Aucun agent IA trouvé. Créez votre premier agent pour commencer.': 'No AI agent found. Create your first agent to start.',
  'Accès activé !': 'Access activated!',
  'L\'accés de l\'utilisateur a bien été activé. Il rejoint votre organisation en tant qu\'un admin': 'The user\'s access has been activated. He joins your organization as an admin',
  'Vos crédits sont disponibles dès maintenant dans votre espace.': 'Your credits are now available in your space.',

  'Contenus épuisés': 'Contents exhausted',
  'Déploiement des Agents IA': 'AI agents deployment',

  'Crédits': 'Credits',
  'Quota contenus': 'Content quota',
  'Sites web': 'Websites',
  'Sites Web': 'Websites',
  'Ressources': 'Resources',
  'Utilisateurs additionnels': 'Additional users',
  'Administrateur': 'Administrator',
  'Administrateurs': 'Administrators',
  'Administrateurs inclus': 'Included administrators',
  'Ajustez vos ressources et licences utilisateurs': 'Adjust your resources and user licenses',
  'Mettre à jour mon abonnement': 'Update my subscription',
  'Paiement sécurisé via Stripe. Annulable à tout moment.': 'Secure payment via Stripe. Cancel anytime.',
  'Avant de partir, peux-tu nous dire pourquoi tu résilies ?': 'Before leaving, could you tell us why you are canceling?',
  'Trop cher par rapport à la valeur': 'Too expensive for the value provided',
  'Je n’utilise pas assez l’outil': 'I do not use the tool enough',
  'Fonctionnalités insuffisantes': 'Insufficient features',
  'Difficulté d’utilisation / UX': 'Usability / UX issues',
  'Problèmes techniques / bugs': 'Technical issues / bugs',
  'J’ai trouvé une alternative': 'I found an alternative',
  'Autre': 'Other',
  'Veuillez sélectionner un motif de résiliation.': 'Please select a cancellation reason.',
  'Impossible de traiter la résiliation pour le moment.': 'Unable to process the cancellation right now.',
  'Commentaire': 'Comment',
  'Ajoutez un commentaire (optionnel)': 'Add a comment (optional)',
  'Annuler': 'Cancel',
  'Confirmation...': 'Confirming...',
  'Confirmer la résiliation': 'Confirm cancellation',
  'Résiliation confirmée': 'Cancellation confirmed',
'La création automatique de votre agent IA est en cours.': 'The automatic creation of your AI agent is in progress.',
'La création automatique de votre agent est en cours... veuillez patienter.': 'The automatic creation of your agent is in progress... please wait.',
  'Votre résiliation a bien été prise en compte.': 'Your cancellation has been successfully processed.',
  'Nous sommes désolés de vous voir partir et espérons vous revoir bientôt ❤️': 'We are sorry to see you go and hope to see you again soon ❤️',

  // createIAbrief — Brief generator
  'Générateur de brief': 'Brief generator',
  'Visualiser mon contenu': 'View my content',
  'Sélectionner un type...': 'Select a type...',
  'Store locator': 'Store locator',
  'Étapes de création du brief': 'Brief creation steps',
  'Visualiser le contenu': 'View content',
  'Votre contenu est prêt': 'Your content is ready',
  'Votre brief est prêt': 'Your brief is ready',
  "Le contenu n'a pas encore été généré": 'Content has not been generated yet',
  "Une erreur s'est produite lors de la génération":
    'An error occurred during generation',
  "Votre brief est prêt, mais aucun texte n'a encore été rédigé à partir de celui-ci. Configurez votre génération à l'aide du formulaire pour lancer la rédaction IA.":
    'Your brief is ready, but no text has been written from it yet. Configure your generation using the form to start AI writing.',
  'La génération du contenu a échoué. Vous pouvez relancer la configuration pour réessayer.':
    'Content generation failed. You can restart the configuration to try again.',
  'Configurer la génération': 'Configure generation',
  'Relancer la génération': 'Restart generation',
  'Cette génération utilisera vos crédits IA disponibles':
    'This generation will use your available AI credits',
  'Le brief et le contenu ont été générés. Consultez le texte rédigé ou modifiez le brief si besoin.':
    'The brief and content have been generated. View the written text or edit the brief if needed.',
  "Configurez l'agent IA et lancez la rédaction pour transformer ce brief en contenu optimisé.":
    'Configure the AI agent and start writing to turn this brief into optimized content.',
  'Générer le contenu': 'Generate content',
  'Génération du brief en cours...': 'Brief generation in progress...',
  'Erreur de génération': 'Generation error',
  'Terminé': 'Completed',
  'En cours...': 'In progress...',
  'Recherche SERP': 'SERP research',
  'Analyse des premiers résultats Google': 'Analysis of top Google results',
  'Analyse des résultats Google...': 'Analyzing Google results...',
  'Analyse SERP': 'SERP analysis',
  'Structure et patterns des top contenus': 'Structure and patterns of top content',
  'Analyse de la structure SERP...': 'Analyzing SERP structure...',
  'Construction du brief': 'Brief construction',
  'Organisation du plan détaillé et structuration': 'Detailed outline organization and structuring',
  'Création du plan détaillé...': 'Creating detailed outline...',
  'Amélioration du brief': 'Brief improvement',
  'Optimisation sémantique et validation finale': 'Semantic optimization and final validation',
  'Finalisation du brief...': 'Finalizing brief...',
  'Impossible de charger le brief.': 'Unable to load the brief.',
  'Une erreur est survenue lors de la génération du brief.':
    'An error occurred while generating the brief.',
  "Veuillez sélectionner un site web depuis le dashboard avant d'enregistrer le brief.":
    'Please select a website from the dashboard before saving the brief.',
  'Le contenu du brief est vide.': 'The brief content is empty.',
  "Une erreur est survenue lors de l'enregistrement du brief.":
    'An error occurred while saving the brief.',
  'Brief modifié avec succès': 'Brief updated successfully',
  'Brief créé avec succès': 'Brief created successfully',
  'Modification...': 'Updating...',
  'Modifier le brief': 'Edit brief',
  'Étape 1 — Génération du brief': 'Step 1 — Brief generation',
  'Générez un brief optimisé à partir de votre mot-clé et de votre type de contenu.':
    'Generate an optimized brief from your keyword and content type.',
  'Étape 2 — Génération du contenu': 'Step 2 — Content generation',
  'Générez un contenu optimisé à partir du brief.':
    'Generate optimized content from the brief.',
  'Chargement du brief...': 'Loading brief...',
  'Génération...': 'Generating...',
  'Générer un nouveau brief': 'Generate a new brief',

  // UseCasePanel — Help panel UI
  "Centre d'aide": 'Help center',
  "Ouvrir le centre d'aide": 'Open help center',
  'Rechercher un tutoriel…': 'Search for a tutorial…',
  'Rechercher un tutoriel': 'Search for a tutorial',
  'Aucun résultat pour': 'No results for',
  'résultat': 'result',
  'résultats': 'results',
  'collection': 'collection',
  'collections': 'collections',
  'tutoriel': 'tutorial',
  'tutoriels': 'tutorials',
  'Table des matières': 'Table of contents',
  'Équipe Typix Néo': 'Typix Neo Team',
  'Mis à jour récemment': 'Recently updated',
  'Contacter le support →': 'Contact support →',
  'Télécharger la documentation (PDF)': 'Download documentation (PDF)',
  'Bibliothèque Vidéos tuto': 'Tutorial video library',
  'vidéos': 'videos',
  'vidéo': 'video',
  'Retour': 'Back',
  'Réduire': 'Shrink',
  'Agrandir': 'Expand',
  'Fermer': 'Close',
  'Défiler vers le bas': 'Scroll down',
  'Oui': 'Yes',
  'Non': 'No',

  // UseCasePanel — Section 1
  'Onboarding & prise en main': 'Onboarding & getting started',
  'Configurez votre espace et générez vos premiers contenus.': 'Set up your workspace and generate your first content.',
  'Ajouter votre site et générer des contenus alignés à votre marque': 'Add your website and generate brand-aligned content',
  'Configurer votre espace de travail dans Typix Néo est la première étape pour transformer votre site en véritable machine à contenu.\n\nEn quelques minutes, vous passez d\'une idée à un environnement prêt à produire du contenu cohérent, structuré et aligné avec votre marque.':
    'Setting up your workspace in Typix Neo is the first step to turning your website into a true content engine.\n\nIn just a few minutes, you go from an idea to an environment ready to produce consistent, structured content aligned with your brand.',
  'Une configuration simple, pensée pour aller vite': 'Simple setup designed for speed',
  'Tout commence en cliquant sur **"Ajouter un nouveau site web"**.': 'It all starts by clicking **"Add a new website"**.',
  'Remplissez le formulaire guidé': 'Fill in the guided form',
  'Vous accédez ensuite à un formulaire guidé, conçu pour structurer automatiquement votre espace de travail :\n\n1. **URL de votre site** — Entrez l\'adresse complète de votre site (ex : https://mondomaine.com)\n2. **Langue principale** — Définissez la langue dans laquelle vos contenus seront générés\n3. **Thématiques d\'expertise** — Indiquez vos domaines clés pour orienter la production de contenu\n4. **Équipe projet (optionnel)** — Ajoutez un ou plusieurs chefs de projet pour collaborer efficacement':
    'You then access a guided form designed to automatically structure your workspace:\n\n1. **Your site URL** — Enter your full website address (e.g. https://mydomain.com)\n2. **Primary language** — Set the language in which your content will be generated\n3. **Areas of expertise** — Indicate your key topics to guide content production\n4. **Project team (optional)** — Add one or more project managers to collaborate effectively',
  'Une fois validé, Typix Néo fait le reste': 'Once validated, Typix Neo does the rest',
  'Dès que votre site est ajouté :\n\n• Votre espace de travail est automatiquement structuré\n• Des agents de création, réécriture et traduction sont créés pour votre marque selon vos besoins\n• Le ton et la cohérence éditoriale sont alignés à votre univers\n• Chaque agent IA représente un rôle précis dans votre stratégie éditoriale, prêt à produire du contenu cohérent, scalable et aligné avec votre marque.\n\n👉 Pour en savoir plus – consultez la section « Des agents IA générés automatiquement selon votre charte éditoriale et entièrement personnalisables »':
    'As soon as your site is added:\n\n• Your workspace is automatically structured\n• Creation, rewriting and translation agents are created for your brand based on your needs\n• Tone and editorial consistency are aligned with your brand universe\n• Each AI agent represents a specific role in your editorial strategy, ready to produce consistent, scalable content aligned with your brand.\n\n👉 To learn more – see the section « AI agents automatically generated from your editorial guidelines and fully customizable »',
  'Des agents IA générés automatiquement selon votre charte éditoriale et entièrement personnalisables': 'AI agents automatically generated from your editorial guidelines and fully customizable',
  'Des agents IA créés pour votre marque, prêts à produire du contenu de qualité': 'AI agents built for your brand, ready to produce quality content',
  'Dès l\'ajout de votre site, Typix Néo ne se contente pas de configurer un espace de travail.\nIl construit pour vous une véritable équipe de production éditoriale composée d\'agents IA spécialisés.\n\nCes agents sont générés automatiquement à partir de votre site web, de votre ton de voix et de votre univers de marque.\n\n👉 Vous n\'avez pas à tout paramétrer. Votre système de contenu est déjà en train de se mettre en place.':
    'As soon as you add your site, Typix Neo doesn\'t just configure a workspace.\nIt builds a real editorial production team made up of specialized AI agents.\n\nThese agents are automatically generated from your website, tone of voice and brand universe.\n\n👉 You don\'t have to configure everything. Your content system is already taking shape.',
  'Une équipe d\'agents spécialisés, pas un seul générateur': 'A team of specialized agents, not a single generator',
  'Chaque agent a un rôle précis dans votre stratégie de contenu :\n\n• Agent de rédaction d\'articles de blog\n• Agent de fiches produits e-commerce\n• Agent Store Locator (SEO local)\n• Agent Google Business Profile (GBP)\n• Agent de traduction multilingue\n• Agents sur mesure selon vos besoins\n\n👉 Chaque agent est responsable d\'un type de contenu spécifique et produit des textes cohérents, structurés et alignés à votre marque.':
    'Each agent has a specific role in your content strategy:\n\n• Blog article writing agent\n• E-commerce product page agent\n• Store Locator agent (local SEO)\n• Google Business Profile (GBP) agent\n• Multilingual translation agent\n• Custom agents based on your needs\n\n👉 Each agent is responsible for a specific content type and produces consistent, structured texts aligned with your brand.',
  'Qu\'est-ce qu\'un agent dans Typix Néo ?': 'What is an agent in Typix Neo?',
  'Un agent est un assistant IA spécialisé, conçu pour exécuter une mission de rédaction ou de traduction selon des règles précises.\n\nIl ne génère pas du contenu "générique".\n\nIl produit du contenu **guidé, structuré et aligné à votre stratégie éditoriale.**\n\nEt surtout :\n👉 vous pouvez les modifier, les affiner ou en créer de nouveaux à tout moment.':
    'An agent is a specialized AI assistant designed to carry out a writing or translation mission according to specific rules.\n\nIt does not generate "generic" content.\n\nIt produces content that is **guided, structured and aligned with your editorial strategy.**\n\nAnd above all:\n👉 you can edit, refine or create new ones at any time.',
  'Comment personnaliser votre agent ?': 'How do you customize your agent?',
  'Chaque agent repose sur 4 blocs de configuration simples mais puissants :': 'Each agent is based on 4 simple but powerful configuration blocks:',
  '1. Informations générales': '1. General information',
  'Définissez le rôle de votre agent :\n\n• Mission (rédaction ou traduction)\n• Nom de l\'agent\n• Site web associé\n• Type de contenu à produire\n• Fonction principale (blog, produit, SEO local, etc.)':
    'Define your agent\'s role:\n\n• Mission (writing or translation)\n• Agent name\n• Associated website\n• Content type to produce\n• Main function (blog, product, local SEO, etc.)',
  '2. Ton & audience': '2. Tone & audience',
  'Donnez une identité éditoriale à votre agent :\n\n• Langue\n• Tonalité (professionnel, premium, pédagogique, etc.)\n• Cible / audience\n• Type de produit ou service\n\n👉 C\'est ici que vous transformez un générateur en **voix de marque cohérente.**':
    'Give your agent an editorial identity:\n\n• Language\n• Tone (professional, premium, educational, etc.)\n• Target / audience\n• Product or service type\n\n👉 This is where you turn a generator into a **consistent brand voice.**',
  '3. Structure & règles de rédaction': '3. Structure & writing rules',
  'Contrôlez la qualité et la forme des contenus :\n\n• Structure des textes\n• Règles éditoriales\n• Expressions interdites\n• Lexique recommandé\n• Consignes spécifiques\n\n👉 Vous imposez un cadre clair pour éviter les contenus génériques.':
    'Control content quality and form:\n\n• Text structure\n• Editorial rules\n• Forbidden expressions\n• Recommended lexicon\n• Specific instructions\n\n👉 You set a clear framework to avoid generic content.',
  '4. Base de connaissance': '4. Knowledge base',
  'Alimentez vos agents avec vos propres sources :\n\n• Sources locales : fichiers internes, documents, guidelines\n• Sources en ligne : URLs de référence et contenus inspirants\n\n👉 L\'agent écrit à partir de votre réalité, pas d\'une moyenne globale.':
    'Feed your agents with your own sources:\n\n• Local sources: internal files, documents, guidelines\n• Online sources: reference URLs and inspiring content\n\n👉 The agent writes from your reality, not from a global average.',
  'Résultat': 'Result',
  'Vous ne créez plus simplement du contenu.\n\nVous construisez :\n👉 une équipe d\'agents IA spécialisés\n👉 alignés à votre marque\n👉 capables de produire à grande échelle\n👉 sans perte de cohérence ni de qualité':
    'You\'re no longer just creating content.\n\nYou\'re building:\n👉 a team of specialized AI agents\n👉 aligned with your brand\n👉 capable of producing at scale\n👉 without losing consistency or quality',
  'Tester vos agents avec des contenus POC': 'Test your agents with POC content',
  'Choisissez votre type de contenu': 'Choose your content type',
  'Paramétrer la génération de votre contenu test': 'Configure your test content generation',
  'Entrez un mot-clé représentatif de votre activité ou un sujet précis pour générer un contenu test réaliste et aligné à votre charte éditoriale.':
    'Enter a keyword representative of your business or a specific topic to generate realistic test content aligned with your editorial guidelines.',
  'Analysez le résultat et le scoring': 'Review the result and scoring',
  'Validez ou itérez': 'Validate or iterate',
  'Rôles et permissions dans Typix': 'Roles and permissions in Typix',
  'Contenu': 'Content',
  'Fonctionnalités / Rôles': 'Features / Roles',
  'Administrateur': 'Administrator',
  'Chef de projet': 'Project manager',
  'Rédacteur': 'Writer',
  'Création de workspaces (sites web)': 'Workspace creation (websites)',
  'Gestion des membres': 'Member management',
  'Gestion des agents IA': 'AI agent management',
  'Création de projets': 'Project creation',
  'Attribution des projets': 'Project assignment',
  'Accès à tous les projets': 'Access to all projects',
  'Accès aux projets personnels / assignés': 'Access to personal / assigned projects',
  'Rédaction de contenus': 'Content writing',
  'Édition de contenus': 'Content editing',
  'Livraison de contenus': 'Content delivery',
  'Validation de contenus': 'Content validation',
  'Accès aux fonctionnalités IA': 'Access to AI features',
  'Consommation de crédits': 'Credit consumption',
  'Certaines fonctionnalités de Typix Néo consomment des crédits. Voici ce qu\'il faut savoir pour bien piloter votre consommation :\n\nLes crédits sont déduits par compte société, et le solde est partagé entre tous les utilisateurs actifs de la société : il n\'y a pas de quota individuel par utilisateur.\n\nChaque fonctionnalité consomme un nombre de crédits différent selon sa complexité, comme indiqué dans le tableau ci-dessous.':
    'Some Typix Neo features consume credits. Here is what you need to know to manage your consumption effectively:\n\nCredits are deducted per company account, and the balance is shared among all active users in the company: there is no individual quota per user.\n\nEach feature consumes a different number of credits depending on its complexity, as shown in the table below.',
  'Consommation crédit': 'Credit consumption',
  'Génération Claude + GPT': 'Generation Claude + GPT',
  'Génération Title': 'Title generation',
  'Génération Méta-description': 'Meta-description generation',
  'Génération avec GPT': 'Generation with GPT',
  'Génération avec Perplexity': 'Generation with Perplexity',
  'Création Agent IA': 'AI Agent creation',
  'Création texte avec enrichissement': 'Text creation with enrichment',
  'Traduction IA': 'AI translation',
  'Génération avec Gemini': 'Generation with Gemini',
  'Génération avec Claude': 'Generation with Claude',
  'Génération light GAP': 'Light GAP generation',
  'Requête IA dans éditeur de texte': 'AI request in text editor',
  'RAG': 'RAG',
  '👉 Ce tableau vous permet d\'anticiper votre consommation selon les fonctionnalités utilisées : par exemple, une requête via Claude coûte davantage qu\'une requête GPT ou qu\'une requête IA dans l\'éditeur de texte, car elle mobilise plus de ressources.\n\n💡 **Conseil** : si plusieurs collaborateurs de votre société utilisent Typix Néo, gardez à l\'esprit que leur usage cumulé impacte le même solde de crédits.':
    '👉 This table helps you anticipate your consumption based on the features used: for example, a request via Claude costs more than a GPT request or an AI request in the text editor, as it uses more resources.\n\n💡 **Tip**: if several collaborators in your company use Typix Neo, keep in mind that their combined usage impacts the same credit balance.',
  'Production de contenu SEO': 'SEO content production',
  'Générez des contenus optimisés et boostez votre ranking.': 'Generate optimized content and boost your rankings.',
  'Générer une couverture sémantique complète autour d\'un mot-clé': 'Generate complete semantic coverage around a keyword',
  'Comment elle est générée': 'How it is generated',
  'À quoi ça sert': 'What it is for',
  'Créer un article SEO optimisé à partir d\'un mot-clé': 'Create an SEO-optimized article from a keyword',
  'Comment est construit un article SEO optimisé': 'How an SEO-optimized article is built',
  'Bonnes pratiques pour un contenu efficace': 'Best practices for effective content',
  'Résultat attendu': 'Expected result',
  'Générer titres et meta descriptions en un clic': 'Generate titles and meta descriptions in one click',
  'Générer titres et méta-descriptions de qualité en un clic': 'Generate quality titles and meta descriptions in one click',
  'Bonnes pratiques pour des titres et méta-descriptions efficaces': 'Best practices for effective titles and meta descriptions',
  'Optimiser un contenu existant pour améliorer son ranking': 'Optimize existing content to improve its ranking',
  'Comment fonctionne l\'optimisation': 'How optimization works',
  'Choix du modèle utilisé': 'Model selection',
  'Résultat obtenu': 'Result obtained',
  'Créer un brief rédactionnel': 'Create an editorial brief',
  'Déployer directement sur WordPress': 'Deploy directly to WordPress',
  'Typix Néo permet de déployer vos contenus directement sur votre site WordPress. Voici la procédure à suivre, étape par étape.':
    'Typix Neo allows you to deploy your content directly to your WordPress site. Here is the step-by-step procedure to follow.',
  'Créer un mot de passe d\'application sur WordPress': 'Create an application password on WordPress',
  '1. Créer un mot de passe d\'application sur WordPress': '1. Create an application password on WordPress',
  'Avant de pouvoir déployer un contenu, vous devez générer des identifiants dédiés à Typix depuis votre back-office WordPress :\n\n• Connectez-vous à votre WordPress et allez dans **Utilisateurs (Users) > Profil**\n• Descendez jusqu\'à la section **Mots de passe d\'application (Application Passwords)**\n• Dans le champ **New Application Password Name**, saisissez un nom permettant de l\'identifier facilement (par exemple Typix-neo)\n• Cliquez sur **Add Application Password**\n• WordPress génère alors un mot de passe unique, affiché une seule fois à l\'écran':
    'Before you can deploy content, you must generate dedicated credentials for Typix from your WordPress back office:\n\n• Log in to your WordPress and go to **Users > Profile**\n• Scroll down to the **Application Passwords** section\n• In the **New Application Password Name** field, enter a name that makes it easy to identify (for example Typix-neo)\n• Click **Add Application Password**\n• WordPress then generates a unique password, displayed only once on screen',
  '⚠️ **Important** : copiez immédiatement ce mot de passe (bouton Copy) et conservez-le en lieu sûr. Une fois la fenêtre fermée, il ne pourra plus être récupéré — vous devrez en générer un nouveau si vous le perdez.':
    '⚠️ **Important**: copy this password immediately (Copy button) and keep it in a safe place. Once the window is closed, it cannot be retrieved — you will need to generate a new one if you lose it.',
  'Renseigner les identifiants dans Typix': 'Enter credentials in Typix',
  '2. Renseigner les identifiants dans Typix': '2. Enter credentials in Typix',
  'Lors du premier déploiement d\'un contenu vers votre site, Typix vous demande de renseigner :\n\n• votre identifiant (login) WordPress\n• le mot de passe d\'application généré à l\'étape précédente':
    'On the first deployment of content to your site, Typix asks you to enter:\n\n• your WordPress login\n• the application password generated in the previous step',
  'Une fois ces informations saisies et validées, Typix les mémorise. Vous n\'aurez donc plus besoin de les ressaisir pour les déploiements suivants sur ce même site.':
    'Once this information is entered and validated, Typix saves it. You will no longer need to re-enter it for subsequent deployments to the same site.',
  'Vérifier le slug avant publication': 'Check the slug before publishing',
  '3. Vérifier le slug avant publication': '3. Check the slug before publishing',
  'Avant de finaliser le déploiement, pensez à vérifier le slug de votre contenu.':
    'Before finalizing the deployment, remember to check your content slug.',
  '**Qu\'est-ce que le slug ?** Le slug est la partie de l\'URL qui identifie votre page ou article sur WordPress (par exemple, pour l\'URL www.monsite.fr/agence-seo, le slug est agence-seo). Il est généré automatiquement à partir du titre du contenu, mais reste modifiable.\n\nQuelques bonnes pratiques à vérifier :\n\n• le slug doit être court, lisible et cohérent avec le sujet du contenu\n• il ne doit pas contenir d\'accents, de caractères spéciaux ou de majuscules\n• les mots doivent être séparés par des tirets (-) et non des espaces ou underscores\n• il doit être unique sur le site, pour éviter les doublons d\'URL\n\n👉 Un slug propre et optimisé est important pour le SEO et pour garder une structure d\'URL cohérente sur l\'ensemble du site.':
    '**What is a slug?** The slug is the part of the URL that identifies your page or article on WordPress (for example, for the URL www.mysite.com/seo-agency, the slug is seo-agency). It is automatically generated from the content title, but remains editable.\n\nSome best practices to check:\n\n• the slug should be short, readable and consistent with the content topic\n• it should not contain accents, special characters or uppercase letters\n• words should be separated by hyphens (-) and not spaces or underscores\n• it should be unique on the site, to avoid duplicate URLs\n\n👉 A clean and optimized slug is important for SEO and to maintain a consistent URL structure across the site.',
  'Le contenu est ajouté en brouillon': 'Content is added as a draft',
  '4. Le contenu est ajouté en brouillon': '4. Content is added as a draft',
  'Une fois déployé, le contenu est ajouté sur WordPress avec le statut **Brouillon**. Il n\'est donc pas publié automatiquement : cela vous laisse la possibilité de faire une dernière relecture, d\'ajouter des images ou d\'ajuster la mise en forme directement dans l\'éditeur WordPress avant de le publier vous-même.':
    'Once deployed, the content is added to WordPress with **Draft** status. It is therefore not published automatically: this gives you the opportunity to do a final proofread, add images or adjust formatting directly in the WordPress editor before publishing it yourself.',
  'Créez un brief rédactionnel complet à partir de votre mot-clé cible et le type de contenu.':
    'Create a complete editorial brief from your target keyword and content type.',
  'Analyse SERP et intentions de recherche': 'SERP analysis and search intent',
  'Thématiques, sections et génération de contenu': 'Topics, sections and content generation',
  'Scale & performance': 'Scale & performance',
  'Automatisez, mesurez et montez en puissance.': 'Automate, measure and scale up.',
  'Contrôler la qualité de vos contenus avec le scoring Typix Néo': 'Control content quality with Typix Neo scoring',
  'Les dimensions analysées dans le scoring': 'Dimensions analyzed in scoring',
  'Une analyse comparée avec les contenus concurrents': 'Comparative analysis with competitor content',
  'Un outil d\'aide à la décision éditoriale': 'An editorial decision-making tool',
  'Automatiser la production de contenus en bulk': 'Automate bulk content production',
  'Utiliser la gestion par projet': 'Use project management',
  'Définissez le mode de rédaction': 'Set the writing mode',
  'Combiner stratégie humaine et IA pour des contenus durables': 'Combine human strategy and AI for sustainable content',
  'Collaborer efficacement avec un rédacteur grâce à Typix Néo': 'Collaborate effectively with a writer using Typix Neo',
  'Un cadre de production structuré': 'A structured production framework',
  'Votre Dashboard de suivi': 'Your tracking dashboard',
  'Top mots-clés (Top ranked)': 'Top keywords (Top ranked)',
  'Depuis le menu **"Rédaction IA"**, sélectionnez le type de contenu que vous souhaitez créer ou optimiser. Cette étape est essentielle, car elle permet à l\'IA d\'adapter sa structure, son ton et ses recommandations à votre objectif.\n\nVous pouvez choisir parmi plusieurs formats :\n\n• Contenu Web : idéal pour créer des articles de blog, pages SEO ou contenus éditoriaux complets.\n• Fiche produit : pour générer des descriptions optimisées, orientées conversion et SEO.\n• Page catégorie : structure et contenu adaptés pour valoriser une catégorie e-commerce.\n• Store Locator : créez des pages locales optimisées pour améliorer votre visibilité géographique.\n• Fiche GBP : générez des contenus optimisés pour vos fiches Google Business Profile.\n• Optimisation d\'un contenu existant : améliorez un texte déjà rédigé (SEO, lisibilité, enrichissement sémantique).\n\n💡 Astuce : choisissez le format le plus proche de votre objectif final. Cela permet à l\'IA de proposer une structure plus pertinente et d\'optimiser automatiquement certains éléments (balises, ton, intention de recherche, etc.).':
    'From the **"AI Writing"** menu, select the content type you want to create or optimize. This step is essential, as it allows the AI to adapt its structure, tone and recommendations to your objective.\n\nYou can choose from several formats:\n\n• Web Content: ideal for creating blog articles, SEO pages or complete editorial content.\n• Product page: to generate optimized descriptions focused on conversion and SEO.\n• Category page: structure and content adapted to showcase an e-commerce category.\n• Store Locator: create locally optimized pages to improve your geographic visibility.\n• GBP page: generate optimized content for your Google Business Profile listings.\n• Existing content optimization: improve an already written text (SEO, readability, semantic enrichment).\n\n💡 Tip: choose the format closest to your final objective. This allows the AI to propose a more relevant structure and automatically optimize certain elements (tags, tone, search intent, etc.).',
  'Une fois votre mot-clé défini, complétez les champs de génération pour affiner le rendu de votre contenu.\n\nAgent IA — Choisissez l\'agent qui correspond le mieux à votre besoin.\n\nModèle IA (LLM) — Sélectionnez le modèle utilisé pour la génération. Chaque modèle a ses spécificités :\n\n• GPT : Modèle polyvalent, performant pour produire des contenus structurés, fluides et adaptés au SEO. Idéal pour la majorité des cas d\'usage.\n• Claude : Modèle reconnu pour sa qualité rédactionnelle et sa compréhension fine du contexte. Particulièrement adapté aux contenus longs, détaillés et nuancés.\n• Perplexity : Modèle orienté recherche et factualité. Pertinent pour des contenus nécessitant des informations à jour, des données fiables ou une approche plus "informatif".\n• GPT + Claude : Combine les forces des deux modèles pour un rendu équilibré : structure, clarté et richesse rédactionnelle. Idéal pour des contenus stratégiques à forte valeur.\n\n💡 **Astuce** : Testez différents modèles selon vos besoins pour identifier celui qui correspond le mieux à votre usage.\n\n**Format de contenu (Preset)** — Déterminez la longueur et la structure de votre contenu (court, standard, long). Cela influence directement le niveau de détail et l\'optimisation SEO.\n\n**URL cible** — Ajoutez l\'URL d\'une page existante pour guider l\'IA dans l\'optimisation ou la réécriture du contenu.\n\n**Gap sémantique** — Renseignez des mots-clés secondaires à intégrer pour enrichir le champ lexical et améliorer la performance SEO. Vous pouvez également générer automatiquement une couverture sémantique via le bouton dédié.\n\n**Maillage interne** — Indiquez les URLs à inclure dans votre contenu pour créer des liens internes et renforcer la structure SEO de votre site.\n\n👉 Enfin, cliquez sur "Générer le contenu" pour lancer la création. Assurez-vous que vos paramètres sont bien définis pour obtenir un résultat pertinent et exploitable.':
    'Once your keyword is defined, complete the generation fields to refine your content output.\n\nAI Agent — Choose the agent that best matches your needs.\n\nAI Model (LLM) — Select the model used for generation. Each model has its own strengths:\n\n• GPT: Versatile model, effective at producing structured, fluent content adapted for SEO. Ideal for most use cases.\n• Claude: Model recognized for its writing quality and fine contextual understanding. Particularly suited for long, detailed and nuanced content.\n• Perplexity: Research and fact-oriented model. Relevant for content requiring up-to-date information, reliable data or a more informative approach.\n• GPT + Claude: Combines the strengths of both models for a balanced output: structure, clarity and editorial richness. Ideal for high-value strategic content.\n\n💡 **Tip**: Test different models based on your needs to identify the one that best suits your usage.\n\n**Content format (Preset)** — Determine the length and structure of your content (short, standard, long). This directly influences the level of detail and SEO optimization.\n\n**Target URL** — Add the URL of an existing page to guide the AI in optimizing or rewriting the content.\n\n**Semantic gap** — Enter secondary keywords to integrate to enrich the vocabulary and improve SEO performance. You can also automatically generate semantic coverage via the dedicated button.\n\n**Internal linking** — Indicate the URLs to include in your content to create internal links and strengthen your site\'s SEO structure.\n\n👉 Finally, click "Generate content" to start creation. Make sure your settings are properly defined to obtain a relevant and usable result.',
  'Une fois le contenu généré, consultez le **scoring Typix Néo** pour évaluer sa qualité globale.\n\n👉 Si le score est insuffisant, modifier le **modèle IA (LLM)** pour un rendu plus précis, plus créatif ou plus structuré ou ajustez les paramètres de génération en revenant sur la configuration de l\'agent (ton, règles, base de connaissances…), puis relancez la génération.':
    'Once the content is generated, review the **Typix Neo scoring** to assess its overall quality.\n\n👉 If the score is insufficient, change the **AI model (LLM)** for a more precise, creative or structured output, or adjust the generation settings by returning to the agent configuration (tone, rules, knowledge base…), then relaunch generation.',
  'Si le contenu généré répond à vos attentes, vous pouvez valider votre configuration : votre agent est prêt pour une utilisation à plus grande échelle.\n\n👉 Si le résultat n\'est pas satisfaisant, ajustez les paramètres et relancez un test jusqu\'à obtenir le contenu idéal.':
    'If the generated content meets your expectations, you can validate your configuration: your agent is ready for use at a larger scale.\n\n👉 If the result is not satisfactory, adjust the settings and rerun a test until you obtain the ideal content.',
  'Typix fonctionne avec un système de rôles permettant de structurer les accès et les responsabilités au sein des équipes.\n\n**Administrateur :** il a un accès complet à la plateforme. Il peut créer et gérer les workspaces(sites web), configurer et administrer les agents IA, créer et attribuer des projets, ainsi que consulter l\'ensemble des projets. Il est également responsable de la gestion des membres et peut intervenir sur tout le cycle de contenu : rédaction, édition, validation et livraison.\n\n**Chef de projet :** il dispose d\'une visibilité sur les projets qui lui sont attribués ou qu\'il a créé. Il peut gérer l\'attribution des projets avec les rédacteurs et suivre leur avancement, mais n\'a accès qu\'aux projets de son périmètre et n\'a pas accès aux fonctionnalité IA.\n\n**Rédacteur :** il a accès uniquement aux projets qui lui sont assignés. Il peut rédiger, éditer, livrer et participer à la validation des contenus dans le cadre de ses projets sans IA.':
    'Typix works with a role system to structure access and responsibilities within teams.\n\n**Administrator:** has full access to the platform. They can create and manage workspaces (websites), configure and administer AI agents, create and assign projects, and view all projects. They are also responsible for member management and can intervene across the entire content cycle: writing, editing, validation and delivery.\n\n**Project manager:** has visibility on projects assigned to them or that they created. They can manage project assignment with writers and track progress, but only has access to projects within their scope and does not have access to AI features.\n\n**Writer:** only has access to projects assigned to them. They can write, edit, deliver and participate in content validation within their projects without AI.',
  'La couverture sémantique correspond à un ensemble de mots-clés et expressions associés à votre mot-clé principal. Elle permet d\'enrichir le contenu généré en comblant les **gaps lexicaux** (termes et variantes manquants autour du sujet).':
    'Semantic coverage corresponds to a set of keywords and expressions associated with your main keyword. It enriches the generated content by filling **lexical gaps** (missing terms and variants around the topic).',
  'La couverture sémantique est construite automatiquement à partir de plusieurs sources et analyses :\n\n• Analyse du mot-clé principal : compréhension du sujet, du contexte et de l\'intention de recherche.\n• Identification des requêtes associées : extraction des expressions fréquemment recherchées autour du même thème.\n• Enrichissement lexical : ajout de synonymes, variantes, termes techniques et expressions longue traîne.\n• Détection des entités liées : intégration des outils, marques, concepts ou acteurs en lien avec le sujet.\n• Analyse des contenus existants : identification des termes souvent utilisés dans les contenus les mieux positionnés.':
    'Semantic coverage is automatically built from multiple sources and analyses:\n\n• Main keyword analysis: understanding the topic, context and search intent.\n• Associated query identification: extraction of frequently searched expressions around the same theme.\n• Lexical enrichment: adding synonyms, variants, technical terms and long-tail expressions.\n• Related entity detection: integration of tools, brands, concepts or stakeholders related to the topic.\n• Existing content analysis: identification of terms commonly used in top-ranking content.',
  'Cette couverture permet de :\n\n• enrichir naturellement le contenu généré\n• couvrir un maximum d\'intentions de recherche\n• améliorer la pertinence SEO sans sur-optimisation\n• rendre le texte plus complet et plus proche du langage utilisateur réel':
    'This coverage allows you to:\n\n• naturally enrich the generated content\n• cover a maximum of search intents\n• improve SEO relevance without over-optimization\n• make the text more complete and closer to real user language',
  'La création d\'un article SEO à partir d\'un mot-clé consiste à transformer une simple requête en un contenu éditorial structuré, informatif et optimisé pour les moteurs de recherche.\n\nL\'objectif est de produire un article qui répond à l\'intention de recherche de l\'utilisateur tout en couvrant le sujet de manière complète et naturelle.':
    'Creating an SEO article from a keyword consists of transforming a simple query into structured, informative editorial content optimized for search engines.\n\nThe goal is to produce an article that answers the user\'s search intent while covering the topic completely and naturally.',
  'Un outil de création de contenu s\'appuie généralement sur plusieurs étapes d\'analyse et de génération :\n\n• Analyse du mot-clé et de l\'intention de recherche — Le sujet est interprété pour comprendre ce que l\'utilisateur cherche réellement : comprendre un concept, comparer des solutions, obtenir des conseils ou résoudre un problème.\n• Définition d\'une structure éditoriale — Un plan d\'article est construit automatiquement avec des sections logiques (titres et sous-titres) afin de couvrir le sujet de façon claire et organisée.\n• Enrichissement sémantique du contenu — Le texte est enrichi avec des mots-clés secondaires, synonymes et expressions associées pour élargir la couverture du sujet et éviter les angles incomplets.\n• Production d\'un contenu informatif — L\'article est rédigé pour expliquer, contextualiser et répondre aux questions que se posent les utilisateurs, avec un ton pédagogique et naturel.\n• Optimisation SEO globale — Le contenu est structuré et rédigé de manière à améliorer sa lisibilité et sa compréhension par les moteurs de recherche, tout en restant fluide pour le lecteur.':
    'A content creation tool generally relies on several analysis and generation steps:\n\n• Keyword and search intent analysis — The topic is interpreted to understand what the user is really looking for: understanding a concept, comparing solutions, getting advice or solving a problem.\n• Editorial structure definition — An article outline is automatically built with logical sections (headings and subheadings) to cover the topic clearly and organized.\n• Semantic content enrichment — The text is enriched with secondary keywords, synonyms and associated expressions to broaden topic coverage and avoid incomplete angles.\n• Informative content production — The article is written to explain, contextualize and answer questions users have, with an educational and natural tone.\n• Global SEO optimization — Content is structured and written to improve readability and understanding by search engines, while remaining fluid for the reader.',
  'Pour obtenir un article de qualité, il est recommandé de :\n\n• partir d\'un mot-clé avec une intention claire\n• couvrir l\'ensemble des aspects du sujet (définition, usages, avantages, limites…)\n• enrichir le contenu avec un champ lexical varié et cohérent\n• éviter la sur-optimisation et privilégier une écriture naturelle\n• adapter le niveau de détail à l\'audience cible':
    'To obtain a quality article, it is recommended to:\n\n• start with a keyword with a clear intent\n• cover all aspects of the topic (definition, uses, benefits, limitations…)\n• enrich the content with a varied and coherent vocabulary\n• avoid over-optimization and favor natural writing\n• adapt the level of detail to the target audience',
  'Un article SEO bien construit permet d\'obtenir :\n\n• un contenu clair et structuré\n• une bonne couverture du sujet traité\n• une meilleure visibilité sur les moteurs de recherche\n• une expérience de lecture fluide et utile pour l\'utilisateur\n\n👉 En résumé, la création de contenu SEO repose sur la transformation d\'un mot-clé en un article complet, structuré et informatif, capable de répondre aux attentes des utilisateurs tout en respectant les exigences des moteurs de recherche.':
    'A well-built SEO article provides:\n\n• clear and structured content\n• good coverage of the topic\n• better visibility on search engines\n• a smooth and useful reading experience for the user\n\n👉 In summary, SEO content creation is based on transforming a keyword into a complete, structured and informative article, capable of meeting user expectations while respecting search engine requirements.',
  'La génération de titres et de méta-descriptions consiste à créer automatiquement des éléments SEO essentiels à partir d\'un contenu ou d\'un mot-clé. Ces éléments jouent un rôle clé dans la visibilité sur les moteurs de recherche et dans le taux de clic (CTR).\n\nLe titre (title tag) et la méta-description sont les premiers points de contact entre votre contenu et l\'utilisateur dans les résultats de recherche. Ils doivent donc être à la fois **optimisés pour le SEO** et **incitatifs pour l\'utilisateur.**':
    'Generating titles and meta descriptions consists of automatically creating essential SEO elements from content or a keyword. These elements play a key role in search engine visibility and click-through rate (CTR).\n\nThe title (title tag) and meta description are the first points of contact between your content and the user in search results. They must therefore be both **optimized for SEO** and **compelling for the user.**',
  'Pour maximiser l\'impact SEO et le taux de clic :\n\n• garder un titre clair, court et descriptif (≈ 50–60 caractères)\n• inclure le mot-clé principal de manière naturelle\n• éviter les formulations trop génériques ou clickbait\n• rédiger une méta-description informative et engageante (≈ 140–160 caractères)\n• mettre en avant la valeur apportée par le contenu\n\n👉 En résumé, cette étape permet de transformer un contenu en résultats de recherche optimisés, capables d\'améliorer à la fois la visibilité SEO et le taux de clic.':
    'To maximize SEO impact and click-through rate:\n\n• keep a clear, short and descriptive title (≈ 50–60 characters)\n• include the main keyword naturally\n• avoid overly generic or clickbait wording\n• write an informative and engaging meta description (≈ 140–160 characters)\n• highlight the value provided by the content\n\n👉 In summary, this step transforms content into optimized search results, capable of improving both SEO visibility and click-through rate.',
  'L\'optimisation d\'un contenu existant consiste à améliorer ses performances SEO sans en modifier l\'intention ni en réécrire entièrement la structure. L\'objectif est de renforcer sa visibilité dans les moteurs de recherche tout en conservant la base éditoriale déjà en place.\n\nCette approche permet d\'enrichir un contenu déjà publié pour le rendre plus complet, plus pertinent et mieux aligné avec les attentes des moteurs de recherche.':
    'Optimizing existing content consists of improving its SEO performance without changing its intent or entirely rewriting its structure. The goal is to strengthen its visibility in search engines while preserving the existing editorial base.\n\nThis approach enriches already published content to make it more complete, more relevant and better aligned with search engine expectations.',
  'L\'amélioration d\'un contenu existant repose sur plusieurs étapes :\n\n• Analyse du contenu actuel — Le texte est étudié pour identifier les forces (structure, informations déjà présentes) et les axes d\'amélioration (angles manquants, manque de profondeur sémantique, vocabulaire limité).\n• Prise en compte de l\'URL existante — La mention de l\'URL est indispensable afin d\'analyser précisément la page cible et de travailler directement sur son contenu réel. Cela permet de garantir une optimisation fidèle à la version publiée.\n• Application de la couverture sémantique — Le contenu est enrichi avec des mots-clés secondaires, variantes lexicales et expressions associées afin d\'élargir sa portée SEO, sans modifier le sens initial.\n• Respect du brief de l\'agent — Les consignes éditoriales (ton, objectif, angle, audience) sont intégrées pour assurer une cohérence globale du contenu.\n• Amélioration progressive du texte — Les enrichissements sont apportés de manière ciblée : ajout d\'informations, clarification de passages, renforcement du champ lexical, sans dénaturer la structure existante.':
    'Improving existing content relies on several steps:\n\n• Current content analysis — The text is studied to identify strengths (structure, existing information) and areas for improvement (missing angles, lack of semantic depth, limited vocabulary).\n• Existing URL consideration — Providing the URL is essential to precisely analyze the target page and work directly on its actual content. This ensures optimization faithful to the published version.\n• Semantic coverage application — Content is enriched with secondary keywords, lexical variants and associated expressions to broaden its SEO reach without changing the original meaning.\n• Agent brief compliance — Editorial guidelines (tone, objective, angle, audience) are integrated to ensure overall content consistency.\n• Progressive text improvement — Enhancements are made in a targeted way: adding information, clarifying passages, strengthening vocabulary, without altering the existing structure.',
  'Pour ce type d\'optimisation, le choix du modèle de langage est volontairement limité à **Claude.**\n\nCe choix s\'explique par sa capacité à :\n\n• préserver fidèlement le contenu existant\n• effectuer des modifications précises sans réécriture globale\n• intégrer des enrichissements sémantiques de manière naturelle\n• respecter la structure et l\'intention initiale de la page\n\nCette approche garantit une optimisation progressive et contrôlée, essentielle pour améliorer un contenu déjà publié.':
    'For this type of optimization, the language model choice is intentionally limited to **Claude.**\n\nThis choice is explained by its ability to:\n\n• faithfully preserve existing content\n• make precise modifications without global rewriting\n• integrate semantic enrichments naturally\n• respect the page\'s original structure and intent\n\nThis approach ensures progressive and controlled optimization, essential for improving already published content.',
  'Un contenu optimisé permet d\'obtenir :\n\n• une meilleure couverture sémantique du sujet\n• une amélioration du positionnement SEO\n• un contenu enrichi sans perte de cohérence\n• une version plus performante tout en restant fidèle à la page existante':
    'Optimized content provides:\n\n• better semantic coverage of the topic\n• improved SEO positioning\n• enriched content without loss of coherence\n• a more performant version while remaining faithful to the existing page',
  'Le générateur analyse les résultats de recherche (SERP) et les intentions de recherche associées afin de proposer une structure de contenu pertinente et compétitive.':
    'The generator analyzes search results (SERP) and associated search intent to propose a relevant and competitive content structure.',
  'Le brief inclut les thématiques à couvrir, les sections recommandées et les points clés à développer. Une fois validé, il peut être utilisé comme base pour générer un contenu cohérent, optimisé et aligné avec les attentes de votre audience.':
    'The brief includes the topics to cover, recommended sections and key points to develop. Once validated, it can be used as a basis to generate coherent, optimized content aligned with your audience\'s expectations.',
  'Le scoring Typix Néo permet d\'évaluer automatiquement la qualité SEO et éditoriale d\'un contenu avant sa publication. L\'objectif est de fournir une vision claire et actionnable de la performance potentielle d\'un texte, en identifiant ses forces et ses axes d\'amélioration.\n\nCe score sert de **référence de validation** pour garantir que chaque contenu respecte les standards SEO, tout en restant lisible et pertinent pour l\'utilisateur.':
    'Typix Neo scoring automatically evaluates the SEO and editorial quality of content before publication. The goal is to provide a clear and actionable view of a text\'s potential performance, identifying its strengths and areas for improvement.\n\nThis score serves as a **validation reference** to ensure each piece of content meets SEO standards while remaining readable and relevant for the user.',
  'Le score Typix Néo repose sur plusieurs piliers complémentaires :\n\n• Performance SEO globale — Évalue la capacité du contenu à se positionner sur les moteurs de recherche en fonction du mot-clé principal et des requêtes associées.\n• Couverture sémantique — Mesure la richesse du champ lexical utilisé : présence de mots-clés secondaires, variantes, expressions longue traîne et entités liées.\n• Pertinence éditoriale — Analyse la cohérence du contenu par rapport à l\'intention de recherche et au sujet traité.\n• Lisibilité et clarté — Évalue la fluidité du texte, la structure des phrases et la facilité de lecture pour l\'utilisateur final.\n• Structure SEO — Vérifie l\'organisation du contenu (titres, sous-titres, hiérarchie logique) et son alignement avec les bonnes pratiques éditoriales.\n• Comblement des gaps sémantiques — Identifie les éléments manquants par rapport à un contenu complet sur le sujet (angles non couverts, termes absents, questions implicites non traitées).':
    'The Typix Neo score is based on several complementary pillars:\n\n• Overall SEO performance — Evaluates the content\'s ability to rank on search engines based on the main keyword and associated queries.\n• Semantic coverage — Measures the richness of the vocabulary used: presence of secondary keywords, variants, long-tail expressions and related entities.\n• Editorial relevance — Analyzes content consistency relative to search intent and the topic covered.\n• Readability and clarity — Evaluates text fluency, sentence structure and ease of reading for the end user.\n• SEO structure — Checks content organization (headings, subheadings, logical hierarchy) and alignment with editorial best practices.\n• Semantic gap filling — Identifies missing elements compared to complete content on the topic (uncovered angles, absent terms, unaddressed implicit questions).',
  'L\'un des points clés du scoring Typix Néo est sa capacité à comparer votre contenu avec ceux déjà positionnés sur les moteurs de recherche.\n\nCette analyse concurrentielle permet de :\n\n• identifier les contenus les mieux classés sur le mot-clé cible\n• détecter les écarts de couverture sémantique entre votre contenu et ceux des concurrents\n• repérer les sujets ou angles manquants dans votre version\n• comprendre les facteurs qui expliquent le positionnement des pages concurrentes\n\nL\'objectif n\'est pas de copier les concurrents, mais de **comprendre les standards du marché** pour produire un contenu plus complet et mieux optimisé.':
    'One of the key points of Typix Neo scoring is its ability to compare your content with those already ranking on search engines.\n\nThis competitive analysis allows you to:\n\n• identify the best-ranking content on the target keyword\n• detect semantic coverage gaps between your content and competitors\'\n• spot missing topics or angles in your version\n• understand the factors explaining competitor page rankings\n\nThe goal is not to copy competitors, but to **understand market standards** to produce more complete and better optimized content.',
  'Le scoring Typix Néo permet aux équipes de :\n\n• valider rapidement la qualité d\'un contenu avant publication\n• prioriser les améliorations à apporter\n• standardiser les niveaux de qualité sur l\'ensemble des contenus produits\n• améliorer en continu les performances SEO des pages':
    'Typix Neo scoring allows teams to:\n\n• quickly validate content quality before publication\n• prioritize improvements to make\n• standardize quality levels across all produced content\n• continuously improve page SEO performance',
  'L\'automatisation de la production de contenus en bulk permet de générer un grand volume de contenus de manière structurée, rapide et cohérente, à partir de règles éditoriales définies en amont. Cette approche est particulièrement utile pour les stratégies SEO à grande échelle, les sites multi-pages ou les catalogues de contenus.\n\nElle repose sur la capacité à industrialiser la création tout en conservant un niveau de qualité constant : chaque contenu suit une logique commune (structure, ton, intention), tout en étant adapté à un mot-clé ou un sujet spécifique.\n\nCette méthode permet notamment de :\n\n• produire des dizaines ou centaines de contenus de manière homogène\n• maintenir une cohérence éditoriale sur l\'ensemble d\'un site\n• accélérer le déploiement de stratégies SEO à grande échelle\n• réduire le temps de production manuelle':
    'Bulk content production automation generates a large volume of content in a structured, fast and consistent way, based on editorial rules defined upfront. This approach is particularly useful for large-scale SEO strategies, multi-page sites or content catalogs.\n\nIt relies on the ability to industrialize creation while maintaining a constant quality level: each piece of content follows a common logic (structure, tone, intent), while being adapted to a specific keyword or topic.\n\nThis method notably allows you to:\n\n• produce dozens or hundreds of content pieces homogeneously\n• maintain editorial consistency across an entire site\n• accelerate the deployment of large-scale SEO strategies\n• reduce manual production time',
  'Pour cela, utilisez la fonction "Gestion par projet".\n\n**Comment créer un projet ?**\n\nCommencez par définir les objectifs du projet (nom, deadline, et nombre de textes).':
    'To do this, use the "Project management" feature.\n\n**How to create a project?**\n\nStart by defining the project objectives (name, deadline, and number of texts).',
  'Ensuite définissez le mode de rédaction : IA rédacteur humain ou IA + revue humaine':
    'Then set the writing mode: AI human writer or AI + human review',
  'La création de contenus performants repose aujourd\'hui sur une combinaison équilibrée entre intelligence humaine et intelligence artificielle. L\'IA permet d\'accélérer la production, d\'enrichir les contenus et de couvrir largement les champs sémantiques, tandis que l\'humain apporte la vision stratégique, la nuance et la compréhension métier.':
    'Creating high-performing content today relies on a balanced combination of human and artificial intelligence. AI accelerates production, enriches content and broadly covers semantic fields, while humans bring strategic vision, nuance and business understanding.',
  'Cette complémentarité permet de produire des contenus plus durables et plus pertinents dans le temps.\n\nDans cette approche :\n\n• l\'IA génère la structure, les idées et l\'enrichissement sémantique\n• l\'humain valide l\'angle, le positionnement et la cohérence éditoriale\n• la stratégie globale garantit l\'alignement avec les objectifs business\n\nLe résultat est un contenu à la fois optimisé pour le SEO et aligné avec une vraie logique de valeur pour l\'utilisateur.':
    'This complementarity produces more sustainable and relevant content over time.\n\nIn this approach:\n\n• AI generates structure, ideas and semantic enrichment\n• humans validate the angle, positioning and editorial consistency\n• the overall strategy ensures alignment with business objectives\n\nThe result is content that is both SEO-optimized and aligned with real user value logic.',
  'La gestion d\'une équipe éditoriale, qu\'elle soit interne ou externe, nécessite un cadre clair pour garantir la qualité, la cohérence et le respect des délais de production. L\'objectif est de fluidifier la collaboration entre les équipes et de centraliser le suivi des contenus.\n\nTypix Néo permet d\'organiser l\'ensemble du processus éditorial autour d\'un espace unique, facilitant à la fois la production, le suivi et la validation des contenus.\n\nL\'outil permet de piloter une équipe de rédacteurs de manière structurée, qu\'ils soient :\n\n• en interne (équipes marketing ou content managers)\n• en externe (freelances, agences, partenaires)\n\nChaque rédacteur peut être assigné à des contenus précis avec un cadre éditorial clair dès le départ (brief, objectif SEO, structure, mots-clés).':
    'Managing an editorial team, whether internal or external, requires a clear framework to guarantee quality, consistency and respect for production deadlines. The goal is to streamline collaboration between teams and centralize content tracking.\n\nTypix Neo organizes the entire editorial process around a single space, facilitating production, tracking and content validation.\n\nThe tool allows you to manage a team of writers in a structured way, whether they are:\n\n• internal (marketing teams or content managers)\n• external (freelancers, agencies, partners)\n\nEach writer can be assigned to specific content with a clear editorial framework from the start (brief, SEO objective, structure, keywords).',
  'La collaboration entre équipes et rédacteurs est optimisée grâce à un cadre de production structuré, permettant de fluidifier les échanges et de clarifier les attentes dès le départ.':
    'Collaboration between teams and writers is optimized through a structured production framework, streamlining exchanges and clarifying expectations from the start.',
  'Typiquement, Typix néo sert de pont entre la stratégie et l\'exécution éditoriale en fournissant :\n\n• un brief de contenu clair et exploitable\n• une structure d\'article prête à rédiger\n• une couverture sémantique pour guider l\'enrichissement\n• des recommandations SEO intégrées\n\nLe rédacteur peut ainsi se concentrer sur la qualité rédactionnelle et la valeur du contenu, sans perdre de temps sur la recherche ou la structuration.\n\nCette approche améliore :\n\n• la rapidité de production\n• la cohérence entre les contenus\n• la qualité globale des livrables\n• la communication entre équipes marketing et rédaction\n\n**Un suivi complet des livrables**\n\nTypix Néo permet de suivre en temps réel l\'avancement des contenus tout au long de la chaîne de production :\n\n• attribution des sujets aux rédacteurs\n• suivi du statut des livrables (en cours, en relecture, validé)\n• centralisation des briefs et consignes éditoriales\n• contrôle de la qualité et de la cohérence des contenus produits\n\nCela permet d\'éviter les pertes d\'information, les allers-retours inutiles et les incohérences entre les différents contenus produits.':
    'Typically, Typix Neo serves as a bridge between strategy and editorial execution by providing:\n\n• a clear and actionable content brief\n• an article structure ready to write\n• semantic coverage to guide enrichment\n• integrated SEO recommendations\n\nThe writer can thus focus on writing quality and content value, without wasting time on research or structuring.\n\nThis approach improves:\n\n• production speed\n• consistency between content pieces\n• overall deliverable quality\n• communication between marketing and editorial teams\n\n**Complete deliverable tracking**\n\nTypix Neo tracks content progress in real time throughout the production chain:\n\n• topic assignment to writers\n• deliverable status tracking (in progress, under review, validated)\n• centralization of briefs and editorial guidelines\n• quality and consistency control of produced content\n\nThis avoids information loss, unnecessary back-and-forth and inconsistencies between different produced content.',
  'Le dashboard est la page d\'accueil de votre projet Typix Néo. Il vous donne, en un coup d\'œil, une vue complète sur l\'avancement de votre production de contenu et sur les performances de votre site.':
    'The dashboard is the home page of your Typix Neo project. It gives you, at a glance, a complete view of your content production progress and your site\'s performance.',
  'Ce widget affiche la répartition de vos projets selon leur statut de validation, sous forme de donut chart. Le chiffre au centre indique le nombre total de projets en cours de suivi.\n\nLes statuts possibles sont :\n\n• **Non attribué** — le projet n\'a pas encore été assigné\n• **En cours** — le projet est en cours de traitement\n• **En retard** — le délai prévu est dépassé\n• **Validé** — le projet a été validé':
    'This widget displays the breakdown of your projects by validation status as a donut chart. The number in the center indicates the total number of projects being tracked.\n\nPossible statuses are:\n\n• **Unassigned** — the project has not yet been assigned\n• **In progress** — the project is being processed\n• **Delayed** — the expected deadline has passed\n• **Validated** — the project has been validated',
  '👉 C\'est votre vue d\'ensemble pour identifier rapidement où concentrer vos efforts (par exemple, s\'il y a beaucoup de projets en retard).':
    '👉 This is your overview to quickly identify where to focus your efforts (for example, if there are many delayed projects).',
  'Ce bloc affiche le nombre total de contenus associés au site sélectionné, ainsi que leur répartition par statut sous forme de barres :\n\n• **Brouillon** — le contenu est en cours de rédaction\n• **Livré** — le contenu a été livré par le rédacteur\n• **Révision** — le contenu est en cours de relecture/correction\n• **Validé** — le contenu a été validé\n• **Publié** — le contenu est en ligne':
    'This block displays the total number of content pieces associated with the selected site, along with their breakdown by status as bars:\n\n• **Draft** — the content is being written\n• **Delivered** — the content has been delivered by the writer\n• **Review** — the content is being proofread/corrected\n• **Validated** — the content has been validated\n• **Published** — the content is live',
  '👉 Ce widget permet de suivre la production de contenu à un instant donné, tous statuts confondus.':
    '👉 This widget lets you track content production at a given moment, across all statuses.',
  'Cette liste affiche les contenus les plus récemment créés pour le site sélectionné : le titre du texte, son statut (Brouillon, Livré, En ligne, Validé...) et sa date d\'ajout.':
    'This list displays the most recently created content for the selected site: the text title, its status (Draft, Delivered, Live, Validated...) and its date added.',
  '👉 Cliquez sur un texte pour accéder directement à sa fiche détaillée. Le lien « Voir plus » vous permet de consulter l\'historique complet.':
    '👉 Click on a text to go directly to its detail page. The "See more" link lets you view the full history.',
  'Ce tableau liste les derniers projets lancés sur le site sélectionné, avec leur statut (Non attribué, En cours, En retard, Validé...) et leur date de création.':
    'This table lists the latest projects launched on the selected site, with their status (Unassigned, In progress, Delayed, Validated...) and creation date.',
  '👉 Cliquez sur un projet pour consulter son avancement ainsi que tous les contenus qui lui sont associés.':
    '👉 Click on a project to view its progress and all associated content.',
  'Ce graphique en barres présente, mois par mois, le nombre de textes publiés sur l\'année sélectionnée (un sélecteur d\'année est disponible en haut à droite).':
    'This bar chart shows, month by month, the number of texts published for the selected year (a year selector is available in the top right).',
  '👉 Il permet de visualiser votre rythme de production et de déploiement de contenu dans le temps, et de repérer les mois les plus ou moins actifs.':
    '👉 It lets you visualize your content production and deployment pace over time, and identify the most or least active months.',
  'Ce graphique de courbes suit l\'évolution de plusieurs indicateurs issus de la Search Console :\n\n• Sessions\n• Conversions\n• Clics\n• Impressions\n\nPlusieurs options permettent d\'affiner l\'analyse :\n\n• **Y-1** : active la comparaison avec la même période de l\'année précédente (affichée en pointillés)\n• **Période** (ex. « 30 days ») : sélectionne la plage de dates à afficher\n• **Appareils** (« All devices ») : filtre les données par type d\'appareil (mobile, desktop...)':
    'This line chart tracks the evolution of several indicators from Search Console:\n\n• Sessions\n• Conversions\n• Clicks\n• Impressions\n\nSeveral options let you refine the analysis:\n\n• **Y-1**: enables comparison with the same period of the previous year (shown as dashed lines)\n• **Period** (e.g. "30 days"): selects the date range to display\n• **Devices** ("All devices"): filters data by device type (mobile, desktop...)',
  '⚠️ **Important** : pour que cette analyse fonctionne, vous devez au préalable ajouter l\'adresse e-mail de Typix à votre Google Search Console. Sans cette étape, le graphique reste vide. Une fois l\'accès accordé, l\'évolution de votre trafic se met à jour automatiquement dans le dashboard.':
    '⚠️ **Important**: for this analysis to work, you must first add Typix\'s email address to your Google Search Console. Without this step, the chart remains empty. Once access is granted, your traffic trends update automatically in the dashboard.',
  'Ce tableau met en avant les 5 mots-clés les plus performants de votre site, toujours basés sur les données de la Search Console. Pour chaque mot-clé, vous retrouvez :\n\n• sa position actuelle\n• le nombre de clics sur la période\n• le nombre de clics (Y-1), pour comparer avec l\'année précédente':
    'This table highlights the 5 best-performing keywords on your site, based on Search Console data. For each keyword, you will find:\n\n• its current position\n• the number of clicks for the period\n• the number of clicks (Y-1), to compare with the previous year',
  '👉 Cela vous permet de suivre l\'évolution de vos mots-clés stratégiques et de repérer rapidement les gains ou pertes de visibilité.\n\n💡 **À noter** : l\'ensemble des widgets du dashboard (contenus, projets, textes publiés, top mots-clés) est calculé pour le site actuellement sélectionné. Si vous gérez plusieurs sites, pensez à vérifier quel site est actif en haut de la page avant d\'interpréter les chiffres.':
    '👉 This lets you track the evolution of your strategic keywords and quickly spot visibility gains or losses.\n\n💡 **Note**: all dashboard widgets (content, projects, published texts, top keywords) are calculated for the currently selected site. If you manage multiple sites, remember to check which site is active at the top of the page before interpreting the figures.',
'En révision': 'Under review',
'Révision': 'Review',

  // WordPress deploy modal
  'Connexion WordPress': 'WordPress login',
  'Déployer sur WordPress': 'Deploy to WordPress',
  'Connectez-vous à votre compte WordPress pour déployer le contenu.':
    'Log in to your WordPress account to deploy the content.',
  'Nom d’utilisateur': 'Username',
  'Mot de passe d’application': 'Application password',
  'Connexion...': 'Logging in...',
  'Mot-clé': 'Keyword',
  Slug: 'Slug',
  'ex: mon-article-seo': 'e.g. my-seo-article',
  'Généré automatiquement à partir du mot-clé, modifiable si besoin.':
    'Automatically generated from the keyword, editable if needed.',
  'wpDeploy.slugTooltip':
    'The slug is the part of the URL that identifies your page (e.g. your-site.com/slug). It should be short, lowercase, without accents or special characters, with hyphens between words.',
  'wpDeploy.usernamePlaceholder': 'e.g. Typix-neo',
  'wpDeploy.passwordPlaceholder': 'XXXX XXXX XXXX XXXX XXXX XXXX',
  'wpDeploy.help.title': 'Where can I find my username and password?',
  'wpDeploy.help.step1':
    'Log in to WordPress and go to <strong>Users > Profile</strong>.',
  'wpDeploy.help.step2':
    'Scroll down to the <strong>Application Passwords</strong> section.',
  'wpDeploy.help.step3':
    'In the <strong>New Application Password Name</strong> field, enter a recognizable name (e.g. Typix-neo): this is your username.',
  'wpDeploy.help.step4':
    'Click <strong>Add Application Password</strong>.',
  'wpDeploy.help.step5':
    'WordPress generates a unique password, shown only once.',
  'wpDeploy.help.step6':
    'Enter the name and password in the fields above.',
  'wpDeploy.help.warning':
    '<strong>Important:</strong> copy the password immediately (Copy button) and keep it in a safe place. Once the window is closed, it cannot be retrieved — you will need to generate a new one.',
  'Déploiement...': 'Deploying...',
  Déployer: 'Deploy',
  'Le slug est invalide.': 'The slug is invalid.',
  'Le mot-clé est obligatoire.': 'The keyword is required.',
  'Le contenu est obligatoire.': 'The content is required.',
  'Identifiant du texte manquant.': 'Text ID is missing.',
  'Le slug est obligatoire.': 'The slug is required.',
  'Erreur lors du déploiement sur WordPress.': 'Error deploying to WordPress.',
  'Veuillez renseigner le nom d’utilisateur et le mot de passe.':
    'Please enter your username and application password.',
  'Identifiants WordPress invalides. Veuillez réessayer.':
    'Invalid WordPress credentials. Please try again.',
  'Déployer via WordPress': 'Deploy via WordPress',
  'Texte mis en ligne avec succès': 'Text successfully published online',
  'Erreur lors de la mise en ligne': 'Error publishing online',
  'Identifiant du site web manquant.': 'Website ID is missing.',
  'Le site web n\'existe pas.': 'The website does not exist.',
  'Identifiants WordPress n\'existe pas. Veuillez réessayer.':
    'WordPress credentials do not exist. Please try again.',
  'Les informations de connexion ne sont pas correctes.':
    'The login information is incorrect.',

  'scoreTooltip.seo':
    "Measures the technical and semantic optimization of your content for search engines: keyword richness, tags, internal linking, and potential over-optimization.",
  'scoreTooltip.ux':
    'Evaluates reading comfort and content structure for users: sentence readability, text length, and format variety.',
  'scoreTooltip.semanticResult':
    'Coverage rate of words and phrases expected by Google on this topic. Each term shows its occurrence count / recommended count. A high score indicates complete, relevant content.\n format : keyword1 (2), keyword2 (1), keyword3 (1).',
  'scoreTooltip.tags':
    'Checks optimization of your structural tags (Hn): presence, length, and integration of the main keyword.',
  'scoreTooltip.keywordStuffing':
    'Detects over-optimization: excessive keyword repetition can be penalized by Google. A high score means density remains natural.',
  'scoreTooltip.internalLinking':
    'Evaluates internal links from the page to other pages on your site. Good internal linking helps Google crawl your site and strengthens page SEO.',
  'scoreTooltip.readability':
    'Measures how easy your content is to read: sentence length, paragraph density, and vocabulary level.',
  'scoreTooltip.structure':
    'Analyzes organization and volume of your content: text length, reading time, and format diversity.',
'Rédiger une description YouTube': 'Write a YouTube description',
'Créez une description pour un mot-clé spécifique': 'Create a description for a specific keyword',
'Rédiger un lot de descriptions': 'Write a batch of descriptions',
'Générez plusieurs descriptions en important un fichier Excel': 'Generate multiple descriptions by importing an Excel file',
'Description existante': 'Existing description',
'Collez la description existante de la vidéo.': 'Paste the existing description of the video.',
'Retranscription': 'Retranscription',
'Collez la retranscription de la vidéo.': 'Paste the retranscription of the video.',
'Crédits insuffisants pour générer automatiquement un agent.':'Insufficient credits to automatically generate an agent.',
'Crédits disponibles':'Available Credits',
'Crédits insuffisants':'Insufficient Credits',
'Ajouter des crédits':'Add Credits',
'Recharger des crédits': 'Top up credits',
"Vous ne disposez pas d'un nombre de crédits suffisant pour générer ce contenu.\nRetrouvez ci-dessous le détail de la consommation de crédits.":
  "You do not have enough credits to generate this content.\nSee below for credit consumption details.",
'Pays':'country',
'Sélectionnez un pays':'Select a country',
'Aucune des adresses e-mail des administrateurs Typix n\'est associée à un compte Search AI.':'None of the Typix administrator email addresses are associated with a Search AI account.',
"Le site web est introuvable dans Search AI. Vérifiez que l'URL configurée dans Typix est identique à celle déclarée dans Search AI, puis réessayez.":"The website could not be found in Search AI. Verify that the URL configured in Typix matches the one registered in Search AI, then try again.",
'Étape 1 — Recherche de mots-clés':'Step 1 — Keyword search',
'Saisissez un mot-clé ou une thématique. Nous générons automatiquement les mots-clés les plus pertinents à travailler, classés selon leur potentiel SEO et leur volume de recherche.':'Enter a keyword or theme. We automatically generate the most relevant keywords to work on, ranked according to their SEO potential and search volume.',
'Mot clé ou Thématique':'Keyword or theme',
'ex. assurance emprunteur':'e.g. mortgage insurance',
'Recherche de mots-clés':'Keyword search',
'Sauvegarder':'Save',
'Sauvegardé ✓':'Saved ✓',
'Sauvegarde…':'Saving…',
'Analyse…':'Analyzing…',
'Étape précédente':'Previous step',
'Étape 3 — Rédaction IA':'Step 3 — AI Writing',
'Générez le contenu final pour « {{keyword}} ».':'Generate the final content for “{{keyword}}”.',
'Mot-clé retenu :':'Selected keyword:',
'Vous pouvez fermer cette page :':'You can close this page:',
'un e-mail vous sera envoyé':'an email will be sent to you',
'dès que les résultats seront prêts. Vous pourrez alors consulter les mots-clés et choisir le plus pertinent.':'as soon as the results are ready. You can then review the keywords and choose the most relevant one.',
'{{count}} idées pour « {{query}} »':'{{count}} ideas for “{{query}}”',
'{{count}} coché(s)':'{{count}} selected',
'{{min}} à {{max}}':'{{min}} to {{max}}',
'affichées':'shown',
'Exporter CSV':'Export CSV',
'Filtres':'Filters',
'Appliquer':'Apply',
'Actifs':'Active',
'Volume de recherche':'Search volume',
'recherches / mois':'searches / month',
"Score d'intérêt":'Interest score',
'Retirer le filtre de volume':'Remove volume filter',
'Retirer le filtre de score':'Remove score filter',
'Retirer le filtre de production':'Remove production filter',
'Aucun mot-clé ne correspond aux filtres.':'No keywords match the filters.',
'résultats par page':'results per page',
'sur':'of',
'Choisi':'Selected',
'Choisir':'Select',
'Réessayer':'Retry',
'Analyse en cours…':'Analysis in progress…',
'Cette analyse peut prendre plusieurs minutes selon la thématique.':'This analysis may take several minutes depending on the theme.',
'Analyse terminée — un e-mail de notification vous a été envoyé. Choisissez ci-dessous le mot-clé le plus pertinent.':'Analysis complete — a notification email has been sent to you. Choose the most relevant keyword below.',
'Générer un brief':'Generate a brief',
'Ouvrez le générateur pour rédiger le contenu à partir du mot-clé retenu.':'Open the generator to write content from the selected keyword.',
'Sélectionnez au moins un mot-clé à sauvegarder.':'Select at least one keyword to save.',
'La sauvegarde a échoué. Réessayez.':'Saving failed. Please try again.',
'Veuillez sélectionner un site web avant de lancer l’analyse.':'Please select a website before starting the analysis.',
'Impossible de déterminer le compte (company name).':'Unable to determine the account (company name).',
'Impossible de déterminer l’e-mail de l’exécuteur.':'Unable to determine the executor email.',
'La langue du site web est introuvable. Vérifiez la configuration du site.':'The website language could not be found. Check the website configuration.',
'Le pays du site web est introuvable. Vérifiez la configuration du site.':'The website country could not be found. Check the website configuration.',
'Erreur – à relancer':'Error – please retry',
'La génération a échoué. Réessayez.':'Generation failed. Please try again.',
'Veuillez sélectionner un site web avant de continuer.':'Please select a website before continuing.',
'Toutes':'All',
'Hybride':'Hybrid',
'Humain':'Human',
'Diminuer':'Decrease',
'Min':'Min',
'Production':'Production',
'Volume':'Volume',
'Rédaction Premium':'Premium writing',
'Choisir un projet Premium':'Choose a Premium project',
'Valider le projet':'Confirm project',
'Découverte mots-clés':'Keyword discovery',
  };
